export const language = {
  pt: {
    title_link_candidates: "Vincular candidatos",
    title_link_proctors: "Vincular fiscais",
    description_link_proctors: "Vincule um ou mais fiscais ao processo",
    description_link_graders: "Vincule um ou mais corretores ao processo",
    label_images: "Imagens",
    label_messages: "Mensagens",
    description_candidate_messages: "Veja as mensagens enviadas durante o processo.",
    action_import_csv: "Importar CSV",
    action_add_graders: "Adicionar corretores",
    action_add_grader: "Adicionar corretor",
    action_add_image: "Adicionar imagem",
    action_add_video: "Adicionar vídeo",
    action_delete_image: "Excluir imagem",
    action_delete_video: "Excluir vídeo",
    action_delete_candidate: "Excluir candidato",
    action_delete_proctor: "Excluir fiscal",
    action_delete_grader: "Excluir corretor",
    action_delete_room: "Excluir sala",
    action_unlink_grader: "Desvincular corretor",
    action_select_all_rooms: "Selecionar todas as salas",
    action_previous: "Anterior",
    loading_generating_zip: "Gerando ZIP...",
    loading_saving_proctors: "Salvando fiscais",
    loading_saving_graders: "Salvando corretores",
    label_first_login: "Primeiro acesso",
    status_never_accessed: "Nunca acessou o sistema",
    status_in_progress: "Em andamento",
    status_execution_error: "Erro na execução",
    title_add_proctors_to_process: "Adicionar fiscais ao processo",
    title_add_graders_to_process: "Adicionar corretores ao processo",
    label_candidate_cpf: "CPF do candidato",
    option_generate_random_email: "Gerar e-mail aleatório quando não for encontrado na planilha",
    label_birth_date_iso: "Data de nascimento (AAAA-MM-DD)",
    label_cpf_digits_only: "CPF (somente números)",
    label_photo_link: "Link da foto",
    candidate_documents: "Documentos",
    candidate_documents_description: "Veja as fotos de perfil, aceite e documentos enviados pelo candidato.",
    candidate_profile_photo: "Foto do usuário",
    candidate_acceptance_photo: "Foto tirada na tela de aceite",
    candidate_document_photos: "Fotos dos documentos",
    candidate_document_composition: "Composição enviada",
    no_candidate_documents: "Nenhum documento encontrado",
    no_candidate_documents_description: "As fotos do candidato e dos documentos aparecerão aqui quando estiverem disponíveis.",
    face_photo: "Foto do rosto",
    document_photo: "Foto do documento",
    sent_composition: "Composição enviada",
    click_to_zoom: "Clique para ampliar e usar zoom",
    zoom_in: "Aumentar zoom",
    zoom_out: "Diminuir zoom",
    label_error: "Erro",
    label_success: "Sucesso",
    error_loading_modules: "Erro ao carregar módulos",
    error_saving_settings: "Erro ao salvar configurações",
    error_processing_server_response: "Erro ao processar a resposta do servidor",
    error_connecting_server: "Erro ao conectar com o servidor",
    error_saving_permissions_prefix: "Erro ao salvar",
    error_saving_permissions_middle: "de",
    error_saving_permissions_suffix: "permissões",
    settings_student_portal: "Portal do estudante",
    settings_student_portal_description: "Portal onde o estudante acessa informações sobre o processo seletivo.",
    settings_notice: "Edital",
    settings_results: "Resultados",
    action_view_exam_external: "Visualizar a prova externamente",
    description_exam_results: "Acompanhe os resultados desta prova.",
    description_show_exam_page: "Aqui você consegue ver as questões e resultados da prova.",
    description_show_essay_page: "Aqui você consegue ver os textos de apoio e resultados da redação.",
    settings_appeals: "Recursos",
    settings_question_appeals: "Recursos de questões",
    label_time_milliseconds: "Tempo em milissegundos (ms)",
    action_release_reset_candidate_access: "Liberar ou redefinir o acesso do candidato",
    title_system_logs: "Logs do sistema",
    label_from: "De",
    label_indexes: "Índices",
    label_photos_without_face: "Fotos sem rosto detectado",
    process_summary_title: "Resumo da configuração",
    summary_identification: "Identificação",
    summary_not_informed: "Não informado",
    summary_not_informed_yet: "Ainda não informado",
    summary_filled_feminine: "Preenchida",
    summary_filled_plural: "Preenchidas",
    summary_pending_plural: "Pendentes",
    summary_not_applicable: "Não se aplica",
    summary_modality: "Modalidade",
    summary_assessment: "Avaliação",
    summary_online: "Online",
    summary_in_person: "Presencial",
    summary_oral_assessment: "Avaliação oral",
    summary_simulation: "Simulado",
    summary_compatibility: "Compatibilidade",
    summary_block_exam: "Prova em blocos",
    summary_schedule: "Cronograma",
    summary_start: "Início",
    summary_time: "Tempo",
    summary_restricted_after_access: "Restrito após acesso",
    summary_total_time: "Tempo total",
    summary_restricted_duration: "Duração restrita",
    summary_time_per_question: "Tempo por questão",
    summary_required: "Obrigatório",
    summary_required_feminine: "Obrigatória",
    summary_disabled: "Desabilitado",
    summary_disabled_feminine: "Desabilitada",
    summary_optional: "Opcional",
    summary_proctoring: "Fiscalização",
    summary_chat: "Chat",
    summary_chat_before_exam: "Chat antes da prova",
    summary_full_screen: "Tela cheia",
    summary_multiple_monitors: "Múltiplos monitores",
    summary_blocked_plural: "Bloqueados",
    summary_allowed_plural: "Permitidos",
    summary_share_screen: "Compartilhar tela",
    summary_external_camera: "Câmera externa",
    summary_not_required: "Não exigido",
    summary_validations: "Validações",
    summary_face_microphone: "Face e microfone",
    summary_on_entry: "Na entrada",
    summary_document: "Documento",
    summary_release_button: "Botão de liberação",
    summary_minutes_before: "min antes",
    summary_periodic_validation: "Validação periódica",
    summary_without_recognition: "sem reconhecimento",
    summary_candidate_resources: "Recursos do candidato",
    summary_mobile: "Mobile",
    summary_allowed: "Permitido",
    summary_blocked: "Bloqueado",
    summary_pauses: "Pausas",
    summary_allowed_feminine_plural: "Permitidas",
    summary_blocked_feminine_plural: "Bloqueadas",
    summary_scratchpad: "Rascunho",
    summary_available: "Disponível",
    summary_unavailable: "Indisponível",
    summary_access: "Acesso",
    summary_time_restriction: "Restrição por horário",
    summary_active_feminine: "Ativa",
    summary_no_restriction: "Sem restrição",
    summary_allowed_period: "Período permitido",
    summary_until: "até",
    summary_define_time: "Defina o tempo",
    unit_minutes: "minutos",
    unit_minutes_short: "min",
    unit_seconds_short: "s",
    form_exam_time: "Tempo de prova",
    form_candidate_total_time: "Candidato pode usar o tempo total de prova",
    form_candidate_restricted_time: "Candidato tem um tempo de prova restrito a partir do acesso",
    form_exam_time_minutes: "Tempo de prova em minutos",
    form_chat_type: "Tipo de chat",
    form_capture_candidate_image_every: "Gerar imagem do candidato a cada",
    form_block_multiple_extended_screens: "Bloquear uso de duas ou mais telas estendidas?",
    form_share_screen_simulation: "Obrigar compartilhamento de tela para o teste? (Simula a gravação de tela para uso em uma prova real)",
    form_record_candidate_screen: "Gravar a tela do candidato? (Exige compartilhamento de tela)",
    form_face_microphone_entry_question: "Usar inteligência artificial para validação facial e de microfone na entrada?",
    form_required_external_camera: "Exigir câmera externa?",
    description_required_external_camera: "Quando habilitado, o candidato só poderá acessar e continuar a avaliação com a câmera externa conectada pelo celular.",
    form_record_before_exam_question: "Gravar candidato antes de iniciar a prova?",
    description_record_before_exam: "Quando habilitado, a gravação começa antes do horário de início e continua durante validações, regras e avaliação.",
    form_record_before_exam_minutes: "Tempo antes do início para começar a gravação (em minutos, máximo 30)",
    summary_record_before_exam: "Gravação antes do início",
    summary_from_exam_start: "A partir do início da prova",
    form_face_microphone_periodic_question: "Realizar validação facial e de microfone caso não sejam detectados durante a avaliação?",
    form_access_interval_start_date: "Data inicial do intervalo",
    error_exam_start_after_access_start: "A data e hora de início da prova devem ser posteriores ao início do intervalo de acesso.",
    error_exam_end_after_access_end: "A data e hora de encerramento da prova devem ser posteriores ao fim do intervalo de acesso.",
    entity_process: "processo",
    entity_vacancy_position: "vaga/cargo",
    option_proctoring_video_image_stream: "Salvar vídeo e imagem - Com transmissão em tempo real",
    option_proctoring_image_stream: "Salvar apenas imagem - Com transmissão em tempo real",
    option_proctoring_logs_only: "Salvar apenas registros - Sem transmissão",
    option_simulation_camera_audio: "Testar compartilhamento de câmera e áudio",
    option_simulation_no_camera_audio: "Não compartilhar câmera e áudio",
    option_chat_both: "Ambos enviam mensagem",
    option_chat_proctor_only: "Apenas o fiscal envia mensagem",
    option_chat_none: "Ninguém envia mensagem",
    option_seconds_30: "30 segundos",
    option_seconds_15: "15 segundos",
    label_not_calculated: "Não calculada",
    title_blocks: "Blocos",
    description_manage_blocks: "Organize avaliações e intervalos",
    label_block: "Bloco",
    label_without_block: "Sem bloco",
    question_document_validation_on_entry: "Validar o documento do candidato na entrada?",
    description_document_validation_on_entry: "Compara o documento apresentado com uma foto do candidato. A validação também poderá ser realizada pelo fiscal.",
    description_simulation_without_blocks: "Processos do tipo simulado não podem utilizar blocos.",
    blocks_operation_error: "Não foi possível concluir a operação.",
    blocks_load_error: "Erro ao carregar os blocos.",
    blocks_save_error: "Erro ao salvar o bloco.",
    blocks_delete_error: "Erro ao excluir o bloco.",
    blocks_delete_confirm_prefix: "Excluir",
    blocks_delete_confirm_suffix: "As avaliações ficarão sem bloco.",
    blocks_interval_description: "Intervalo entre avaliações.",
    blocks_none_linked: "Nenhuma avaliação vinculada a este bloco.",
    blocks_selection_title: "Avaliações deste bloco",
    blocks_transfer_description: "Ao selecionar uma avaliação vinculada a outro bloco, ela será transferida para este.",
    empty_no_items_registered: "Nenhum item cadastrado.",
    empty_state_default_description: "Revise os filtros ou cadastre um novo item para continuar.",
    empty_state_selection_description: "Adicione itens para continuar.",
    label_currently_in: "Atualmente em:",
    blocks_module_title: "Blocos da avaliação",
    blocks_module_description: "Organize cadernos, redações, questionários e intervalos na ordem de execução.",
    blocks_linked_evaluations: "Avaliações vinculadas",
    blocks_empty_description: "Adicione o primeiro bloco para organizar o tempo e as avaliações deste processo.",
    label_order: "Ordem",
    action_add_block: "Adicionar bloco",
    action_new_test: "Nova prova",
    blocks_remaining_prefix: "Ainda faltam",
    blocks_remaining_suffix: "para completar o tempo da prova.",
    blocks_exceeded_prefix: "Os blocos excedem o tempo da prova em",
    label_exam_total: "Total da prova",
    label_distributed: "Distribuído",
    label_type: "Tipo",
    block_type_assessment: "Bloco de prova",
    block_type_interval: "Bloco de intervalo",
    label_block_type: "Tipo de bloco",
    block_interval_no_evaluations: "Blocos de intervalo não possuem provas, redações ou questionários vinculados.",
    placeholder_interval_name: "Ex.: Intervalo",
    placeholder_block_name: "Ex.: Bloco 1",
    label_duration_minutes: "Duração em minutos",
    label_optional: "Opcional",
    label_exam_total_time: "Tempo total da prova",
    label_already_distributed: "Já distribuído",
    label_exceeded_time: "Tempo excedido",
    label_remaining_after_save: "Restará após salvar",
    empty_no_blocks: "Nenhum bloco cadastrado.",
    action_edit_block: "Editar bloco",
    action_delete_block: "Excluir bloco",
    block_select_label: "Bloco da avaliação",
    block_select_option: "Selecione o bloco",
    block_select_empty: "Cadastre primeiro um bloco de avaliação no módulo Blocos.",
    empty_no_user_found: "Nenhum(a) usuário encontrado(a).",
    label_training_completed: "Concluiu o treinamento",
    label_proctor: "Fiscal",
    portal_candidate: "Portal do Candidato",
    portal_evaluator: "Portal do Avaliador",
    portal_proctor: "Portal do Fiscal",
    portal_grader: "Portal do Corretor",
    placeholder_search_evaluator: "Pesquisar pelo nome do avaliador",
    empty_register_first_vacancy: "Cadastre a primeira vaga/cargo deste processo.",
    empty_register_first_process: "Cadastre o primeiro processo desta instituição.",
    empty_no_vacancy_found: "Nenhum(a) vaga/cargo encontrado(a)",
    empty_no_process_found: "Nenhum(a) processo encontrado(a)",
    placeholder_csv_proctors: "Arquivo .csv contendo os dados dos fiscais",
    placeholder_search_candidate_name_cpf: "Pesquisar candidato pelo nome ou CPF",
    placeholder_search_grader: "Pesquisar corretor pelo nome",
    option_all: "Todos",
    question_objective: "Questão objetiva",
    difficulty_easy: "Fácil",
    difficulty_medium: "Médio",
    difficulty_hard: "Difícil",
    education_elementary: "Ensino Fundamental",
    education_high_school: "Ensino Médio",
    education_higher: "Ensino Superior",
    label_alternative_order: "Ordem das alternativas",
    label_correct: "Correta",
    label_answered_feminine: "Respondida",
    label_response: "Resposta",
    label_total: "Total",
    label_registered_order_alternatives: "Alternativas na ordem de cadastro",
    label_random_order_alternatives: "Alternativas em ordem aleatória",
    placeholder_select_one_or_more_rooms: "Selecione uma ou mais salas",
    option_all_feminine: "Todas",
    label_alternative_count: "Quantidade de alternativas",
    question_discursive: "Questão dissertativa",
    question_plural: "questões",
    question_singular: "questão",
    question_group_prefix: "Conjunto de questões",
    question_group_objective_common: "Conjuntos de questões objetivas com enunciado em comum",
    select_education_level: "Selecione um nível de escolaridade",
    select_difficulty_level: "Selecione um nível de dificuldade",
    option_select: "Selecione uma opção",
    label_main_theme: "Tema principal",
    placeholder_main_theme_example: "Ex: Revolução Francesa",
    label_context: "Contexto",
    label_answer: "Resposta",
    loading_question_generating_response: "Gerando resposta, por favor aguarde...",
    loading_question_thinking: "Estou pensando na melhor resposta...",
    loading_question_processing: "Processando sua pergunta, aguarde um momento...",
    loading_question_calculating: "Calculando a resposta perfeita para você...",
    error_statement_required: "O campo Enunciado é obrigatório",
    error_alternative_a_required: "O campo Alternativa a) é obrigatório",
    error_alternative_b_required: "O campo Alternativa b) é obrigatório",
    error_alternative_c_required: "O campo Alternativa c) é obrigatório",
    error_alternative_d_required: "O campo Alternativa d) é obrigatório",
    error_alternative_e_required: "O campo Alternativa e) é obrigatório",
    error_server_response: "Erro ao pegar resposta do servidor",
    error_server_connection: "Erro ao pegar resposta do servidor. Você está conectado à internet?",
    status_denied: "Indeferido",
    status_granted: "Deferido",
    status_not_answered: "Não respondido",
    status_answered: "Respondido",
    status_not_finished: "Não finalizado",
    status_not_started: "Não iniciado",
    status_not_corrected: "Não corrigida",
    status_corrected: "Corrigida",
    status_absent: "Ausente",
    status_present: "Presente",
    status_valid: "Válida",
    status_annulled: "Anulada",
    status_pending: "Pendente",
    status_rejected: "Recusado",
    status_approved: "Aprovado",
    status_rejected_plural: "Desaprovadas",
    status_approved_plural: "Aprovadas",
    action_generating_csv: "Gerando CSV...",
    label_request_made: "Pedido realizado",
    label_deadline_datetime: "Data e hora limite",
    label_general_statement: "Enunciado geral",
    label_alternatives: "Alternativas",
    label_generated_at: "Gerada em",
    label_education_level: "Escolaridade",
    label_difficulty: "Dificuldade",
    label_question_type_modal: "Tipo",
    tooltip_rewind_5_seconds: "Retroceder 5 segundos",
    tooltip_forward_5_seconds: "Avançar 5 segundos",
    action_select_videos: "Selecionar vídeos",
    label_total_video_size: "Tamanho total dos vídeos:",
    filter_all_videos: "Todos",
    filter_webcam_videos: "Vídeos Webcam",
    filter_external_camera_videos: "Vídeos Câmera Externa",
    label_cpf: "CPF",
    label_registration_number: "Inscrição",
    summary_yes: "Sim",
    summary_no: "Não",
    video_ai_title: "Eventos de IA dos vídeos",
    video_ai_report_title: "Eventos IA",
    video_ai_report_description: "Revise eventos detectados automaticamente nos vídeos dos candidatos.",
    video_ai_candidate_module_description: "Veja eventos detectados por IA nos vídeos deste candidato.",
    video_ai_process_description: "Candidatos com eventos detectados, ordenados por maior quantidade de eventos.",
    video_ai_candidate_description: "Eventos detectados nos vídeos do candidato",
    video_ai_analysis_status: "Status da análise",
    video_ai_generate_events: "Gerar eventos",
    video_ai_download_excel: "Baixar Excel",
    video_ai_search_candidate: "Pesquisar candidato",
    video_ai_search_event: "Pesquisar evento",
    video_ai_search_candidate_placeholder: "Nome, CPF ou inscrição",
    video_ai_search_event_placeholder: "Evento, origem ou site",
    video_ai_source: "Origem",
    video_ai_all_sources: "Todas as origens",
    video_ai_source_camera: "Câmera normal",
    video_ai_source_external_camera: "Câmera ambiente",
    video_ai_source_screen: "Tela",
    video_ai_event_type: "Tipo de evento",
    video_ai_all_event_types: "Todos os tipos",
    video_ai_sort: "Ordenação",
    video_ai_sort_date_asc: "Data crescente",
    video_ai_sort_date_desc: "Data decrescente",
    video_ai_sort_events_desc: "Mais eventos",
    video_ai_sort_events_asc: "Menos eventos",
    video_ai_snapshot: "Imagem",
    video_ai_events: "Eventos IA",
    video_ai_points: "Pontos",
    video_ai_detected_site: "Site detectado",
    video_ai_clip: "Trecho",
    video_ai_datetime: "Data/hora",
    video_ai_view_details: "Ver detalhes",
    video_ai_view_candidate_events: "Ver eventos do candidato",
    video_ai_video_events: "Eventos IA do vídeo",
    video_ai_video: "Vídeo",
    video_ai_video_unavailable: "Vídeo não disponível",
    video_ai_image_unavailable: "Imagem não disponível",
    video_ai_first_event_datetime: "Data/hora do primeiro evento",
    video_ai_analyzed_clip: "Trecho analisado",
    video_ai_analysis_source: "Origem da análise",
    video_ai_video_available: "Vídeo disponível",
    video_ai_total_events: "Total de eventos",
    video_ai_detected_events: "Eventos detectados",
    video_ai_snapshot_second: "Segundo da imagem",
    video_ai_event_id: "ID do evento",
    video_ai_no_events_found: "Nenhum evento encontrado",
    video_ai_adjust_search: "Tente ajustar a busca.",
    video_ai_generate_to_view: "Gere os eventos para visualizar as análises dos vídeos.",
    video_ai_job_success: "Concluída",
    video_ai_job_not_generated: "Não gerada",
    action_generate_report: "Gerar relatório",
    action_select_all: "Selecionar tudo",
    action_clear_selection: "Limpar seleção",
    label_value: "Valor",
    trust_options_title: "Itens considerados na confiabilidade",
    trust_options_description: "Desmarque os itens que não devem entrar no cálculo antes de gerar o relatório.",
    trust_metrics_title: "Métricas de fiscalização",
    trust_ai_events_title: "Eventos de IA detalhados",
    trust_report_not_generated: "O relatório de confiabilidade ainda não foi gerado",
    trust_points_by_metric: "Pontos por métrica",
    trust_video_ai_points: "Pontos IA de vídeo",
    trust_ai_points_details: "Pontos IA detalhados",
    trust_events_count: "evento(s)",
    trust_metric_reported_actions: "Ações reportadas",
    trust_metric_face_recognition_average: "Média do reconhecimento facial",
    trust_metric_periodic_face_validations: "Validações faciais periódicas",
    trust_metric_photos_without_face: "Fotos sem rosto detectado",
    trust_metric_fiscal_release_requests: "Pedidos de liberação para o fiscal",
    trust_metric_screen_exits: "Saídas de tela",
    trust_metric_screen_exit_time: "Tempo de saída da tela de prova",
    trust_metric_videos_without_face: "Vídeos sem rosto",
    trust_metric_multiple_faces_videos: "Múltiplos rostos nos vídeos",
    trust_metric_identical_ips: "IPs idênticos",
    video_ai_event_ai_assistant: "Assistente de IA",
    video_ai_event_book: "Livro",
    video_ai_event_calculator: "Calculadora",
    video_ai_event_cell_phone: "Celular",
    video_ai_event_earbuds: "Fones intra-auriculares",
    video_ai_event_email: "E-mail",
    video_ai_event_external_website: "Site externo",
    video_ai_event_headphones: "Fones de ouvido",
    video_ai_event_laptop: "Notebook",
    video_ai_event_long_hair: "Cabelo longo",
    video_ai_event_browser_new_tab: "Nova aba do navegador",
    video_ai_event_looking_away: "Olhar desviado",
    video_ai_event_messaging: "Mensagens",
    video_ai_event_multiple_faces: "Múltiplos rostos",
    video_ai_event_multiple_people: "Múltiplas pessoas",
    video_ai_event_multiple_speakers: "Múltiplas vozes",
    video_ai_event_no_face: "Sem pessoas",
    video_ai_event_no_person: "Sem pessoas",
    video_ai_event_paper: "Papel",
    video_ai_event_person: "Pessoa",
    video_ai_event_reference: "Referência",
    video_ai_event_search_engine: "Buscador",
    video_ai_event_second_speaker: "Segunda voz",
    video_ai_event_speech: "Fala detectada",
    video_ai_event_start_menu: "Menu iniciar",
    video_ai_event_smartwatch: "Relógio inteligente",
    video_ai_event_tv_monitor: "TV/Monitor",
    video_ai_event_unknown: "Evento não classificado",
    video_ai_severity_info: "Informativo",
    video_ai_severity_low: "Baixo",
    video_ai_severity_medium: "Médio",
    video_ai_severity_high: "Alto",
    video_ai_severity_critical: "Crítico",
    label_docx_file: "Arquivo .docx",
    label_selected_file: "Arquivo selecionado:",
    action_choose_files: "Escolher arquivos",
    label_no_file_selected: "Nenhum(a) arquivo selecionado",
    label_files_selected: "arquivos selecionados",
    action_clear: "Limpar",
    action_clear_file: "Limpar arquivo",
    action_clear_all_files: "Limpar todos os arquivos",
    label_upload_pdf: "Upload do PDF",
    label_pdf_viewer: "Visualizador de PDF",
    error_server_response: "Erro ao pegar resposta do servidor. Você está conectado à internet?",
    error_select_video_or_pdf: "Para salvar você deve selecionar um vídeo ou arquivo PDF",
    upload_success: "Upload realizado com sucesso",
    error_fetch_server_response_short: "Erro ao pegar resposta do servidor",
    error_fetch_contents: "Erro ao buscar conteúdos",
    error_delete_content: "Erro ao excluir conteúdo",
    error_edit_question: "Erro ao editar a questão",
    alert_delete_content_unavailable: "Ao deletar este conteúdo, ele não estará mais disponível no sistema",
    label_type_colon: "Tipo: ",
    label_created_at_colon: "Criado em: ",
    action_delete_question: "Deletar questão",
    action_saving: "Salvando",
    action_saving_resource: "Salvando recurso",
    description_create_institutions: "Cadastre as instituições do seu sistema",
    description_create_processes: "Cadastre os processos do seu sistema",
    description_manage_institutions: "Gerencie instituições, páginas e responsáveis cadastrados na plataforma.",
    description_manage_processes: "Gerencie processos, páginas e responsáveis cadastrados na plataforma.",
    description_edit_institution: "Edite uma instituição do seu sistema",
    description_edit_process: "Edite um processo do seu sistema",
    label_logo: "Logo",
    label_of_your_system: "do seu sistema",
    label_of_vacancy_position: "da vaga/cargo",
    placeholder_url_path: "Caminho da URL",
    placeholder_search_by_name: "Pesquisar pelo nome",
    title_process: "Processos",
    title_institution: "Instituições",
    title_demand: "Demandas",
    title_demands: "Lista de Demandas",
    title_subjects: "Disciplinas",
    title_questions: "Questões",
    title_question_list: "Lista de Questões",
    title_modules: "Módulos",
    title_system_modules: "Módulos do sistema",
    title_team_members: "Lista de membros da equipe",
    title_authors: "Lista de Elaboradores",
    title_assignments: "Atribuições",
    title_question_assignments: "Atribuições de Questões",
    title_essay_assignments: "Atribuições de Redações",
    title_create_layout: "Cadastrar diagramação",
    title_edit_layout: "Editar diagramação",
    title_create_question: "Cadastrar Questão",
    title_edit_question: "Editar Questão",
    title_quick_reports: "Relatórios rápidos",
    report_exam_results_by_institution: "Resultados das provas",
    report_all_candidates_general: "Relatório geral dos candidatos",
    report_candidates_world_map: "Mapa dos candidatos",
    title_candidates_geolocation_map: "Mapa de geolocalização dos candidatos",
    desc_candidates_geolocation_map: "Pontos e regiões de calor com base no primeiro IP registrado na tela de avaliação em andamento.",
    title_quick_summary: "Resumo rápido",
    title_latest_updates: "Últimas atualizações",
    title_realtime_indicators: "Indicadores em tempo real",
    title_choose_module_manage: "Escolha um módulo para gerenciar",
    title_create_demand: "Cadastrar Demanda",
    title_edit_demand: "Editar Demanda",
    title_reliability: "Confiabilidade",
    title_general_logs: "Logs gerais",
    title_exam_and_template: "Prova e padrão",
    title_print_settings: "Configurações de impressão",
    role_administrator: "Administrador",
    role_user: "Usuário",
    authors: "Elaboradores",
    disciplines: "Disciplinas",
    action_back: "Voltar",
    action_next: "Próximo",
    action_add: "Adicionar",
    action_new_institution: "Nova instituição",
    action_new_process: "Novo processo",
    action_view_institution: "Ver instituição",
    action_view_process: "Ver processo",
    action_add_question: "Adicionar questão",
    action_add_questions_docx: "Adicionar questões via .docx",
    docx_add_exam_questions_title: "Adicionar questões via DOCX",
    docx_select_file: "Selecionar arquivo DOCX",
    docx_file_by_disciplines_description: "Arquivo DOCX separado por disciplinas",
    docx_error_process_file: "Erro ao processar arquivo.",
    docx_error_import_questions: "Erro ao importar questões.",
    docx_status_creating_bank: "Criando seu banco de questões...",
    docx_error_poll_job: "Erro ao consultar processamento. Você está conectado à internet?",
    docx_error_select_file: "Selecione um arquivo DOCX para continuar.",
    docx_status_uploading_file: "Carregando arquivo...",
    docx_error_upload_file: "Erro ao enviar arquivo. Você está conectado à internet?",
    docx_instructions_intro: "Use o modelo correspondente ao tipo da prova. O nome de cada disciplina deve ficar em uma linha própria, em caixa alta, com as questões abaixo.",
    docx_objective_questions_title: "Questões objetivas",
    docx_objective_question_number_instruction: "Use \"Questão N)\" no início de cada questão.",
    docx_objective_alternatives_instruction: "Use alternativas a), b), c), d) e e) em sequência.",
    docx_correct_alternative_instruction: "Marque a alternativa correta com marca-texto ou cor de fundo diferente de branco.",
    docx_group_questions_title: "Questões em conjunto",
    docx_group_header_instruction: "Informe o texto-base com o intervalo: \"Texto-base para as questões X a Y:\".",
    docx_group_children_instruction: "As subquestões do conjunto devem ser objetivas.",
    docx_group_added_instruction: "O conjunto será adicionado como uma questão única na tabela da prova.",
    docx_discursive_questions_title: "Questões dissertativas",
    docx_discursive_question_number_instruction: "Use \"Questão N)\" no início de cada questão.",
    docx_discursive_no_alternatives_instruction: "Não inclua alternativas; o tipo é identificado pela ausência de a), b), c), etc.",
    docx_metadata_optional_instruction: "Palavras-chave, Dificuldade e Escolaridade são opcionais.",
    docx_download_objective_model: "Baixar modelo - objetivas",
    docx_download_objective_group_model: "Baixar modelo - objetivas e conjunto",
    docx_download_discursive_model: "Baixar modelo - dissertativas",
    docx_error_only_objective_for_discursive_exam: "Este arquivo possui apenas questões objetivas. Altere o tipo da prova ou envie um arquivo com questões dissertativas.",
    docx_error_only_discursive_for_objective_exam: "Este arquivo possui apenas questões dissertativas. Altere o tipo da prova ou envie um arquivo com questões objetivas.",
    docx_warning_objective_ignored_discursive_exam: "Questões objetivas foram ignoradas porque a prova está configurada como dissertativa.",
    docx_warning_discursive_ignored_objective_exam: "Questões dissertativas foram ignoradas porque a prova está configurada como objetiva.",
    action_add_edit_assignments: "Adicionar/Editar atribuições",
    action_add_edit_essay_assignments: "Adicionar/Editar atribuições de redações",
    action_save: "Salvar",
    action_save_demand: "Salvar demanda",
    action_save_member: "Salvar membro",
    action_save_author: "Salvar elaborador",
    action_save_assignments: "Salvar atribuições",
    action_close: "Fechar",
    action_delete: "Excluir",
    action_download_report: "Baixar relatório",
    action_download_csv: "Baixar CSV",
    action_generating_map: "Gerando mapa...",
    action_view_map: "Ver mapa",
    action_access: "Acessar",
    action_view_terms: "Visualizar termos da instituição",
    action_include_keyword: "Incluir palavra chave",
    label_name: "Nome",
    label_email: "E-mail",
    label_candidates: "candidatos",
    label_actions: "Ações",
    label_status: "Status",
    label_auditor_status: "Status Auditor",
    label_registered_by: "Cadastrado por",
    label_created_at: "Criado em",
    label_created_at_feminine: "Criada em",
    label_pages_published: "Páginas publicadas",
    label_sort_by: "Ordenar por",
    label_showing: "Mostrando",
    label_to: "a",
    label_of: "de",
    sort_recent: "Mais recentes",
    sort_oldest: "Mais antigas",
    sort_name: "Nome",
    unit_page_singular: "página",
    unit_page_plural: "páginas",
    empty_no_institutions_registered: "Nenhuma instituição cadastrada",
    empty_no_processes_registered: "Nenhum processo cadastrado",
    empty_register_first_institution: "Cadastre a primeira instituição para começar.",
    label_updated_at: "Atualizado em",
    label_description: "Descrição",
    label_descriptive: "Descritivo",
    label_demand_description: "Descrição da demanda",
    label_keywords: "Palavras chave",
    label_subject: "Disciplina",
    label_statement: "Enunciado",
    label_correct_alternative: "Alternativa correta",
    label_question_type: "Tipo de questão",
    label_objective_question_count: "Número de questões objetivas",
    label_essay_question_count: "Número de questões dissertativas",
    label_selected_authors: "Elaboradores selecionados",
    label_user_type: "Tipo de Usuário",
    label_password_confirmation: "Confirmação de senha",
    label_end_time: "Horário de encerramento",
    label_start: "Início",
    label_end: "Encerramento",
    label_rules: "Regras",
    label_terms: "Termos",
    label_proctoring_type: "Tipo de Fiscalização",
    label_save_videos_streaming: "Salvar Vídeos e Imagens com Streaming em tempo real",
    label_module: "Módulo",
    label_module_status: "Status",
    label_present_count: "Nº de Presentes",
    role_collaborator: "Colaborador",
    role_viewer: "Visualizador",
    answer_yes: "Sim",
    answer_no: "Não",
    value_not_specified: "Não especificado",
    status_active: "Ativo",
    status_inactive: "Inativo",
    status_maintenance: "Em manutenção",
    status_finished: "Finalizado",
    desc_demands: "Aqui são listados todas as demandas do seu sistema",
    desc_subject_questions: "Aqui são listados todas as questões da disciplina",
    desc_system_modules: "Aqui são listados todos os módulos do sistema e seus respectivos status",
    desc_team_members: "Aqui são listados todos os membros da sua equipe no sistema",
    desc_team_member_create: "Cadastre os membros de sua equipe no sistema",
    desc_authors: "Aqui são listados todos os elaboradores do seu sistema",
    desc_question_resources: "Aqui são listados todos os recursos de questões do seu sistema",
    desc_process_dashboard_data: "Dados gerais consolidados do dashboard deste processo.",
    desc_institution_dashboard_data: "Dados gerais consolidados do dashboard desta instituição.",
    desc_quick_reports_process: "Acesse os relatórios de acompanhamento deste processo.",
    desc_question_assignment: "Adicione/Edite atribuições de questões à demanda",
    desc_essay_assignment: "Adicione/Edite atribuições de redações à demanda",
    desc_select_authors_subject: "Selecione um ou mais elaboradores que deverão cadastrar questões dessa disciplina e escreva um descritivo",
    desc_selected_essay_authors: "Selecione um elaborador que devera criar uma ou mais redações nessa demanda",
    desc_status_active: "Ativo: Módulo operando em sua função normal",
    desc_status_maintenance: "Em manutenção: Módulo está passando por alguma atualização, podendo sofrer instabilidade",
    desc_status_inactive: "Inativo: Módulo está desligado",
    empty_no_answers_found: "Nenhum(a) resposta encontrada",
    empty_no_records_found: "Nenhum(a) registro encontrado",
    empty_no_geolocation_found: "Nenhuma geolocalização encontrada para os candidatos presentes.",
    empty_no_questions_found: "Nenhum(a) questão encontrada",
    empty_no_questions_found_dot: "Nenhum(a) questão encontrada.",
    empty_no_subject_found_term: "Nenhum(a) disciplina encontrada com este termo",
    empty_no_subject_added: "Nenhum(a) disciplina adicionada",
    empty_no_assignments_found: "Nenhum(a) atribuição encontrada",
    empty_no_demand_found: "Nenhum(a) demanda encontrada",
    empty_no_author_selected: "Nenhum(a) elaborador selecionado",
    empty_no_author_found: "Nenhum(a) elaborador encontrado",
    empty_no_member_found: "Nenhum(a) membro encontrado",
    empty_no_candidate_found: "Nenhum(a) candidato encontrado",
    empty_no_proctor_found: "Nenhum(a) fiscal encontrado",
    empty_no_grader_found: "Nenhum(a) corretor encontrado",
    empty_no_evaluator_found: "Nenhum(a) avaliador encontrado",
    empty_no_room_found: "Nenhum(a) sala encontrada",
    empty_no_layout_found: "Nenhum(a) diagramação encontrada",
    empty_no_test_found: "Nenhum(a) prova encontrada",
    placeholder_search_demand: "Pesquisar pelo nome da demanda",
    placeholder_search_subject: "Pesquisar pelo nome da categoria",
    placeholder_search_subject_add: "Pesquise uma disciplina para adicionar a esta demanda",
    placeholder_search_question: "Pesquisar pelo enunciado da questão",
    placeholder_search_room: "Pesquisar pelo número da sala",
    placeholder_search_author_subject: "Pesquisar pelo nome do elaborador ou disciplina",
    placeholder_password: "Digite sua senha",
    validation_required_field: "O campo {field} é obrigatório",
    feedback_essay_correction_started: "Correção iniciada com sucesso!",
    feedback_essay_correction_error: "Erro ao corrigir a redação. Tente novamente mais tarde.",
    loading_essay_analyzing: "Analisando sua redação...",
    loading_essay_identifying_points: "Identificando pontos principais...",
    loading_essay_evaluating_argument: "Avaliando argumentação...",
    loading_essay_checking_coherence: "Verificando coerência textual...",
    loading_essay_applying_criteria: "Aplicando critérios de correção...",
    loading_essay_generating_feedback: "Gerando feedback personalizado...",
    loading_almost_done: "Quase lá...",
    back: "Voltar",
    chooseOption: "Escolha uma opção para visualizar",
    enter: "Entrar",
    entering: "Entrando...",
    email: "E-mail",
    english: "Inglês",
    language: "Idioma",
    light: "Claro",
    dark: "Escuro",
    loginHeroTitle: "Gestão de avaliações com clareza e segurança.",
    loginHeroSubtitle: "Organize processos, candidatos, fiscais e resultados em um painel moderno e direto.",
    myProfile: "Meu perfil",
    password: "Senha",
    passwordPlaceholder: "Digite sua senha",
    portuguese: "Português",
    signInSubtitle: "Acesse sua conta para continuar.",
    adminEnvironment: "Ambiente administrativo",
    spanish: "Espanhol",
    system: "Sistema",
    theme: "Tema",
    viewing: "Visualizando",
    welcome: "Bem-vindo",
    logout: "Sair",
    adminOrganizer: "Admin Organizadora",
    analyses: "Análises",
    analysisObjects: "Objetos de análise",
    assignments: "Atribuições",
    assessmentBank: "Banca de Questões",
    candidateConflicts: "Conflitos de candidatos",
    candidates: "Candidatos",
    chooseProcessReports: "Escolha um processo para visualizar os relatórios",
    content: "Conteúdo",
    contents: "Conteúdos",
    dashboard: "Dashboard",
    demands: "Demandas",
    diagramLayouts: "Diagramações",
    details: "Detalhes",
    edit: "Editar",
    essays: "Redações",
    evaluators: "Avaliadores",
    evaluateQuestions: "Avaliar questões",
    graders: "Corretores",
    importExisting: "Importar existente",
    interviews: "Entrevistas",
    link: "Vincular",
    linkedQuestionnaires: "Questionários vinculados",
    members: "Membros",
    module: "Módulo",
    modules: "Módulos",
    organization: "Instituição",
    organizations: "Instituições",
    openProcessReports: "Abrir relatórios deste processo.",
    organizers: "Organizadoras",
    process: "Processo",
    processes: "Processos",
    proctors: "Fiscais",
    publicQuestions: "Questões Públicas",
    question: "Questão",
    questionBank: "Banco de questões",
    questionResources: "Recursos de Questão",
    questions: "Questões",
    questionnaires: "Questionários",
    register: "Cadastro",
    registerAction: "Cadastrar",
    resources: "Recursos",
    rooms: "Salas",
    systemModules: "Módulos do sistema",
    teamMembers: "Membros da equipe",
    tests: "Provas",
    training: "Treinamento",
    trainingManagement: "Gestão de treinamentos",
    trainings: "Treinamentos",
    vacancies: "Vagas/Cargos",
    vacancy: "Vaga/Cargo",
    bulk_process_add_button: "Adicionar processo em lote",
    bulk_process_title: "Adicionar processos em lote",
    bulk_process_names_label: "Nomes dos processos",
    bulk_vacancy_add_button: "Adicionar vaga em lote",
    bulk_vacancy_title: "Adicionar vagas em lote",
    bulk_vacancy_names_section: "Nomes",
    bulk_vacancy_config_section: "Configurações",
    bulk_vacancy_jobs_section: "Execuções",
    bulk_vacancy_names_count: "nomes prontos para criação",
    bulk_vacancy_names_label: "Nomes das vagas",
    bulk_vacancy_names_description: "Digite os nomes separados por vírgula. Ao inserir uma vírgula, cada nome vira uma badge; clique na badge para editar ou no x para excluir. Se importar uma planilha CSV, será usada a primeira coluna de cada linha.",
    bulk_vacancy_names_placeholder: "Digite um nome e use vírgula para adicionar",
    bulk_vacancy_name_edit_hint: "Clique para editar este nome",
    bulk_vacancy_name_remove: "Remover nome",
    bulk_vacancy_file_label: "Importar nomes por planilha",
    bulk_vacancy_file_description: "Use um arquivo .csv ou .txt com os nomes na primeira coluna.",
    bulk_vacancy_file_read_error: "Não foi possível ler o arquivo enviado.",
    bulk_vacancy_names_required: "Informe pelo menos um nome de vaga.",
    bulk_vacancy_config_required: "Preencha descrição e regras antes de salvar.",
    bulk_vacancy_save_button: "Criar :entity em lote",
    bulk_vacancy_basic_data: "Dados básicos",
    bulk_vacancy_dates: "Datas",
    bulk_vacancy_start_time: "Horário de início",
    bulk_vacancy_restrict_access: "Restringir período de acesso",
    bulk_vacancy_access_start: "Início do acesso",
    bulk_vacancy_access_end: "Fim do acesso",
    bulk_vacancy_exam_settings: "Configurações da avaliação",
    bulk_vacancy_mobile: "Processo mobile",
    bulk_vacancy_exam_per_time: "Uma questão por tempo",
    bulk_vacancy_need_pause: "Permitir pausa",
    bulk_vacancy_has_blocks: "Usar blocos",
    bulk_vacancy_time_type: "Tempo da avaliação",
    bulk_vacancy_time_all: "Usar todo o período configurado",
    bulk_vacancy_time_restrict: "Restringir tempo em minutos",
    bulk_vacancy_exam_time_minutes: "Tempo em minutos",
    bulk_vacancy_proctoring: "Fiscalização",
    bulk_vacancy_proctoring_type: "Tipo de fiscalização",
    bulk_vacancy_proctoring_all: "Salvar vídeo e imagem com streaming",
    bulk_vacancy_proctoring_image: "Salvar apenas imagem com streaming",
    bulk_vacancy_proctoring_none: "Salvar apenas logs, sem streaming",
    bulk_vacancy_chat_type: "Permissão de chat",
    bulk_vacancy_chat_all: "Candidato e fiscal podem enviar mensagem",
    bulk_vacancy_chat_fiscal_to_student: "Apenas o fiscal envia mensagem",
    bulk_vacancy_chat_none: "Chat desativado",
    bulk_vacancy_screen_sharing: "Exigir compartilhamento de tela",
    bulk_vacancy_screen_extended_restrict: "Bloquear tela estendida",
    bulk_vacancy_recording_before: "Começar gravação antes do início em minutos",
    bulk_vacancy_draft: "Permitir rascunho",
    bulk_vacancy_validations: "Validações",
    bulk_vacancy_face_validation: "Validação facial na entrada",
    bulk_vacancy_document_validation: "Validação de documento",
    bulk_vacancy_chat_time: "Intervalo do chat em minutos",
    bulk_vacancy_request_time: "Intervalo de solicitações em minutos",
    bulk_vacancy_periodic_validation_time: "Intervalo da validação periódica em minutos",
    action_refresh: "Atualizar",
    legacy_acoes_rapidas: "Ações rápidas",
    legacy_adicionar_avaliadores: "Adicionar Avaliadores",
    legacy_adicionar_corretor: "Adicionar Corretor",
    legacy_adicionar_fiscais: "Adicionar Fiscais",
    legacy_adicionar_disciplina: "Adicionar disciplina",
    legacy_adicionar_elemento: "Adicionar elemento",
    legacy_adicionar_elaborador: "Adicionar elaborador",
    legacy_adicionar_membro: "Adicionar membro",
    legacy_adicionar_novo_modulo: "Adicionar novo módulo",
    legacy_adicionar_novo_conteudo: "Adicionar novo conteúdo",
    legacy_adicionar_nova_questao: "Adicionar nova questão",
    legacy_adicionar_questionario: "Adicionar questionário",
    legacy_adicionar_pergunta: "Adicionar pergunta",
    legacy_adicionar_cursos: "Adicionar cursos",
    legacy_adicionar_usuarios: "Adicionar usuários",
    legacy_adicionar_professores: "Adicionar professores",
    legacy_adicionar_candidato: "Adicionar Candidato",
    legacy_adicionar_fiscal: "Adicionar Fiscal",
    legacy_adicionar_avaliador: "Adicionar Avaliador",
    legacy_adicionar_treinamento: "Adicionar Treinamento",
    legacy_adicionar_organizadora: "Adicionar organizadora",
    legacy_adicionar_novo_treinamento: "Adicionar novo treinamento",
    legacy_adicionar_entrevista: "Adicionar Entrevista",
    legacy_adicionar_topico: "Adicionar tópico",
    legacy_adicionar_criterio: "Adicionar critério",
    legacy_adicionar_alternativa_de_escolha_multipla: "Adicionar alternativa de escolha múltipla",
    legacy_adicionar_campo_de_texto: "Adicionar campo de texto",
    legacy_adicionar_prefiro_nao_informar: "Adicionar \"Prefiro não informar\"",
    legacy_adicionar_perguntas: "Adicionar Perguntas",
    legacy_adicionar_formula: "Adicionar Fórmula",
    legacy_adicionar_nova_demanda: "Adicionar nova demanda",
    legacy_adicionar_novo_recurso: "Adicionar novo recurso",
    legacy_adicionar_comentario: "Adicionar Comentário",
    legacy_adicionar_zip_rar_de_redacoes_externas: "Adicionar .zip/.rar de redações externas",
    legacy_adicionar_zip_rar_de_redacoes_existentes: "Adicionar .zip/.rar de redações existentes",
    legacy_adicionar_editar_atribuicoes: "Adicionar/Editar Atribuições",
    legacy_analise_de_objetos: "Análise de objetos",
    legacy_analise_facial: "Análise facial",
    legacy_analise_movimentacoes_capturadas_pela_camera: "Analise movimentações capturadas pela câmera.",
    legacy_movimento_facial: "Movimento facial",
    legacy_acompanhe_indicadores_de_confianca_dos_candidatos: "Acompanhe indicadores de confiança dos candidatos.",
    legacy_acompanhe_acessos_e_eventos_registrados_durante_a_avaliacao: "Acompanhe acessos e eventos registrados durante a avaliação.",
    legacy_acesse_as_versoes_nominais_dos_candidatos: "Acesse as versões nominais dos candidatos.",
    legacy_acesse_as_imagens_capturadas: "Acesse as imagens capturadas.",
    legacy_aqui_sao_listados_todas_as_questoes_pendentes_do_seu_sistema: "Aqui são listados todas as questões pendentes do seu sistema",
    legacy_aqui_sao_listados_todas_as_organizadoras_do_seu_sistema: "Aqui são listados todas as organizadoras do seu sistema",
    legacy_aqui_sao_listados_todos_os_treinamentos_do_seu_sistema: "Aqui são listados todos os treinamentos do seu sistema",
    legacy_aqui_sao_listados_todos_os_conteudos_vinculados_com_o_modulo: "Aqui são listados todos os conteúdos vinculados com o módulo",
    legacy_aqui_sao_listados_todos_os_modulos_vinculados_com_o_treinamento: "Aqui são listados todos os módulos vinculados com o treinamento",
    legacy_aqui_sao_listados_todas_as_suas_disciplinas: "Aqui são listados todas as suas disciplinas",
    legacy_aqui_sao_listados_todos_os_seus_questionarios: "Aqui são listados todos os seus questionários",
    legacy_aqui_sao_listados_todas_as_questoes_do_conteudo: "Aqui são listados todas as questões do conteúdo",
    legacy_aqui_sao_listados_todos_os_conteudos_do_seu_sistema: "Aqui são listados todos os conteúdos do seu sistema",
    legacy_ao_deletar_este_modulo_ele_nao_estara_mais_disponivel_no_sistema: "Ao deletar este módulo, ele não estará mais disponível no sistema",
    legacy_atencao: "Atenção",
    legacy_aqui_sao_listados_todos_os_modulos_do_seu_sistema: "Aqui são listados todos os módulos do seu sistema",
    legacy_api_integrada_e_ativa: "API integrada e ativa",
    legacy_avaliacoes: "Avaliações",
    legacy_avaliar_questao: "Avaliar Questão",
    legacy_baixar_respostas: "Baixar respostas",
    legacy_baixar_pdf_com_analises: "Baixar pdf com análises",
    legacy_baixar_analises_em_pdf: "Baixar análises em pdf",
    legacy_baixar_planilha_excel: "Baixar planilha excel",
    legacy_baixar_todas_redacoes: "Baixar todas redações",
    legacy_baixar_correcoes: "Baixar correções",
    legacy_baixar_exemplo_de_arquivo: "Baixar Exemplo de Arquivo",
    legacy_baixar_pdf: "Baixar pdf",
    legacy_borda_visivel: "Borda visível?",
    legacy_candidatos_online: "Candidatos online",
    legacy_candidatos_vinculados: "Candidatos vinculados",
    legacy_cadastre_os_modulos_do_seu_sistema: "Cadastre os módulos do seu sistema",
    legacy_cancelar: "Cancelar",
    legacy_cadastrar_avaliador: "Cadastrar Avaliador",
    legacy_cadastrar_corretor: "Cadastrar Corretor",
    legacy_cadastrar_disciplina: "Cadastrar Disciplina",
    legacy_cadastrar_elaborador: "Cadastrar Elaborador",
    legacy_cadastrar_fiscal: "Cadastrar Fiscal",
    legacy_cadastrar_membro: "Cadastrar Membro",
    legacy_cadastrar_redacao: "Cadastrar Redação",
    legacy_cadastrar_recurso_de_questao: "Cadastrar Recurso de Questão",
    legacy_cadastrar_disciplina_2: "Cadastrar disciplina",
    legacy_configuracoes: "Configurações",
    legacy_configuracoes_da_instituicao: "Configurações da instituição",
    legacy_configuracoes_do_processo: "Configurações do processo",
    legacy_consulte_objetos_detectados_durante_a_avaliacao: "Consulte objetos detectados durante a avaliação.",
    legacy_confira_registros_de_troca_de_janela_ou_saida_da_tela: "Confira registros de troca de janela ou saída da tela.",
    legacy_data_de_criacao: "Data de criação",
    legacy_data_de_nascimento: "Data de nascimento",
    legacy_data_de_inicio: "Data de início",
    legacy_data_de_encerramento: "Data de encerramento",
    legacy_data_de_encerammento: "Data de encerammento",
    legacy_data_limite: "Data limite",
    legacy_data_da_resposta: "Data da resposta",
    legacy_data: "Data",
    legacy_download_relatorio: "Download relatório",
    legacy_deletar_demanda: "Deletar demanda",
    legacy_descricao: "Descrição:",
    legacy_descricao_do_modulo: "Descrição do módulo",
    legacy_descricao_do_treinamento: "Descrição do treinamento",
    legacy_descricao_dos_fatos: "Descrição dos fatos",
    legacy_editar_pagina: "Editar página",
    legacy_editar_perfil: "Editar Perfil",
    legacy_editar_avaliador: "Editar Avaliador",
    legacy_editar_corretor: "Editar Corretor",
    legacy_editar_fiscal: "Editar Fiscal",
    legacy_editar_membro: "Editar Membro",
    legacy_editar_modulo_conteudos: "Editar Módulo/Conteúdos",
    legacy_editar_questionario: "Editar Questionário",
    legacy_editar_redacao: "Editar Redação",
    legacy_editar_recurso_de_questao: "Editar Recurso de Questão",
    legacy_editar_disciplina: "Editar disciplina",
    legacy_editar_conteudo: "Editar conteúdo",
    legacy_editar_questao: "Editar questão",
    legacy_editar_questionario_2: "Editar questionário",
    legacy_editar_candidato: "Editar candidato",
    legacy_editar_corretor_2: "Editar corretor",
    legacy_editar_avaliador_2: "Editar avaliador",
    legacy_editar_fiscal_2: "Editar fiscal",
    legacy_editar_membro_2: "Editar membro",
    legacy_editar_elaborador: "Editar elaborador",
    legacy_editar_recurso: "Editar recurso",
    legacy_editar_atribuicao: "Editar atribuição",
    legacy_editar_treinamento: "Editar treinamento",
    legacy_editar_organizadora: "Editar organizadora",
    legacy_editar_horario: "Editar horário",
    legacy_editar_elemento_da_folha_de_rosto: "Editar elemento da folha de rosto",
    legacy_elemento_selecionado_de_duplo_clique_nele_para_abrir_o_editor: "Elemento selecionado. Dê duplo clique nele para abrir o editor.",
    legacy_editar_demanda: "Editar demanda",
    legacy_editar_elaborador_2: "Editar Elaborador",
    legacy_edite_um_elaborador_do_seu_sistema: "Edite um elaborador do seu sistema",
    legacy_escolha_a_alternativa_correta: "Escolha a alternativa correta",
    legacy_esconder_paginacao: "Esconder paginação?",
    legacy_enviar_e_mail_para_o_elaborador_com_senha_aleatoria: "Enviar e-mail para o elaborador com senha aleatória?",
    legacy_enviar_e_mail_para_o_cliente_com_senha_aleatoria: "Enviar e-mail para o cliente com senha aleatória?",
    legacy_elaborador_pode_criar_redacao: "Elaborador pode criar redação?",
    legacy_elaborador_pode_ser_auditor: "Elaborador pode ser auditor?",
    legacy_excluir_candidato: "Excluir candidato",
    legacy_excluir_corretor: "Excluir corretor",
    legacy_excluir_avaliador: "Excluir avaliador",
    legacy_excluir_fiscal: "Excluir fiscal",
    legacy_fiscais_online: "Fiscais online",
    legacy_folha_de_rosto: "Folha de rosto",
    legacy_gerencie: "Gerencie",
    legacy_gerencie_as_diagramacoes: "Gerencie as diagramações",
    legacy_gerencie_as_diagramacoes_vinculadas_ao_processo: "Gerencie as diagramações vinculadas ao processo",
    legacy_gerencie_as_redacoes: "Gerencie as redações",
    legacy_gerencie_candidatos: "Gerencie candidatos",
    legacy_gerencie_corretores: "Gerencie corretores",
    legacy_gerencie_diagramacoes: "Gerencie diagramações",
    legacy_gerencie_fiscais: "Gerencie fiscais",
    legacy_gerencie_provas_e_itens: "Gerencie provas e itens",
    legacy_gerencie_questionarios: "Gerencie questionários",
    legacy_gerencie_salas: "Gerencie salas",
    legacy_gerencie_as_salas_vinculadas_ao_processo: "Gerencie as salas vinculadas ao processo",
    legacy_gerencie_os_fiscais_vinculados_ao_processo: "Gerencie os fiscais vinculados ao processo",
    legacy_gerencie_os_corretores_vinculados_ao_processo: "Gerencie os corretores vinculados ao processo",
    legacy_gerencie_os_candidatos_vinculados_ao_processo: "Gerencie os candidatos vinculados ao processo",
    legacy_gerencie_os_candidatos_da_instituicao: "Gerencie os candidatos da instituição.",
    legacy_gerencie_os_candidatos_do_processo: "Gerencie os candidatos do processo.",
    legacy_gerencie_os_fiscais_da_instituicao: "Gerencie os fiscais da instituição.",
    legacy_gerencie_os_fiscais_do_processo: "Gerencie os fiscais do processo.",
    legacy_gerencie_os_avaliadores_da_instituicao: "Gerencie os avaliadores da instituição.",
    legacy_gerencie_os_avaliadores_do_processo: "Gerencie os avaliadores do processo.",
    legacy_gerencie_os_corretores_da_instituicao: "Gerencie os corretores da instituição.",
    legacy_gerencie_os_corretores_do_processo: "Gerencie os corretores do processo.",
    legacy_gerencie_os_treinamentos_vinculados_desta_instituicao: "Gerencie os treinamentos vinculados desta instituição.",
    legacy_gerencie_os_treinamentos_vinculados_deste_processo: "Gerencie os treinamentos vinculados deste processo.",
    legacy_gerencie_treinamentos: "Gerencie treinamentos",
    legacy_gerencie_as_entrevistas_vinculadas_ao_processo: "Gerencie as entrevistas vinculadas ao processo.",
    legacy_gerencie_as_avaliacoes_orais_dos_candidatos: "Gerencie as avaliações orais dos candidatos.",
    legacy_gerencie_os_membros_desta_organizadora: "Gerencie os membros desta organizadora.",
    legacy_gerencie_os_processos_seletivos: "Gerencie os processos seletivos",
    legacy_gerencie_as_vagas_do_processo_seletivo: "Gerencie as vagas do processo seletivo",
    legacy_gerencie_as_vagas_vinculadas_ao_seletivo: "Gerencie as vagas vinculadas ao seletivo.",
    legacy_gerencie_os_processos_vinculados_a_instituicao: "Gerencie os processos vinculados à instituição.",
    legacy_gerenciar: "Gerenciar",
    action_manage_dashboard: "Gerenciar dashboard",
    action_manage_proctors: "Gerenciar fiscais",
    action_manage_graders: "Gerenciar corretores",
    action_manage_evaluators: "Gerenciar avaliadores",
    legacy_horario_de_encerramento_do_intervalo: "Horário de encerramento do intervalo",
    legacy_ir_para_lista_de_correcoes: "Ir Para Lista de Correções",
    legacy_informacoes: "Informações",
    legacy_margem_direita: "Margem Direita",
    legacy_margem_esquerda: "Margem Esquerda",
    legacy_margem_inferior: "Margem Inferior",
    legacy_margem_superior: "Margem Superior",
    legacy_modulo_administrativo_utilizado_para_fazer_todos_os_cadastros_no_siste: "Módulo administrativo utilizado para fazer todos os cadastros no sistema e download dos resultados/relatórios",
    legacy_modulo_para_correcao_de_questoes_dissertativas_e_redacoes: "Módulo para correção de questões dissertativas e redações",
    legacy_modulo_para_aplicacao_de_prova_oral_onde_os_avaliadores_conseguem_entr: "Módulo para aplicação de prova oral, onde os avaliadores conseguem entrar em chamada com os candidatos",
    legacy_modulo_para_cadastros_de_questoes_por_parte_de_professores_elaboradoes: "Módulo para cadastros de questões por parte de professores/elaboradoes, responder recursos e atender demandas",
    legacy_modulo_de_fiscalizacao_proctoring_do_candidato_durante_todo_o_perido_d: "Módulo de fiscalização/proctoring do candidato durante todo o perído da avaliação online",
    legacy_modulo_para_acesso_do_candidato: "Módulo para acesso do candidato",
    legacy_modulos_vinculados: "Módulos vinculados",
    legacy_multipla_escolha: "Múltipla Escolha",
    legacy_escolha_multipla: "Escolha múltipla",
    legacy_administrador: "Administrador",
    legacy_corretor: "Corretor",
    legacy_avaliador: "Avaliador",
    legacy_elaborador: "Elaborador",
    legacy_fiscal: "Fiscal",
    legacy_candidato: "Candidato",
    legacy_nenhum_conteudo_cadastrado: "Nenhum(a) conteúdo cadastrado",
    legacy_nenhum_conteudo_selecionado: "Nenhum(a) conteúdo selecionado",
    legacy_nenhum_corretor_adicionado: "Nenhum(a) corretor adicionado",
    legacy_nenhum_corretor_selecionado: "Nenhum(a) corretor selecionado",
    legacy_nenhum_modulo_selecionado: "Nenhum(a) módulo selecionado",
    legacy_nenhum_questionario_cadastrado: "Nenhum(a) questionário cadastrado",
    legacy_nenhum_recurso_encontrado: "Nenhum(a) recurso encontrado",
    legacy_nenhum_aviso_encontrado: "Nenhum(a) aviso encontrado",
    legacy_nenhuma_analise_encontrada: "Nenhum(a) análise encontrada",
    legacy_nenhuma_disciplina_cadastrada: "Nenhum(a) disciplina cadastrada",
    legacy_nenhuma_execucao_encontrada: "Nenhum(a) execução encontrada",
    legacy_nenhuma_pergunta_adicionada: "Nenhum(a) pergunta adicionada",
    legacy_nenhuma_questao_adicionada: "Nenhum(a) questão adicionada",
    legacy_nenhuma_questao_cadastrada_nesta_demanda: "Nenhum(a) questão cadastrada nesta demanda",
    legacy_nenhuma_questao_encontrada_com_os_filtros_aplicados: "Nenhum(a) questão encontrada com os filtros aplicados",
    action_search: "Pesquisar",
    action_apply_filters: "Aplicar filtros",
    legacy_nenhuma_questao_selecionada: "Nenhum(a) questão selecionada",
    legacy_nenhuma_redacao_encontrada: "Nenhum(a) redação encontrada",
    legacy_nenhum_texto_de_apoio_adicionado: "Nenhum(a) texto de apoio adicionado",
    legacy_nenhuma_texto_encontrada: "Nenhum(a) texto encontrada",
    legacy_nenhum_avaliador_selecionado: "Nenhum(a) avaliador selecionado",
    legacy_nenhum_comentario_adicionado: "Nenhum(a) comentário adicionado",
    legacy_nenhum_criterio_adicionado: "Nenhum(a) critério adicionado",
    legacy_nenhuma_nota_registrada: "Nenhum(a) nota registrada",
    legacy_nenhuma_palavra_chave_vinculada: "Nenhum(a) palavra-chave vinculada",
    legacy_nome_do_modulo: "Nome do módulo",
    legacy_nome_da_disciplina: "Nome da disciplina",
    legacy_nome_da_categoria: "Nome da categoria",
    legacy_nome_do_corretor: "Nome do corretor",
    legacy_nome_do_avaliador: "Nome do avaliador",
    legacy_nome_do_fiscal: "Nome do fiscal",
    legacy_nome_do_aluno: "Nome do aluno",
    legacy_nome_do_membro: "Nome do membro",
    legacy_nome_do_membro_da_equipe: "Nome do membro da equipe",
    legacy_nome_do_elaborador: "Nome do elaborador",
    legacy_nome_da_redacao: "Nome da redação",
    legacy_nome_da_demanda: "Nome da demanda",
    legacy_nome_do_recurso: "Nome do recurso",
    legacy_nome_do_treinamento: "Nome do treinamento",
    legacy_nome_da_entrevista: "Nome da entrevista",
    legacy_nome_da_organizadora: "Nome da organizadora",
    legacy_nome_da_prova: "Nome da prova",
    legacy_nome_do_padrao: "Nome do padrão",
    legacy_nome_organizacao: "Nome Organização",
    legacy_nome_usuario: "Nome Usuário",
    legacy_numero_de_alternativas: "Número de alternativas",
    legacy_numero_de_modulos: "Número de Módulos",
    legacy_numero_de_colunas_da_avaliacao: "Número de colunas da Avaliação",
    legacy_numero_de_colunas_na_pagina: "Número de Colunas na página",
    legacy_numero_de_colunas: "Número de colunas",
    legacy_presentes: "Presentes",
    legacy_alunos: "Alunos",
    legacy_nota_minima: "Nota mínima",
    legacy_nota_maxima: "Nota máxima",
    legacy_nota: "Nota",
    legacy_criterios: "Critérios",
    legacy_codigo_do_criterio: "Código do Critério",
    legacy_texto_do_criterio: "Texto do Critério",
    legacy_n: "Nº",
    legacy_paginas: "Páginas",
    legacy_palavras_chaves: "Palavras chaves",
    legacy_palavra_chave: "Palavra chave",
    legacy_palavra_chave_2: "Palavra-chave",
    legacy_palavras_chave: "Palavras chave:",
    legacy_termos_nao_cadastrados: "Termos não cadastrados",
    legacy_termos_de_uso: "Termos de uso",
    legacy_alternativa_correta: "Alternativa Correta",
    legacy_alternativa_a: "Alternativa a)",
    legacy_alternativa_b: "Alternativa b)",
    legacy_alternativa_c: "Alternativa c)",
    legacy_alternativa_d: "Alternativa d)",
    legacy_alternativa_e: "Alternativa e)",
    legacy_comentarios: "Comentários",
    legacy_correcao_da_redacao: "Correção da Redação",
    legacy_enunciado_da_redacao: "Enunciado da redação",
    legacy_escolaridade: "Escolaridade",
    legacy_solucao: "Solução",
    legacy_pesquisa: "Pesquisa",
    legacy_pesquisar_pelo_nome_do_arquivo: "Pesquisar pelo nome do arquivo",
    legacy_pesquisar_pelo_nome_cpf_numero_de_inscricao_do_candidato: "Pesquisar pelo nome/cpf/número de inscrição do candidato",
    legacy_pesquisar_por_nome_cpf_ou_inscricao: "Pesquisar por nome, CPF ou inscrição",
    legacy_pesquisar_pelo_nome_do_questionario: "Pesquisar pelo nome do questionário",
    legacy_pesquisar_pelo_nome_da_prova: "Pesquisar pelo nome da prova",
    legacy_pesquisar_pelo_enunciado_ou_nome_da_redacao: "Pesquisar pelo enunciado ou nome da redação",
    legacy_pesquisar_pelo_nome_do_recurso: "Pesquisar pelo nome do recurso",
    legacy_pesquisar_pelo_nome_da_organizadora: "Pesquisar pelo nome da organizadora",
    legacy_pesquisar_pelo_nome_do_treinamento: "Pesquisar pelo nome do treinamento",
    legacy_pesquisar_pelo_nome_da_entrevista: "Pesquisar pelo nome da entrevista",
    legacy_pesquisar_pelo_nome_da_imagem: "Pesquisar pelo nome da imagem",
    legacy_pesquisar_pelo_nome_do_video: "Pesquisar pelo nome do video",
    legacy_pesquisar_pelo_nome_do_elaborador_ou_nome_da_categoria: "Pesquisar pelo nome do elaborador ou nome da categoria",
    legacy_pesquisar_pelo_enunciado_ou_nome_do_elaborador: "Pesquisar pelo enunciado ou nome do elaborador",
    legacy_pesquisar_pelo_nome_da_diagramacao: "Pesquisar pelo nome da diagramação",
    legacy_pesquisar_pelo_nome_do_candidato: "Pesquisar pelo nome do candidato",
    legacy_pesquisar_pelo_nome_do_conteudo: "Pesquisar pelo nome do conteúdo",
    legacy_pesquisar_pelo_nome_do_corretor: "Pesquisar pelo nome do corretor",
    legacy_pesquisar_pelo_nome_do_elaborador: "Pesquisar pelo nome do elaborador",
    legacy_pesquisar_pelo_nome_do_fiscal: "Pesquisar pelo nome do fiscal",
    legacy_pesquisar_pelo_nome_do_membro: "Pesquisar pelo nome do membro",
    legacy_pesquisar_pelo_nome_do_modulo: "Pesquisar pelo nome do módulo",
    legacy_pesquise_pelo_nome_do_conteudo: "Pesquise pelo nome do conteúdo",
    legacy_pesquise_pelo_nome_do_fiscal: "Pesquise pelo nome do fiscal",
    legacy_pesquise_a_questao_pelo_enunciado: "Pesquise a questão pelo enunciado",
    legacy_permissoes_concedidas: "Permissões concedidas",
    legacy_processo_seletivo_do_recurso: "Processo Seletivo do Recurso",
    legacy_prova_objetiva: "Prova objetiva",
    legacy_prova_atualizada: "Prova atualizada",
    legacy_provas_cadastradas: "Provas cadastradas",
    legacy_questao_objetiva: "Questão objetiva",
    legacy_questao_unica: "Questão única",
    legacy_questao_selecionada: "Questão selecionada",
    legacy_questoes_selecionadas: "Questões selecionadas",
    legacy_questoes_cadastradas: "Questões cadastradas",
    legacy_questao_de_multipa_escolha: "Questão de Múltipa Escolha",
    legacy_questao_dissertativa: "Questão Dissertativa",
    legacy_conjunto_de_questoes_de_multipa_escolha_com_enunciado_em_comum: "Conjunto de Questões de Múltipa Escolha com Enunciado em Comum",
    legacy_lista_de_questionarios: "Lista de Questionários",
    legacy_lista_de_diagramacoes: "Lista de Diagramações",
    legacy_lista_de_organizadoras: "Lista de organizadoras",
    legacy_lista_de_questoes_para_avaliacao: "Lista de Questões para Avaliação",
    legacy_lista_de_recursos_de_questoes: "Lista de Recursos de Questões",
    legacy_registros_de_tela: "Registros de Tela",
    legacy_videos: "Videos",
    legacy_logs_de_conexao: "Logs de conexão",
    legacy_diagramacoes_nominais: "Diagramações nominais",
    legacy_recolher_configuracoes: "Recolher configurações",
    legacy_relatorio_rapido: "Relatório rápido",
    legacy_relatorios: "Relatórios",
    legacy_relatorios_gerais: "Relatórios Gerais",
    legacy_relatorios_por_vaga_cargo: "Relatórios por vaga/cargo",
    legacy_remover_elemento: "Remover elemento",
    legacy_redacao_criada: "Redação criada",
    legacy_redacoes_cadastradas: "Redações cadastradas",
    legacy_revise_validacoes_imagens_e_ocorrencias_de_reconhecimento_facial: "Revise validações, imagens e ocorrências de reconhecimento facial.",
    legacy_ver_regras: "Ver regras",
    legacy_ver_questao: "Ver questão",
    legacy_ver: "Ver",
    legacy_sala: "Sala",
    legacy_saidas_de_tela: "Saídas de tela",
    legacy_salvar_imagens_com_streaming_em_tempo_real: "Salvar Imagens com Streaming em tempo real",
    legacy_sem_fiscalizacao: "Sem fiscalização",
    legacy_salvar_diagramacao: "Salvar diagramação",
    legacy_salvar_diagramacao_como_padrao: "Salvar diagramação como padrão?",
    legacy_salvar_diagramacao_e_imprimir: "Salvar diagramação e imprimir",
    legacy_salvar_configuracoes: "Salvar Configurações",
    legacy_salvar_questao: "Salvar questão",
    legacy_salvar_comentario: "Salvar comentário",
    legacy_salvar_recurso: "Salvar recurso",
    legacy_salvar_corretor: "Salvar corretor",
    legacy_salvar_corretores: "Salvar corretores",
    legacy_salvar_fiscal: "Salvar fiscal",
    legacy_salvar_fiscais: "Salvar fiscais",
    legacy_salvar_avaliador: "Salvar avaliador",
    legacy_salvar_modulo: "Salvar módulo",
    legacy_salvar_treinamento: "Salvar treinamento",
    legacy_salvar_organizadora: "Salvar organizadora",
    legacy_salvar_redacoes: "Salvar redações",
    legacy_salvar_redacao: "Salvar redação",
    legacy_salvar_aluno: "Salvar aluno",
    legacy_salvar_prova: "Salvar prova",
    legacy_salvar_prova_e_ir_para_diagramacao: "Salvar prova e ir para diagramação",
    legacy_salvar_questoes: "Salvar questões",
    legacy_salvar_questionario: "Salvar questionário",
    legacy_salvar_questionarios: "Salvar questionários",
    legacy_salvar_conteudo: "Salvar conteúdo",
    legacy_salvar_formula: "Salvar fórmula",
    legacy_salvar_entrevista: "Salvar entrevista",
    legacy_mostrar_configuracoes: "Mostrar configurações",
    legacy_selecione_a_disciplina: "Selecione a disciplina",
    legacy_selecione_a_quantidade: "Selecione a quantidade",
    legacy_selecione_uma_disciplina: "Selecione uma disciplina",
    legacy_selecione_uma_alternativa_correta: "Selecione uma alternativa correta",
    legacy_selecione_um_processo_seletivo: "Selecione um processo seletivo",
    legacy_selecione_um_ou_mais_elaboradores: "Selecione um ou mais elaboradores",
    legacy_selecione_um_ou_mais_elaboradores_que_deverao_cadastrar_questoes_dessa: "Selecione um ou mais elaboradores que deverão cadastrar questões dessa disciplina",
    legacy_selecione_um_elemento_no_preview_de_duplo_clique_para_editar_o_texto: "Selecione um elemento no preview. Dê duplo clique para editar o texto.",
    legacy_selecione_um_padrao_de_diagramacao: "Selecione um padrão de diagramação",
    legacy_selecione_uma_prova: "Selecione uma prova",
    legacy_sim_desejo_apagar: "Sim, desejo apagar",
    legacy_subtitulo_cabecalho: "Subtítulo Cabeçalho",
    legacy_tipo: "Tipo",
    legacy_tipo_da_questao: "Tipo da Questão",
    legacy_tipo_de_pergunta: "Tipo de pergunta",
    legacy_tipos_de_status: "Tipos de status:",
    legacy_titulo: "Título",
    legacy_titulo_do_questionario: "Título do questionário",
    legacy_titulo_do_texto_de_apoio: "Título do texto de apoio",
    legacy_titulo_campo_1: "Título campo 1",
    legacy_titulo_campo_2: "Título campo 2",
    legacy_titulo_ex_escola_x: "Título. Ex: Escola X",
    legacy_tamanho_da_fonte_do_texto: "Tamanho da fonte do texto",
    legacy_termos_cadastrados: "Termos cadastrados",
    legacy_titulo_ex_instituicao: "Título (Ex: Instituição)",
    legacy_titulo_cabecalho: "Título Cabeçalho",
    legacy_todos_os_relatorios: "Todos os relatórios",
    legacy_n_candidatos: "Nº candidatos",
    legacy_n_fiscais: "Nº fiscais",
    legacy_n_corretores: "Nº corretores",
    legacy_vagas: "Vagas",
    legacy_veja_candidatos_e_avaliadores_conectados_no_momento: "Veja candidatos e avaliadores conectados no momento.",
    legacy_ver_enunciado: "Ver Enunciado",
    legacy_visualize_indicadores: "Visualize indicadores",
    legacy_visualize_as_atribuicoes_desta_demanda: "Visualize as atribuições desta demanda.",
    legacy_visualize_as_atribuicoes_deste_recurso: "Visualize as atribuições deste recurso.",
    legacy_visualize_os_modulos_vinculados_ao_treinamento: "Visualize os módulos vinculados ao treinamento.",
    legacy_visualize_os_candidatos_vinculados_a_entrevista: "Visualize os candidatos vinculados à entrevista.",
    legacy_visualize_as_questoes_do_questionario: "Visualize as questões do questionário.",
    legacy_visualize_as_questoes_desta_diagramacao: "Visualize as questões desta diagramação.",
    legacy_visualize_os_registros_de_tela: "Visualize os registros de tela.",
    legacy_consulte_os_relatorios_da_analise_facial: "Consulte os relatórios da análise facial.",
    legacy_consulte_os_relatorios_e_pontos_de_confianca: "Consulte os relatórios e pontos de confiança.",
    legacy_quem_ja_fez_login: "Quem já fez login",
    legacy_online_agora: "Online agora",
    legacy_abrir_modulo: "Abrir módulo",
    legacy_encerramento: "Encerramento:",
    legacy_e_mail_do_elaborador: "E-mail do elaborador",
    legacy_baixe_relatorios_gerais_ou_abra_a_area_completa_de_relatorios: "Baixe relatórios gerais ou abra a área completa de relatórios.",
    legacy_avaliadores_online: "Avaliadores online",
    legacy_avaliadores_vinculados: "Avaliadores vinculados",
    legacy_fiscais_vinculados: "Fiscais vinculados",
    legacy_candidato_vinculado: "Candidato vinculado",
    legacy_baixar_pdf_2: "Baixar PDF",
    legacy_baixar_planilha: "Baixar Planilha",
    legacy_baixar_gabarito_da_prova: "Baixar gabarito da prova",
    legacy_baixar_respostas_da_prova: "Baixar respostas da prova",
    legacy_baixar_folhas_de_resposta_em_pdf: "Baixar folhas de resposta em .pdf",
    legacy_baixar_caderno_com_respostas_em_pdf: "Baixar caderno com respostas em pdf",
    legacy_baixar_provas_em_pdf: "Baixar provas em .pdf",
    legacy_baixar_respostas_em_csv: "Baixar respostas em .csv",
    legacy_baixar_resposta_em_pdf: "Baixar resposta em .pdf",
    legacy_baixar_relatorio_de_saidas_de_tela: "Baixar relatório de saídas de tela",
    legacy_baixar_pdf_com_imagens: "Baixar pdf com imagens",
    legacy_categoria: "Categoria",
    legacy_data_da_ultima_atualizacao: "Data da última atualização",
    legacy_erro: "Erro",
    legacy_identificador_da_demanda: "Identificador da demanda",
    legacy_numero_de_questoes: "Número de questões",
    legacy_numero_de_questoes_2: "Número de Questões",
    legacy_numero_de_inscricao: "Número de Inscrição",
    legacy_numero_de_inscricao_2: "Número de inscrição",
    legacy_numero_inscricao: "Número Inscrição",
    legacy_numero_deteccoes: "Número detecções",
    legacy_pesquise_o_fiscal_pelo_nome: "Pesquise o fiscal pelo nome",
    legacy_prova: "Prova",
    legacy_relatorio: "Relatório",
    legacy_relatorio_de_acesso: "Relatório de Acesso",
    legacy_saidas: "Saídas",
    legacy_tipo_de_arquivo: "Tipo de arquivo",
    legacy_total: "Total",
    legacy_textos_de_apoio: "Textos de apoio",
    legacy_corrigir_com_ia: "Corrigir com IA",
    legacy_cpf: "CPF",
    legacy_inscricao: "Inscrição",
    legacy_resultado: "Resultado",
    legacy_modelo: "Modelo",
    legacy_progresso: "Progresso",
    legacy_primeira_deteccao: "Primeira detecção",
    legacy_pre_visualizacao_do_pdf: "Pré-visualização do PDF",
    legacy_upload_da_capa_do_video: "Upload da Capa do Vídeo",
    legacy_pre_visualizacao_do_video: "Pré-visualização do Vídeo",
    legacy_pre_visualizacao_da_capa: "Pré-visualização da Capa",
    legacy_busque_um_ou_mais_conteudos_que_deseja_vincular: "Busque um ou mais conteúdos que deseja vincular",
    legacy_busque_um_ou_mais_corretores_que_deseja_vincular: "Busque um ou mais corretores que deseja vincular",
    legacy_busque_um_ou_mais_fiscais_que_deseja_vincular: "Busque um ou mais fiscais que deseja vincular",
    legacy_busque_um_ou_mais_candidatos_que_deseja_vincular: "Busque um ou mais candidatos que deseja vincular",
    legacy_busque_questoes_da_disciplina: "Busque questões da disciplina",
    legacy_gerencie_os_textos_de_apoio_da_redacao: "Gerencie os textos de apoio da redação.",
    legacy_acompanhe_os_resultados_desta_redacao: "Acompanhe os resultados desta redação.",
    legacy_acesse_a_correcao_assistida_por_ia: "Acesse a correção assistida por IA.",
    legacy_visualize_e_organize_as_questoes_da_prova: "Visualize e organize as questões da prova.",
    legacy_visualize_os_conteudos_vinculados_ao_modulo: "Visualize os conteúdos vinculados ao módulo.",
    legacy_visualize_o_arquivo_principal_do_conteudo: "Visualize o arquivo principal do conteúdo.",
    legacy_gerencie_as_questoes_vinculadas_ao_conteudo: "Gerencie as questões vinculadas ao conteúdo.",
    legacy_visualize_as_imagens_capturadas_na_analise: "Visualize as imagens capturadas na análise.",
    legacy_consulte_os_relatorios_da_analise: "Consulte os relatórios da análise.",
    legacy_consulte_os_candidatos_vinculados_a_esta_sala: "Consulte os candidatos vinculados a esta sala.",
    legacy_veja_os_fiscais_responsaveis_pela_sala: "Veja os fiscais responsáveis pela sala.",
    legacy_acompanhe_os_corretores_vinculados: "Acompanhe os corretores vinculados.",
    legacy_consulte_o_historico_e_os_indicadores_de_acesso: "Consulte o histórico e os indicadores de acesso.",
    legacy_visualize_as_avaliacoes_do_candidato: "Visualize as avaliações do candidato.",
    legacy_acesse_os_videos_capturados: "Acesse os vídeos capturados.",
    legacy_consulte_os_logs_de_conexao: "Consulte os logs de conexão.",
    legacy_veja_os_videos_da_tela_do_candidato: "Veja os vídeos da tela do candidato.",
    legacy_aqui_ficam_os_downloads_do_seletivo: "Aqui ficam os downloads do seletivo",
    legacy_aqui_ficam_os_modelos_da_prova: "Aqui ficam os modelos da prova",
    legacy_aqui_ficam_os_candidatos_que_possuem_conflito_de_cpf_com_outros_candid: "Aqui ficam os candidatos que possuem conflito de CPF com outros candidatos",
    legacy_arquivo_csv: "Arquivo .csv",
    legacy_arquivo_csv_contendo_os_dados_dos_corretores: "Arquivo .csv contendo os dados dos corretores",
    legacy_arquivo_de_redacoes_zip_rar: "Arquivo de redações (.zip/.rar)",
    legacy_busque_um_ou_mais_avaliadores_que_deseja_vincular: "Busque um ou mais avaliadores que deseja vincular",
    legacy_busque_um_ou_mais_fiscais_que_deseja_vincular_no_treinamento: "Busque um ou mais fiscais que deseja vincular no treinamento",
    legacy_busque_um_ou_mais_modulos_que_deseja_vincular: "Busque um ou mais módulos que deseja vincular",
    legacy_busque_um_ou_mais_questionarios_que_deseja_vincular: "Busque um ou mais questionários que deseja vincular",
    legacy_campo_1: "Campo 1",
    legacy_campo_1_ex_cargo_de_poilicia: "Campo 1 (Ex: Cargo de Poílicia)",
    legacy_campo_2: "Campo 2",
    legacy_campo_2_ex_vespertino: "Campo 2 (Ex: Vespertino)",
    legacy_corretores_selecionados: "Corretores selecionados",
    legacy_deletar_disciplina: "Deletar disciplina",
    legacy_deletar_elaborador: "Deletar elaborador",
    legacy_deletar_organizadora: "Deletar organizadora",
    legacy_deletar_recurso: "Deletar recurso",
    legacy_deletar_texto: "Deletar texto",
    legacy_desvincular_candidato: "Desvincular candidato",
    legacy_desvincular_fiscal: "Desvincular fiscal",
    legacy_digite_a_confirmacao_de_senha: "Digite a confirmação de senha",
    legacy_fiscais_selecionados: "Fiscais selecionados",
    legacy_gerenciar_aula: "Gerenciar aula",
    legacy_gerenciar_candidato: "Gerenciar candidato",
    legacy_gerenciar_disciplina: "Gerenciar disciplina",
    legacy_gerenciar_imagem: "Gerenciar imagem",
    legacy_gerenciar_organizadora: "Gerenciar organizadora",
    legacy_gerenciar_prova: "Gerenciar prova",
    legacy_gerenciar_recurso: "Gerenciar recurso",
    legacy_gerenciar_texto: "Gerenciar texto",
    legacy_historico_de_resposta_s: "Histórico de resposta(s):",
    legacy_imagem_s_arquivo_s_da_resposta: "Imagem(s)/arquivo(s) da resposta:",
    legacy_imagem_s_arquivo_s_do_recurso: "Imagem(s)/arquivo(s) do recurso:",
    legacy_imagens_arquivos_do_recurso_maximo_10_arquivos: "Imagens/arquivos do recurso (Máximo 10 arquivos)",
    legacy_incluir_campo_de_titulo_na_redacao: "Incluir campo de título na redação?",
    legacy_incluir_folha_em_branco_apos_folha_de_rosto: "Incluir folha em branco após folha de rosto?",
    legacy_numero_de_linhas_na_folha_de_redacao: "Número de linhas na folha de redação",
    legacy_pedido_realizado: "Pedido realizado",
    legacy_pesquise_o_avaliador_pelo_nome: "Pesquise o avaliador pelo nome",
    legacy_pesquisar_pelo_nome_do_membro_da_organizadora: "Pesquisar pelo nome do membro da organizadora",
    legacy_questao_selecionada_2: "Questão selecionada:",
    legacy_redacoes_zip_rar: "Redações (.zip/.rar)",
    legacy_subtitulo_ex_local: "Subtítulo (Ex: Local)",
    legacy_subtitulo_ex_estado_de_sao_paulo: "Subtítulo. Ex: Estado de São Paulo",
    legacy_subtitulo_do_cabecalho: "Subtítulo do Cabeçalho",
    legacy_texto_de_apoio_pdf: "Texto de apoio (.pdf)",
    legacy_texto_informativo_na_tela_de_login: "Texto informativo na tela de login",
    legacy_texto_informativo_para_os_candidatos_que_ira_aparecer_na_tela_de_login: "Texto informativo para os candidatos que irá aparecer na tela de login.",
    legacy_titulo_campo_1_ex_cargo: "Título campo 1 (Ex: Cargo)",
    legacy_titulo_campo_2_ex_turno: "Título campo 2 (Ex: Turno)",
    legacy_titulo_do_cabecalho: "Título do Cabeçalho",
    legacy_tamanho_da_fonte_das_instrucoes: "Tamanho da fonte das instruções",
    legacy_tamanho_da_fonte_do_cabecalho_da_folha_de_rosto: "Tamanho da fonte do cabeçalho da folha de rosto",
    legacy_visualizar: "Visualizar",
    legacy_visualizar_texto: "Visualizar texto",
    legacy_cabecalho_folha_de_rosto: "Cabeçalho folha de rosto",
    legacy_caminho_da_url: "Caminho da URL",
    legacy_cnpj: "CNPJ",
    legacy_escreva_a_alternativa: "Escreva a alternativa",
    legacy_escreva_a_pergunta: "Escreva a pergunta",
    legacy_escreva_a_pergunta_do_campo_texto: "Escreva a pergunta do campo texto ",
    legacy_escreva_o_placeholder_do_campo_texto: "Escreva o placeholder do campo texto ",
    legacy_fundamentacao_do_pedido: "Fundamentação do pedido",
    legacy_fundamentacao_do_pedido_2: "Fundamentação do pedido:",
    legacy_horario_limite: "Horário limite",
    legacy_informacao_geral: "Informação Geral",
    legacy_informacao_geral_2: "Informação Geral:",
    legacy_informacao_para_o_avaliador: "Informação para o Avaliador",
    legacy_informacao_para_o_avaliador_2: "Informação para o Avaliador:",
    legacy_logo_superior: "Logo Superior",
    legacy_logo_inferior: "Logo Inferior",
    legacy_numero_de_inscricao_do_candidato: "Número de inscrição do candidato",
    legacy_obrigatorio_sempre: "Obrigatório sempre",
    legacy_obrigatorio_se: "Obrigatório se",
    legacy_qual_a_alternativa_correta: "Qual a alternativa correta?",
    legacy_texto_do_topico: "Texto do tópico",
    legacy_visualizar_pergunta_do_questionario: "Visualizar Pergunta do Questionário",
    legacy_vincular_corretor_es: "Vincular Corretor(es)",
    legacy_dashboard: "← Dashboard",
    legacy_cadastrados_na_plataforma: "cadastrados na plataforma",
    legacy_as_vagas: "as vagas",
    legacy_os_processos: "os processos",
    legacy_candidatos_e_equipe: ", candidatos e equipe",
    legacy_da_instituicao: "da instituição",
    legacy_do_processo: "do processo",
    legacy_instituicoes: "instituições",
    legacy_processos: "processos",
    ui_sim_desejo_desvincular_91364237: "Sim, desejo desvincular",
    ui_ao_desvincular_este_questao_ele_nao_tera_mais_aces_7cad3b8d: "Ao desvincular este questao, ele não terá mais acesso as questoes deste processo",
    ui_ao_deletar_este_candidato_ele_nao_estara_mais_disp_014976fb: "Ao deletar este candidato, ele não estará mais disponível no sistema",
    ui_cadastrar_candidato_00a96ef8: "Cadastrar Candidato",
    ui_cadastre_os_candidatos_cd2390f0: "Cadastre os candidatos",
    ui_o_candidato_precisa_de_alguma_funcao_de_acessibili_9ef2ad9d: "O candidato precisa de alguma função de acessibilidade? Ex: ouvir texto da questão",
    ui_e_necessario_um_fiscal_supervisor_77284eb8: "É necessário um fiscal supervisor?",
    ui_habilitar_opcao_de_ouvir_questao_redacao_744ae16d: "Habilitar opção de ouvir questão/redação?",
    ui_habilitar_possibilidade_de_ampliar_questao_redacao_cb06350b: "Habilitar possibilidade de ampliar questão/redação?",
    ui_data_invalida_76fc5825: "Data inválida",
    ui_editar_candidato_de3b0830: "Editar Candidato",
    ui_aqui_ficam_as_analises_dos_candidatos_do_processo_4d85efa9: "Aqui ficam as análises dos candidatos do processo \"",
    ui_acuracia_media_ed46129a: "Acurácia Média",
    ui_melhor_acuracia_9143c643: "Melhor Acurácia",
    ui_pior_acuracia_eca7bfc4: "Pior Acurácia",
    ui_acoes_reportadas_473f06f8: "Ações reportadas",
    ui_aqui_ficam_as_analises_das_imagens_do_candidato_8490cebb: "Aqui ficam as análises das imagens do candidato \"",
    ui_acuracia_18c91bc7: "Acurácia",
    ui_ultimo_login_64f79636: "Último Login:",
    ui_aqui_ficam_as_analises_dos_candidatos_vinculados_a_7ea29b91: "Aqui ficam as análises dos candidatos vinculados ao processo \"",
    ui_estatisticas_bd290229: "Estatísticas",
    ui_nao_detectada_0d0935c6: "Não detectada:",
    ui_multiplas_faces_detectadas_944de664: "Múltiplas Faces Detectadas:",
    ui_ao_deletar_este_avaliador_ele_nao_estara_mais_disp_5a8e24a5: "Ao deletar este avaliador, ele não estará mais disponível no sistema",
    ui_gerencie_os_avaliadores_vinculados_ao_processo_e1675ff5: "Gerencie os avaliadores vinculados ao processo",
    ui_ao_desvincular_este_avaliador_ele_nao_tera_mais_ac_341570a9: "Ao desvincular este avaliador, ele não terá mais acesso a este processo",
    ui_nenhum_avaliador_encontrado_com_este_termo_02f9a1af: "Nenhum(a) avaliador encontrado com este termo",
    ui_salvar_avaliadores_07b49db6: "Salvar avaliadores",
    ui_bem_vindo_a_questoes_publicas_043b7469: "Bem-vindo à Questões Públicas!",
    ui_filtrar_questoes_6421faf4: "Filtrar Questões",
    ui_tipo_de_questao_d2c9716b: "Tipo de Questão",
    ui_ensino_medio_3712ec7a: "Ensino Médio",
    ui_nivel_de_dificuldade_a85f6b3c: "Nível de Dificuldade",
    ui_facil_e304d15a: "Fácil",
    ui_medio_4f48c19e: "Médio",
    ui_dificil_36dc8fb0: "Difícil",
    ui_utilizar_questao_3fee6791: "Utilizar Questão",
    ui_alterar_questao_bbfea6ad: "Alterar questão",
    ui_aqui_ficam_a_confiabilidade_dos_candidatos_no_d344db7b: "Aqui ficam a confiabilidade dos candidatos no \"",
    ui_quanto_menor_o_valor_mais_confiavel_6654eba4: "\". Quanto menor o valor, mais confiável",
    ui_acoes_reportadas_3b561a75: "Ações reportadas:",
    ui_media_do_reconhecimento_facial_cda4999c: "Média do reconhecimento facial:",
    ui_validacoes_faciais_periodicas_004cccb9: "Validações faciais periódicas:",
    ui_numero_de_pedidos_de_liberacao_para_o_fiscal_ae10b565: "Número de pedidos de liberação para o fiscal:",
    ui_saidas_de_tela_101c35f0: "Saídas de tela:",
    ui_tempo_de_saida_da_tela_de_prova_75e5fa8c: "Tempo de saída da tela de prova:",
    ui_videos_sem_rosto_39a8f692: "Vídeos sem rosto:",
    ui_multiplas_rostos_2288af49: "Múltiplas rostos:",
    ui_ips_identicos_a9e2cc1b: "Ips idênticos:",
    ui_ao_desvincular_este_candidato_ele_nao_tera_mais_ac_1d2c882c: "Ao desvincular este candidato, ele não terá mais acesso a este processo",
    ui_aqui_ficam_os_candidatos_ordernados_por_saidas_da__b0224f9a: "Aqui ficam os candidatos ordernados por saídas da tela de avialiação do \"",
    ui_quanto_menor_mais_confiavel_46a756c2: "Quanto menor, mais confiável",
    ui_vincule_um_ou_mais_candidatos_ao_processo_aeb7a3be: "Vincule um ou mais candidatos ao processo",
    ui_nenhum_candidato_encontrado_com_este_termo_2b9da6d2: "Nenhum(a) candidato encontrado com este termo",
    ui_candidatos_selecionados_c38f4abb: "Candidatos selecionados",
    ui_nenhum_candidato_selecionado_5cf1f638: "Nenhum(a) candidato selecionado",
    ui_salvar_candidatos_87fdb232: "Salvar candidatos",
    ui_salvando_candidatos_bfb38308: "Salvando candidatos",
    ui_aqui_ficam_os_registros_de_tela_do_candidato_dd8ad37e: "Aqui ficam os registros de tela do candidato \"",
    ui_ao_deletar_esta_imagem_ela_nao_estara_mais_disponi_fba6b358: "Ao deletar esta imagem, ela não estará mais disponível no sistema",
    ui_aqui_ficam_as_imagens_do_candidato_6138c418: "Aqui ficam as imagens do candidato \"",
    ui_proximo_64b2d0d6: "Próximo",
    ui_nenhuma_imagem_encontrada_2840b232: "Nenhum(a) imagem encontrada",
    ui_ao_deletar_este_image_ele_nao_estara_mais_disponiv_e2464011: "Ao deletar este Image, ele não estará mais disponível no sistema",
    ui_aqui_fica_os_logs_de_conexao_do_candidato_d73a76d4: "Aqui fica os logs de conexão do candidato \"",
    ui_logs_de_conexao_86069e78: "Logs de conexão:",
    ui_ao_deletar_este_relatorio_ele_nao_estara_mais_disp_34cd8ca1: "Ao deletar este relatorio, ele não estará mais disponível no sistema",
    ui_aqui_ficam_as_mensagens_do_candidato_92001b7d: "Aqui ficam as mensagens do candidato \"",
    ui_ao_deletar_este_message_ele_nao_estara_mais_dispon_ff224805: "Ao deletar este message, ele não estará mais disponível no sistema",
    ui_adicionar_candidatos_no_processo_4fc3ab7a: "Adicionar candidatos no processo",
    ui_arquivo_csv_contendo_os_dados_dos_candidatos_272963f2: "Arquivo .csv contendo os dados dos candidatos",
    ui_padrao_3386172b: "Padrão:",
    ui_o_csv_nao_deve_ter_cabecalho_nome_das_colunas_as_c_641b51e4: "O .csv não deve ter cabeçalho (Nome das colunas). As colunas devem ser separadas por “;” no seguinte formato:",
    ui_numero_inscricao_nome_e_mail_data_de_nascimento_yy_e687bdde: "Número Inscrição; Nome; E-mail; Data de nascimento (YYYY-MM-DD); CPF (Sem . e -); Senha; Link da foto do candidato (Opcional)",
    ui_nenhum_candidato_adicionado_33c9a2c9: "Nenhum(a) candidato adicionado",
    ui_aqui_ficam_as_avaliacoes_do_candidato_fd246cf8: "Aqui ficam as avaliações do candidato \"",
    ui_redacoes_30c87866: "Redações:",
    ui_redacao_cd320598: "Redação",
    ui_gerenciar_correcao_c17fdb3e: "Gerenciar correção",
    ui_gerenciar_redacao_b69a0438: "Gerenciar redação",
    ui_nenhuma_redacao_encontrado_eb318de7: "Nenhum(a) redação encontrado",
    ui_questionarios_fefc98ab: "Questionários:",
    ui_questionario_a3ec8d1d: "Questionário",
    ui_nenhum_questionario_encontrado_cc92c82e: "Nenhum(a) questionário encontrado",
    ui_aqui_fica_o_relatorio_do_candidato_37e99da8: "Aqui fica o relatorio do candidato \"",
    ui_acao_d621dc82: "Ação",
    ui_ate_fc454800: "Até",
    ui_saiu_da_pagina_da_aplicacao_fda9235a: "Saiu da página da aplicação:",
    ui_horario_3bd854d6: "Horário",
    ui_ver_video_da_camera_0a3101ee: "Ver Vídeo da Câmera",
    ui_ver_video_da_tela_b4b78e7f: "Ver Vídeo da Tela",
    ui_nenhuma_acao_registrada_aebf4fac: "Nenhum(a) ação registrada",
    ui_registros_de_saida_27d28fba: "Registros de Saída:",
    ui_avisos_de_restricao_de_horario_duas_ou_mais_telas__902f57ad: "Avisos de restrição de horário/duas ou mais telas/permissões:",
    ui_media_do_reconhecimento_facial_001ef5c2: "Média do reconhecimento facial",
    ui_validacoes_faciais_periodicas_f9280df8: "Validações faciais periódicas",
    ui_numero_de_pedidos_de_liberacao_para_o_fiscal_217b2c1f: "Número de pedidos de liberação para o fiscal",
    ui_tempo_de_saida_da_tela_de_prova_7fd35c63: "Tempo de saída da tela de prova",
    ui_videos_sem_rosto_57354ae0: "Vídeos sem rosto",
    ui_multiplas_rostos_de74b532: "Múltiplas rostos",
    ui_ips_identicos_df44355b: "Ips idênticos",
    ui_sim_desejo_liberar_b38fec32: "Yes, release",
    ui_ao_liberar_esse_candidato_ele_tera_acesso_a_avalia_8784a55f: "Ao liberar esse candidato, ele terá acesso a avaliação caso ele não tenha entrado durante o intervalo de horário determinado, ou caso ele já tenha finalizado a avaliação",
    ui_aqui_ficam_os_videos_da_tela_do_candidato_8209a3d0: "Aqui ficam os videos da tela do candidato \"",
    ui_nenhum_video_de_tela_encontrado_372de0f0: "Nenhum(a) video de tela encontrado",
    ui_ao_deletar_este_video_ele_nao_estara_mais_disponiv_db74e885: "Ao deletar este video, ele não estará mais disponível no sistema",
    ui_aqui_ficam_os_videos_do_candidato_a563f69c: "Aqui ficam os videos do candidato \"",
    ui_nenhum_video_encontrado_6180dcce: "Nenhum(a) video encontrado",
    ui_ao_deletar_esta_disciplina_ela_nao_estara_mais_dis_6ced45ee: "Ao deletar esta disciplina, ela não estará mais disponível no sistema",
    ui_contexto_da_questao_36e5d6aa: "Contexto da Questão",
    ui_tipo_de_questao_2e2adb09: "Tipo de Questão:",
    ui_nivel_de_escolaridade_d4702d75: "Nível de Escolaridade:",
    ui_nivel_de_dificuldade_0d029649: "Nível de Dificuldade:",
    ui_editar_criar_novo_contexto_0450e752: "Editar/Criar Novo Contexto",
    ui_gerar_questao_d655bb9d: "Gerar Questão",
    ui_questoes_geradas_pendentes_de_validacao_18471a7e: "Questões Geradas Pendentes de Validação",
    ui_altere_a_disciplina_do_contexto_para_ver_questao_p_815d5e95: "Altere a disciplina do contexto para ver questão pendentes de outra disciplina",
    ui_validar_questao_787fc7b5: "Validar Questão",
    ui_salvar_disciplina_b7d69832: "Salvar disciplina",
    ui_cadastre_as_questoes_da_disciplina_2788a383: "Cadastre as questões da disciplina",
    ui_criando_questao_a_partir_de_uma_questao_gerada_por_fa6bba4a: "*Criando questão a partir de uma questão gerada por IA*",
    ui_criar_questao_com_ia_e87441a1: "Criar Questão com IA",
    ui_nivel_de_escolaridade_a4c58d10: "Nível de Escolaridade",
    ui_gerenciar_questao_71268f08: "Gerenciar questão",
    ui_deletar_questao_6f8e24a2: "Deletar questão",
    ui_salvando_questao_848b910e: "Salvando questão",
    ui_editar_disciplina_3a3c3d30: "Editar Disciplina",
    ui_edite_uma_questao_da_disciplina_dec9ff97: "Edite uma questão da disciplina",
    ui_questao_56688686: "Questão -",
    ui_abra_o_teclado_de_formula_clicando_em_3de9635e: "Abra o teclado de fórmula clicando em",
    ui_aperte_shift_em_cada_aba_do_teclado_para_ver_mais__8e0b3b8b: "Aperte SHIFT em cada aba do teclado para ver mais opções",
    ui_salvando_formula_f82737d5: "Salvando fórmula",
    ui_solucao_b354e358: "Solução:",
    ui_questao_de_31457044: "Questão de",
    ui_adicionar_questoes_na_disciplina_03c19af6: "Adicionar questões na disciplina",
    ui_palavras_chaves_palavras_que_serao_aplicadas_para__c51efe30: "Palavras chaves (Palavras que serão aplicadas para identificar todas questões do arquivo)",
    ui_arquivo_docx_contendo_as_questoes_f5bf5ebe: "Arquivo .docx contendo as questões",
    ui_o_docx_deve_ter_os_seguintes_caracteres_dividindo__d9815b36: "O .docx deve ter os seguintes caracteres dividindo cada questão: $$$$$",
    ui_o_docx_deve_ter_os_seguintes_caracteres_dividindo__37d81673: "O .docx deve ter os seguintes caracteres dividindo cada alternativa: &&&&&",
    ui_se_for_a_ultima_questao_ao_final_do_arquivo_tambem_e587849a: "Se for a última questão, ao final do arquivo também deve colocar os caracteres: $$$$$",
    ui_o_docx_deve_ter_os_seguintes_caracteres_para_indic_1d1f63f4: "O .docx deve usar os seguintes caracteres para indicar que a linha abaixo contém a resposta da questão: =====",
    ui_nenhuma_questao_cadastrada_2b696d49: "Nenhum(a) questão cadastrada",
    ui_ao_deletar_esta_questao_ela_nao_estara_mais_dispon_a09d435b: "Ao deletar esta questão, ela não estará mais disponível no sistema",
    ui_deseja_marcar_essa_questao_como_b8074843: "Deseja marcar essa questão como",
    ui_defina_o_contexto_da_questao_4d71daea: "Defina o Contexto da Questão",
    ui_crie_uma_questao_utilizando_inteligencia_artificia_66097e93: "Crie uma questão utilizando inteligência artificial",
    ui_descreva_o_assunto_especifico_da_questao_b704a6ac: "Descreva o assunto específico da questão",
    ui_avancar_82625e8f: "Avançar",
    ui_essa_questao_foi_criada_por_ia_voce_deve_confirmar_74018da6: "Essa questão foi criada por IA. Você deve confirmar a qualidade da questão gerada.",
    ui_voce_tem_certeza_que_deseja_validar_esta_questao_9e34f2f8: "Você tem certeza que deseja validar esta questão?",
    ui_ao_confirmar_sera_redirecionado_para_a_pagina_de_b3319da3: "Ao confirmar, será redirecionado para a página de",
    ui_criar_questao_beccec03: "\"Criar Questão\"",
    ui_onde_podera_editar_seu_conteudo_como_desejar_10c9f36f: ", onde poderá editar seu conteúdo como desejar.",
    ui_ao_deletar_este_membro_ele_nao_tera_mais_acesso_ao_65edeccd: "Ao deletar este membro, ele não terá mais acesso ao sistema",
    ui_deletar_conteudo_654f6956: "Deletar conteúdo",
    ui_cadastrar_conteudo_419aa739: "Cadastrar Conteúdo",
    ui_cadastre_os_conteudos_do_seu_sistema_2deb6d86: "Cadastre os conteúdos do seu sistema",
    ui_nome_do_conteudo_103bd7e3: "Nome do conteúdo",
    ui_selecione_qual_sera_o_tipo_do_arquivo_5c78c931: "Selecione qual será o tipo do arquivo",
    ui_video_03e7e13e: "Vídeo",
    ui_upload_do_video_menor_do_que_200_mb_3a58957f: "Upload do Vídeo (Menor do que 200 Mb)",
    ui_pre_visualizacao_65cab02c: "Pré-visualização",
    ui_salvando_conteudo_03d904a8: "Salvando conteúdo",
    ui_cadastre_as_questoes_do_conteudo_c3aecc68: "Cadastre as questões do conteúdo",
    ui_nome_da_questao_fbe10cc2: "Nome da questão",
    ui_editar_conteudo_f001902a: "Editar Conteúdo",
    ui_upload_do_pdf_caso_seja_o_mesmo_nao_escolha_nenhum_2e4b8884: "Upload do PDF (Caso seja o mesmo, não escolha nenhum arquivo)",
    ui_upload_do_video_caso_seja_o_mesmo_nao_escolha_nenh_a0aacf5a: "Upload do Vídeo (Caso seja o mesmo, não escolha nenhum arquivo)",
    ui_upload_da_capa_do_video_caso_seja_o_mesmo_nao_esco_ba01a936: "Upload da Capa do Vídeo (Caso seja o mesmo, não escolha nenhum arquivo)",
    ui_seu_navegador_nao_suporta_o_elemento_de_video_05b48753: "Seu navegador não suporta o elemento de vídeo.",
    ui_edite_uma_questao_do_conteudo_5a52b2a7: "Edite uma questão do conteúdo",
    ui_editar_perguntas_9063b9f2: "Editar Perguntas",
    ui_nao_foi_possivel_encontrar_o_arquivo_080c0a5a: "Não foi possível encontrar o arquivo.",
    ui_questao_de_6a47d07b: "Questão de:",
    ui_ao_deletar_este_corretor_ele_nao_estara_mais_dispo_823c3f53: "Ao deletar este corretor, ele não estará mais disponível no sistema",
    ui_correcoes_redacoes_440ee433: "Correções Redações",
    ui_correcoes_dissertativas_926a5325: "Correções Dissertativas",
    ui_ao_desvincular_este_corretor_ele_nao_tera_mais_ace_2636a0a7: "Ao desvincular este corretor, ele não terá mais acesso as salas deste processo",
    ui_nenhum_corretor_encontrado_com_este_termo_6d600488: "Nenhum(a) corretor encontrado com este termo",
    ui_corrigira_quais_redacoes_9a93a9ff: "Corrigirá quais Redações?",
    ui_nenhuma_sala_selecionada_bf0df991: "Nenhum(a) sala selecionada",
    ui_nome_e_mail_senha_cpf_candidato_opcional_numero_da_dc2d93eb: "Nome; E-mail; Senha;CPF Candidato (Opcional);Número da Questão (Opcional); Salas (Opcional)",
    ui_para_o_corretor_deve_ser_especificado_um_ou_mais_c_6d982098: "Para o corretor, deve ser específicado um ou mais candidatos juntamento com o número da questão para correção da prova dissertativa, ou uma ou mais salas para correção de redação. As salas devem ser específicadas entre ',' , ou seja, se quiser que um corretor fique nas salas 1, 2 e 3, deve passar: 1,2,3",
    ui_ao_deletar_esta_atribuicao_o_elaborador_nao_tera_m_aedfe8f4: "Ao deletar esta atribuição, o elaborador não terá mais acesso a esta disciplina/demanda",
    ui_horario_invalido_6d7a8390: "Horário inválido",
    ui_salvando_demanda_f0fa62e8: "Salvando demanda",
    ui_gerenciar_demanda_d6f65913: "Gerenciar demanda",
    ui_ao_deletar_esta_demanda_ela_nao_estara_mais_dispon_c569a1d6: "Ao deletar esta demanda, ela não estará mais disponível no sistema",
    ui_edite_a_demanda_do_seu_sistema_ab251ef1: "Edite a demanda do seu sistema",
    ui_aqui_sao_listados_todas_as_questoes_da_demanda_0edb9c97: "Aqui são listados todas as questões da Demanda \"",
    ui_questoes_objetivas_d444777a: "Questões objetivas:",
    ui_questoes_dissertativas_8b8bb598: "Questões dissertativas:",
    ui_descritivo_a0d41125: "Descritivo:",
    ui_cadastre_uma_diagramacao_de_prova_e9cacaf0: "Cadastre uma diagramação de prova",
    ui_nenhuma_prova_encontrada_para_diagramar_8d13fd70: "Nenhum(a) prova encontrada para diagramar",
    ui_trazer_as_questoes_diagramadas_do_padrao_seleciona_840f3d1d: "Trazer as questões diagramadas do padrão selecionado?",
    ui_instrucoes_7961e863: "Instruções",
    ui_numero_de_colunas_das_instrucoes_d22515a8: "Número de colunas das instruções",
    ui_salvando_diagramacao_303cdc1f: "Salvando diagramação",
    ui_instrucoes_gerais_e7875311: "INSTRUÇÕES GERAIS",
    ui_realizacao_898ecc72: "Realização",
    ui_pagina_b3a7f96a: "Página",
    ui_nova_diagramacao_3f8a792f: "Nova Diagramação",
    ui_cadastre_a_primeira_diagramacao_deste_processo_921ee032: "Cadastre a primeira diagramação deste processo.",
    ui_ao_deletar_esta_diagramacao_ele_nao_estara_mais_di_596f476a: "Ao deletar esta diagramação, ele não estará mais disponível no sistema",
    ui_aqui_ficam_as_respostas_da_prova_db6a9721: "Aqui ficam as respostas da prova \"",
    ui_ao_desvincular_este_prova_ele_nao_tera_mais_acesso_b74083f3: "Ao desvincular este prova, ele não terá mais acesso a este processo",
    ui_edite_uma_diagramacao_de_prova_6fc036bd: "Edite uma diagramação de prova",
    ui_modulo_nao_habilitado_f5792cfe: "Módulo não habilitado",
    ui_visualizar_diagramacao_b0136eb9: "Visualizar diagramação",
    ui_diagramacao_de_prova_do_aluno_a8bb0ec6: "Diagramação de prova do aluno",
    ui_nenhum_download_registrado_6211f004: "Nenhum(a) download registrado",
    ui_candidatos_da_entrevista_a9e44072: "Candidatos da Entrevista",
    ui_avaliacao_b83b6158: "Avaliação",
    ui_inicio_3ea3dd6c: "Início:",
    ui_nenhum_candidato_foi_vinculado_a_entrevista_1a26c285: "Nenhum(a) candidato foi vinculado à entrevista.",
    ui_ao_desvincular_este_entrevista_ele_nao_tera_mais_a_3e116a66: "Ao desvincular este entrevista, ele não terá mais acesso a este processo",
    ui_horario_de_inicio_701ca30c: "Horário de início",
    ui_criterios_5fb45232: "Critérios:",
    ui_cadastrar_entrevista_2914b77a: "Cadastrar entrevista",
    ui_topicos_0e1d8c1b: "Tópicos",
    ui_remover_topico_e918d570: "Remover tópico",
    ui_remover_criterio_ae4a7cae: "Remover critério",
    ui_editar_entrevista_19c99dac: "Editar entrevista",
    ui_nenhuma_entrevista_encontrada_3eed3914: "Nenhum(a) entrevista encontrada",
    ui_ao_deletar_esta_entrevista_ele_nao_estara_mais_dis_2a6785b8: "Ao deletar esta entrevista, ele não estará mais disponível para os candidatos responde-lá",
    ui_topicos_e6378334: "Tópicos:",
    ui_configure_os_modulos_e_funcionalidades_disponiveis_208f88ed: "Configure os módulos e funcionalidades disponíveis para os candidatos",
    ui_configuracoes_salvas_com_sucesso_6f4c5595: "Configurações salvas com sucesso!",
    ui_ativacao_de_modulos_e_funcionalidades_d3a0ba81: "Ativação de Módulos e Funcionalidades",
    ui_nenhum_modulo_disponivel_018261fe: "Nenhum(a) módulo disponível",
    ui_nao_existem_modulos_disponiveis_para_configuracao_43292f9a: "Não existem módulos disponíveis para configuração.",
    ui_total_candidatos_878e3013: "Total candidatos",
    ui_candidatos_que_fizeram_login_14f0d12d: "Candidatos que fizeram login",
    ui_candidatos_que_acessaram_a_tela_de_termos_e9f9141c: "Candidatos que acessaram a tela de termos",
    ui_candidatos_que_acessaram_a_tela_de_avaliacao_nao_i_a41a4375: "Candidatos que acessaram a tela de avaliação não iniciada",
    ui_candidatos_que_acessaram_a_tela_de_aceite_de_regra_da5f04ad: "Candidatos que acessaram a tela de aceite de regras",
    ui_candidatos_que_acessaram_a_tela_de_avaliacao_em_an_1b4c8a44: "Candidatos que acessaram a tela de avaliação em andamento",
    ui_candidatos_que_acessaram_a_tela_de_avaliacao_final_7987b18b: "Candidatos que acessaram a tela de avaliação finalizada",
    ui_candidatos_ausentes_906899d3: "Candidatos ausentes",
    ui_candidatos_que_acessaram_e_nao_finalizaram_fe2f36f7: "Candidatos que acessaram e não finalizaram",
    ui_candidatos_que_acessaram_e_finalizaram_c9793b24: "Candidatos que acessaram e finalizaram",
    ui_descicao_8a9d0ffe: "Descição:",
    ui_nao_iniciado_79f0570c: "Não iniciado",
    ui_opcoes_de_relatorio_b2f110b8: "Opções de relatório:",
    ui_candidatos_avaliadores_online_639e532c: "Candidatos/Avaliadores online",
    ui_analises_faciais_5ef2980a: "Análises faciais",
    ui_analises_objetos_7b70af86: "Análises objetos",
    ui_analises_movimento_facial_9f470e32: "Análises Movimento Facial",
    ui_candidatos_online_por_sala_c4a7fb6b: "Candidatos Online por Sala:",
    ui_candidatos_online_fe6d8bc6: "Candidatos Online",
    ui_nenhum_avaliador_online_vinculado_a_este_cargo_85e7dc18: "Nenhum(a) avaliador online vinculado a este cargo",
    ui_nenhum_a_13fdab50: "Nenhum(a)",
    ui_cadastre_a_primeira_para_comecar_6d5dc4dd: "Cadastre a primeira para começar.",
    ui_ao_deletar_esta_faculdade_ela_nao_estara_mais_disp_09656d24: "Ao deletar esta faculdade, ela não estará mais disponível no sistema",
    ui_responsavel_dac53a5e: "Responsável:",
    ui_voltar_para_cd10d454: "← Voltar para",
    ui_instituicao_criada_em_8e333c6a: "Instituição criada em",
    ui_ao_deletar_este_fiscal_ele_nao_estara_mais_disponi_ba3bc4ca: "Ao deletar este fiscal, ele não estará mais disponível no sistema",
    ui_nenhum_fiscal_encontrado_com_este_termo_7c6340f3: "Nenhum(a) fiscal encontrado com este termo",
    ui_nenhum_fiscal_selecionado_b8684c0e: "Nenhum(a) fiscal selecionado",
    ui_ao_desvincular_este_fiscal_ele_nao_tera_mais_acess_05fc2cf3: "Ao desvincular este fiscal, ele não terá mais acesso a este processo",
    ui_nome_e_mail_senha_tipo_fiscal_coordenador_ou_fisca_3df45539: "Nome; E-mail; Senha; Tipo (fiscal_coordenador ou fiscal_normal); Salas",
    ui_as_salas_devem_ser_especificadas_entre_ou_seja_se__164c8379: "As salas devem ser específicadas entre ',' , ou seja, se quiser que um fiscal fique nas salas 1, 2 e 3, deve passar: 1,2,3",
    ui_nenhum_fiscal_adicionado_151a84e5: "Nenhum(a) fiscal adicionado",
    ui_cadastrar_membro_da_equipe_02c4e5d7: "Cadastrar Membro da Equipe",
    ui_editar_membro_da_equipe_9c426afb: "Editar Membro da Equipe",
    ui_cadastrar_modulo_a9b6ba58: "Cadastrar Módulo",
    ui_nenhum_conteudo_encontrado_com_este_termo_a1a14166: "Nenhum(a) conteúdo encontrado com este termo",
    ui_conteudos_vinculados_7adf15fe: "Conteúdos vinculados",
    ui_salvando_modulo_c5640cd0: "Salvando módulo",
    ui_editar_modulo_cead4a60: "Editar Módulo",
    ui_edite_um_modulo_do_seu_sistema_435e4985: "Edite um módulo do seu sistema",
    ui_cadastrar_organizadora_6386ed45: "Cadastrar Organizadora",
    ui_dados_do_usuario_549a26c8: "Dados do usuário",
    ui_editar_organizadora_54d2b6d8: "Editar Organizadora",
    ui_nenhuma_organizadora_encontrada_f5da8ee0: "Nenhum(a) organizadora encontrada",
    ui_ao_deletar_esta_organizadora_ela_nao_tera_mais_ace_05022d02: "Ao deletar esta organizadora, ela não terá mais acesso ao sistema",
    ui_e_suas_regras_9951434d: "e suas regras.",
    ui_a_avaliacao_e_online_63f6668d: "A avaliação é online?",
    ui_e_um_avaliacao_oral_031e9629: "É um avaliação oral?",
    ui_se_habilitado_esta_vaga_cargo_sera_uma_entrevista__b2e828a7: "Se habilitado, esta vaga/cargo será uma entrevista (avaliação oral) com os candidatos vinculados a ele, onde será possível cadastrar os critérios de avaliação e quem serão os avaliadores. Cada avaliador poderá entrar em chamadas individuais com cada candidato.",
    ui_e_um_simulado_para_teste_de_compatibilidade_dos_ca_be36cb46: "É um simulado para teste de compatibilidade dos candidatos?",
    ui_se_habilitado_essa_vaga_cargo_sera_um_teste_para_o_6222b09d: "Se habilitado, essa vaga/cargo será um teste para os candidatos conseguirem acessar o sistema e testar funções como compartilhamento de câmera/áudio/tela. Será gerado também uma prova teste dentro da vaga/cargo.",
    ui_cada_avaliacao_tera_um_tempo_maximo_para_fazer_e0de075c: "Cada avaliação terá um tempo máximo para fazer?",
    ui_se_habilitado_na_hora_de_criar_a_prova_sera_obriga_8f8b7f7f: "Se habilitado, na hora de criar a prova será obrigatório definir o tempo, em minutos, que cada questão terá para ser respondida. Caso não queira que tenha tempo por questão, desabilite-a.",
    ui_o_candidato_podera_solicitar_pausa_durante_a_prova_6d5871fc: "O candidato poderá solicitar pausa durante a prova?",
    ui_se_habilitado_e_exibilido_um_botao_de_pedir_pausa__a63c10d6: "Se habilitado, é exibilido um botão de \"Pedir Pausa\" do lado do candidato, onde ele poderá solicitar pausas durante a prova com uma justificativa, por exemplo: preciso ir ao banheiro, preciso amamentar, etc. O fiscal vinculado a sala daquele candidato deverá aceitar ou negar a pausa solicitada.",
    ui_o_candidato_podera_acessar_por_dispositivos_moveis_f529a234: "O candidato poderá acessar por dispositivos móveis?",
    ui_se_habilitado_a_avaliacao_tambem_podera_ser_realiz_ccf181b9: "Se habilitado, a avaliação também poderá ser realizada por dispositivos móveis, porém algumas funções não poderão ser habilitadas, sendo estas: Gravação de tela e Validação facial.",
    ui_disponibilizar_campo_para_rascunho_em_cada_questao_59890895: "Disponibilizar campo para rascunho em cada questão?",
    ui_se_habilitado_em_cada_questao_tera_um_botao_de_ras_29b1be64: "Se habilitado, em cada questão terá um botão de rascunho para o candidato, onde será aberto um caixa de texto para o candidato escrever. O rascunho não é salvo pelo sistema.",
    ui_obrigar_o_uso_de_tela_cheia_para_ver_a_avaliacao_81575207: "Obrigar o uso de tela cheia para ver a avaliação?",
    ui_se_habilitado_o_candidato_so_conseguira_fazer_a_av_c5c6d2f3: "Se habilitado, o candidato só conseguirá fazer a avaliação com o sistema em tela cheia. Caso ele saia da tela cheia, o sistema registro como saída de tela.",
    ui_tempo_de_prova_em_minutos_que_o_candidato_tera_apo_f25d6411: "Tempo de prova em minutos que o candidato terá após o primeiro acesso",
    ui_tempo_em_minuntos_anterior_a_avaliacao_que_deve_ap_6be44aeb: "Tempo em minuntos anterior a avaliação que deve aparecer para o candidato o chat de comunicação com o fiscal",
    ui_exemplo_caso_seja_colocado_60_minutos_entao_uma_ho_3f08b307: "Exemplo: Caso seja colocado 60 minutos, então uma hora antes do início da avaliação aparecerá para o candidato o chat de comunicação onde é possível enviar e receber mensagens dos fiscais.",
    ui_se_habilitada_o_candidato_so_conseguira_acessar_a__104a32e1: "Se habilitada o candidato só conseguirá acessar a prova caso tenha sido identificado um rosto (apenas um) na imagem de sua câmera, e será necessário ele fazer movimentos para a esquerda e direita com a cabeça para validar sua entrada. Será necessário o candidato falar uma frase para ser validado o microfone.",
    ui_tempo_em_minuntos_anterior_a_avaliacao_que_deve_ap_018422a2: "Tempo em minuntos anterior a avaliação que deve aparecer para o candidato um botão de pedir liberação para o fiscal",
    ui_exemplo_caso_seja_colocado_60_minutos_entao_uma_ho_333a557f: "Exemplo: Caso seja colocado 60 minutos, então uma hora antes do início da avaliação aparecerá um botão para o candidato pedir liberação para o fiscal, caso ele não consiga completar a validação facial.",
    ui_se_habilitada_caso_apos_o_candidato_acessar_a_aval_76209b26: "Se habilitada, caso após o candidato acessar a avaliação não ser detecado um rosto na câmera ou oscilação de áudio no microfone por um determinado tempo, o candidato deverá realizar a validação novamente (Apenas se o candidato não tenha sido liberado pelo fiscal).",
    ui_tempo_sem_reconhecimento_para_o_candidato_ter_que__36fb327b: "Tempo sem reconhecimento para o candidato ter que realizar a validação facial novamente (Em segundos)",
    ui_restringir_horario_de_acesso_do_candidato_ff671aed: "Restringir horário de acesso do candidato?",
    ui_candidatos_que_nao_tiverem_acessado_o_sistema_dent_db3aa123: "Candidatos que não tiverem acessado o sistema dentro de um determinado horário, não conseguiram acessar a prova",
    ui_horario_inicial_do_intervalo_dbb8ab8c: "Horário inicial do intervalo",
    ui_data_de_encerramento_do_intervalo_ca148297: "Data de encerramento do intervalo",
    ui_o_evento_sera_dividido_em_blocos_d2406ebe: "O evento será dividido em blocos?",
    ui_caso_sim_e_possivel_definir_o_tempo_de_cada_bloco__e1f7d3b8: "Caso sim, é possível definir o tempo de cada bloco, e um tempo de intervalo.",
    ui_ao_deletar_este_processo_ele_nao_estara_mais_dispo_d822045c: "Ao deletar este processo, ele não estará mais disponível no sistema",
    ui_ao_deletar_este_elaborador_ele_nao_tera_mais_acess_c6438fc1: "Ao deletar este elaborador, ele não terá mais acesso ao sistema",
    ui_cadastrar_prova_05e853e9: "Cadastrar prova",
    ui_configuracoes_adicionais_0d9c9733: "Configurações adicionais",
    ui_ordem_das_questoes_d3f085f2: "Ordem das questões",
    ui_selecao_das_questoes_c85b2f2d: "Seleção das questões",
    ui_forma_de_aleatorizacao_499ad86d: "Forma de aleatorização",
    ui_numero_de_questoes_que_devem_ser_selecionadas_c940b4a7: "Número de questões que devem ser selecionadas",
    ui_numero_de_questoes_que_devem_ser_selecionadas_def12a81: "Número de questões que devem ser selecionadas:",
    ui_exibicao_das_questoes_8463a65b: "Exibição das questões",
    ui_definir_um_numero_maximo_de_provas_aleatorias_gera_78fd6056: "Definir um número máximo de provas aleatórias geradas?",
    ui_numero_de_provas_geradas_5c4213f8: "Número de provas geradas:",
    ui_numero_de_provas_que_vao_ser_geradas_ebe3dc3e: "Número de provas que vão ser geradas",
    ui_o_candidato_podera_retornar_para_a_questao_anterio_9d388b4d: "O candidato poderá retornar para a questão anterior após avançar para a próxima?",
    form_auto_advance_on_answer_question: "Ao responder, avançar automaticamente para a próxima questão?",
    form_auto_advance_on_answer_yes: "Sim, avançar e bloquear a alteração da resposta",
    form_auto_advance_on_answer_no: "Não, manter o candidato na questão atual",
    form_show_answer_map_question: "Mostrar mapa de respostas durante a prova?",
    description_show_answer_map: "Se desativado, o candidato não verá o resumo das questões respondidas acima da questão atual.",
    form_finished_result_visibility: "Ao final da prova, exibir",
    form_finished_result_answer_sheet: "Folha de resposta do candidato",
    form_finished_result_accuracy_sheet: "Relação de acertos e erros",
    form_finished_result_answer_and_accuracy: "Folha de resposta com relação de acertos e erros",
    form_finished_result_exam_booklet: "Caderno de prova",
    form_finished_result_exam_booklet_correct: "Caderno de prova com gabarito",
    form_finished_result_exam_booklet_candidate: "Caderno de prova com gabarito e respostas do candidato",
    form_allow_download_answer_and_accuracy_sheet: "Download da folha de resposta com acertos e erros",
    form_finished_result_none: "Nenhuma das opções",
    form_finished_result_mirror: "Caderno de prova",
    description_finished_result_mirror: "Mostra o espelho do caderno com questões, alternativas e as regras de acerto configuradas.",
    form_finished_result_period: "Período de exibição ao candidato",
    description_finished_result_period: "Deixe vazio para liberar a exibição imediatamente e sem data final.",
    form_finished_result_downloads: "Permitir download",
    form_allow_download_answer_sheet: "Download da folha de resposta",
    form_allow_download_accuracy_sheet: "Download da relação de acertos e erros",
    form_allow_download_mirror: "Download do caderno de prova",
    legacy_prova_dissertativa: "Prova dissertativa",
    exam_options_summary_eyebrow: "Configurações",
    exam_options_summary_title: "Opções selecionadas na criação da prova",
    exam_options_summary_description: "Resumo das regras de exibição, organização, resultado e downloads configuradas para esta prova.",
    exam_options_basic: "Dados da prova",
    exam_options_randomization: "Organização das questões",
    exam_options_candidate_view: "Visualização do candidato",
    exam_options_one_question: "Uma questão por vez",
    exam_options_all_questions: "Todas as questões",
    exam_options_exam_time: "Tempo de prova",
    exam_options_use_exam_models: "Usar modelos de prova",
    exam_options_exam_models_count: "Número de modelos",
    exam_options_shuffle_questions: "Aleatorizar questões",
    exam_options_shuffle_alternatives: "Aleatorizar alternativas",
    exam_options_select_from_group: "Selecionar por grupo",
    exam_options_random_by_subject: "Sorteio por disciplina",
    exam_options_block_return_after_pause: "Bloquear retorno após pausa",
    exam_options_immediate_display: "Exibição imediata, sem prazo final",
    exam_options_no_downloads: "Nenhum download habilitado para esta opção",
    ui_bloquear_de_alterar_respostas_de_questoes_ja_vista_aaa83af2: "Bloquear de alterar respostas de questões já vistas após uma soliciitação de pausa?",
    ui_tempo_por_questao_em_minutos_5407240a: "Tempo por questão em minutos",
    ui_tempo_por_questao_eaffb704: "Tempo por questão",
    ui_selecionar_todas_as_questoes_desta_disciplina_7d72b315: "Selecionar todas as questões desta disciplina",
    ui_selecionar_questoes_por_palavra_chave_76d0ed50: "Selecionar questões por palavra chave",
    ui_nenhuma_questao_encontrada_com_este_termo_69f1b489: "Nenhum(a) questão encontrada com este termo",
    ui_editar_prova_097be7e1: "Editar prova",
    ui_bloquear_de_alterar_respostas_de_questoes_ja_vista_cb647283: "Bloquear de alterar respostas de questões já vistas após uma solicitação de pausa?",
    ui_buscar_questoes_da_disciplina_93831202: "Buscar questões da disciplina",
    ui_salvando_questoes_187c0279: "Salvando questões",
    ui_gerencie_as_provas_vinculadas_ao_processo_5ce1abb6: "Gerencie as provas vinculadas ao processo",
    ui_ao_deletar_esta_prova_ele_nao_estara_mais_disponiv_7c8cffac: "Ao deletar esta prova, ele não estará mais disponível para os candidatos responde-lá",
    ui_aqui_ficam_as_questoes_da_prova_62cf730a: "Aqui ficam as questões da prova \"",
    ui_cadastrar_questionario_c27e40cd: "Cadastrar Questionário",
    ui_cadastre_um_novo_questionario_no_sistema_9b7d9485: "Cadastre um novo questionário no sistema",
    ui_ver_questionario_08339686: "Ver questionário",
    ui_salvando_questionario_446add5a: "Salvando questionário",
    ui_edite_um_questionario_do_sistema_9c25790b: "Edite um questionário do sistema",
    ui_cadastrar_pergunta_do_questionario_21b5431b: "Cadastrar Pergunta do Questionário",
    ui_paragrafo_1c4bc2b2: "Parágrafo",
    ui_nao_e_obrigatorio_4b5bab2b: "Não é obrigatório",
    ui_obrigatorio_se_assinalado_59d615fd: "Obrigatório se assinalado \"(",
    ui_gerenciar_questionario_4cf424e3: "Gerenciar questionário",
    ui_deletar_questionario_44d0f59c: "Deletar questionário",
    ui_ao_deletar_este_questionario_ela_nao_estara_mais_d_523483a1: "Ao deletar este questionário, ela não estará mais disponível no sistema",
    ui_vincular_questionario_s_0c995c4c: "Vincular Questionário(s)",
    ui_vincule_um_ou_mais_questionarios_ao_processo_a186a3eb: "Vincule um ou mais questionários ao processo",
    ui_onde_o_questionario_ira_aparecer_be82f196: "Onde o questionário irá aparecer?",
    ui_pesquise_o_questionario_pelo_nome_ab3d430c: "Pesquise o questionário pelo nome",
    ui_nenhum_questionario_encontrado_com_este_termo_a4b1cd9f: "Nenhum(a) questionário encontrado com este termo",
    ui_questionarios_selecionados_6a604e81: "Questionários selecionados",
    ui_desvincular_questionario_ac6d9747: "Desvincular questionário",
    ui_nenhum_questionario_selecionado_d6a1afb8: "Nenhum(a) questionário selecionado",
    ui_salvando_questionarios_0ee57d98: "Salvando questionários",
    ui_gerencie_os_questionarios_vinculados_ao_processo_10b384f8: "Gerencie os questionários vinculados ao processo",
    ui_adicionar_questionarios_2a88af71: "Adicionar Questionários",
    ui_vincule_o_primeiro_questionario_ao_processo_958376ac: "Vincule o primeiro questionário ao processo.",
    ui_ao_desvincular_este_questionario_ele_nao_estara_ma_574217ce: "Ao desvincular este questionário, ele não estará mais disponível neste processo",
    ui_aqui_ficam_as_respostas_do_questionario_1755792c: "Aqui ficam as respostas do questionario \"",
    ui_aqui_ficam_as_questoes_do_questionario_264de9be: "Aqui ficam as questões do questionário \"",
    ui_aqui_ficam_as_atribuicoes_da_demanda_25de260e: "Aqui ficam as atribuições da demanda \"",
    ui_gerenciar_atribuicao_224a10c0: "Gerenciar atribuição",
    ui_deletar_atribuicao_ae0a77d8: "Deletar atribuição",
    ui_ao_deletar_esta_atribuicao_o_elaborador_nao_tera_m_55bce2dd: "Ao deletar esta atribuição, o elaborador não terá mais acesso a esta categoria/demanda",
    ui_questao_avaliada_com_sucesso_55663755: "Questão avaliada com sucesso!",
    ui_carregando_comentarios_c260c035: "Carregando comentários...",
    ui_escreva_seu_comentario_aqui_c2486f14: "Escreva seu comentário aqui...",
    ui_enviar_avaliacao_629e5d59: "Enviar Avaliação",
    ui_adicione_edite_atribuicoes_a_demanda_d174b85f: "Adicione/Edite atribuições à demanda \"",
    ui_numero_de_questoes_2fb10acf: "Número de questões:",
    ui_cadastre_um_recurso_de_uma_questao_do_seu_sistema_62fc3a72: "Cadastre um recurso de uma questão do seu sistema",
    ui_busque_a_questao_da_disciplina_55512db0: "Busque a questão da disciplina",
    ui_nome_do_responsavel_df1f0fe8: "Nome do responsável:",
    ui_e_mail_do_responsavel_6f9ed412: "E-mail do responsável:",
    ui_edite_um_recurso_de_uma_questao_do_seu_sistema_4692e136: "Edite um recurso de uma questão do seu sistema",
    ui_nao_especificar_ddfc6e39: "Não especificar",
    ui_ao_deletar_este_recurso_ela_nao_estara_mais_dispon_0ccc7650: "Ao deletar este recurso, ele não estará mais disponível no sistema",
    ui_avaliacao_de_questao_27fd4ee1: "Avaliação de questão",
    ui_dados_da_questao_e4f73f31: "Dados da questão",
    ui_data_de_criacao_b8ae5b5f: "Data de Criação:",
    ui_demanda_relacionada_e62c1518: "Demanda Relacionada:",
    ui_o_campo_comentario_e_obrigatorio_2d86054e: "O campo Comentário é obrigatório",
    ui_caso_a_questao_tenha_sido_editada_ela_so_sera_salv_2b9818fb: "Caso a questão tenha sido editada, ela só será salva ao enviar a avaliação.",
    ui_descricao_dos_fatos_e3186d0b: "Descrição dos fatos:",
    ui_cadastre_as_redacoes_cd8d699e: "Cadastre as redações",
    ui_salvando_redacao_2875125c: "Salvando redação",
    ui_edite_uma_redacao_f80c5cfb: "Edite uma redação",
    ui_gerencie_as_redacoes_vinculadas_ao_processo_9e0682a4: "Gerencie as redações vinculadas ao processo",
    ui_nova_redacao_f7f8f71a: "Nova Redação",
    ui_cadastre_a_primeira_redacao_deste_processo_7b43c0f0: "Cadastre a primeira redação deste processo.",
    ui_ao_deletar_esta_redacao_ele_nao_estara_mais_dispon_1440dab3: "Ao deletar esta redação, ele não estará mais disponível para os candidatos responde-lá",
    ui_todas_as_redacoes_devem_estar_no_formato_png_ou_jp_48fe5b0b: "Todas as redações devem estar no formato .png ou .jpg, sendo o número de inscrição o nome da imagem, e todas compactadas em um arquivo .zip/.rar, que pode ser selecionado abaixo.",
    ui_salvando_redacoes_0ec9631b: "Salvando redações",
    ui_aqui_ficam_as_respostas_da_redacao_d8e417d4: "Aqui ficam as respostas da redação \"",
    ui_ao_desvincular_este_redacao_ele_nao_tera_mais_aces_ea522608: "Ao desvincular este redacao, ele não terá mais acesso a este processo",
    ui_aqui_ficam_as_correcoes_da_redacao_1feaced4: "Aqui ficam as correções da redação \"",
    ui_realizadas_por_inteligencia_artificial_e9b909ee: "\" realizadas por inteligência artificial",
    ui_ir_para_progresso_da_correcao_94b462b0: "Ir Para Progresso da Correção",
    ui_imprimir_template_da_redacao_42731392: "Imprimir template da redação",
    ui_aqui_ficam_os_textos_de_apoio_da_redacao_f7a787bd: "Aqui ficam os textos de apoio da redação \"",
    ui_ao_desvincular_este_texto_ele_nao_tera_mais_acesso_0fb3b0af: "Ao desvincular este texto, ele não terá mais acesso as textos deste processo",
    ui_baixe_relatorios_gerais_d7ab5b34: "Baixe relatórios gerais",
    ui_candidatos_62b9af6b: "candidatos",
    ui_nenhuma_sala_foi_vinculada_a_este_processo_cc8c090a: "Nenhum(a) sala foi vinculada a este processo.",
    ui_ao_desvincular_este_sala_ele_nao_tera_mais_acesso__15f445ac: "Ao desvincular este sala, ele não terá mais acesso as salas deste processo",
    ui_aqui_ficam_os_candidatos_da_sala_609742e7: "Aqui ficam os candidatos da Sala \"",
    ui_aqui_ficam_os_fiscais_da_sala_b90de17f: "Aqui ficam os fiscais da Sala \"",
    ui_aqui_ficam_os_corretores_da_sala_2997b757: "Aqui ficam os corretores da Sala \"",
    ui_cadastrar_treinamento_4f504c6b: "Cadastrar Treinamento",
    ui_nenhum_modulo_encontrado_com_este_termo_40aad181: "Nenhum(a) módulo encontrado com este termo",
    ui_nenhum_usuario_encontrado_07e706e0: "Nenhum(a) usuário encontrado.",
    ui_editar_treinamento_2a8da4ce: "Editar Treinamento",
    ui_editar_treinamento_modulos_e4254df3: "Editar Treinamento/Módulos",
    ui_nenhum_modulo_cadastrado_f4cff322: "Nenhum(a) módulo cadastrado",
    ui_nenhum_treinamento_cadastrado_1114c17b: "Nenhum(a) treinamento cadastrado",
    ui_periodo_9d2b2bb8: "Período",
    ui_nenhum_treinamento_encontrado_327ab048: "Nenhum(a) treinamento encontrado",
    ui_aqui_estao_listados_todos_os_treinamentos_do_seu_s_066f2573: "Aqui estão listados todos os treinamentos do seu sistema",
    ui_nenhum_treinamento_encontrado_com_este_termo_01f25665: "Nenhum(a) treinamento encontrado com este termo",
    ui_videos_da_tela_6e150a3a: "Vídeos da Tela",
    ui_gerenciar_candidatos_a4e149c2: "Gerenciar candidatos",
    ui_acessar_configuracoes_e95ce866: "Acessar configurações",
    ui_gerencie_avaliadores_00986d21: "Gerencie avaliadores",
    ui_avaliacao_oral_f015a022: "Avaliação Oral",
    ui_configuracoes_da_avaliacao_oral_f1c2d588: "Configurações da avaliação oral",
    ui_antes_de_iniciar_a_avaliacao_1026e291: "Antes de iniciar a avaliação",
    ui_durante_a_avaliacao_b2e19d2f: "Durante a avaliação",
    ui_apos_finalizada_a_avaliacao_4f08017f: "Após finalizada a avaliação",
    ui_acompanhe_os_resultados_do_questionario_b2346d60: "Acompanhe os resultados do questionário.",
    ui_lista_os_candidatos_que_acessaram_a_plataforma_2258f573: "Lista os candidatos que acessaram a plataforma.",
    ui_lista_quem_concedeu_permissoes_e_chegou_na_tela_de_47155e81: "Lista quem concedeu permissões e chegou na tela de avaliação não iniciada.",
  },
  en: {
    title_link_candidates: "Link candidates",
    title_link_proctors: "Link proctors",
    description_link_proctors: "Link one or more proctors to the process",
    description_link_graders: "Link one or more graders to the process",
    label_images: "Images",
    label_messages: "Messages",
    description_candidate_messages: "View the messages sent during the process.",
    action_import_csv: "Import CSV",
    action_add_graders: "Add graders",
    action_add_grader: "Add grader",
    action_add_image: "Add image",
    action_add_video: "Add video",
    action_delete_image: "Delete image",
    action_delete_video: "Delete video",
    action_delete_candidate: "Delete candidate",
    action_delete_proctor: "Delete proctor",
    action_delete_grader: "Delete grader",
    action_delete_room: "Delete room",
    action_unlink_grader: "Unlink grader",
    action_select_all_rooms: "Select all rooms",
    action_previous: "Previous",
    loading_generating_zip: "Generating ZIP...",
    loading_saving_proctors: "Saving proctors",
    loading_saving_graders: "Saving graders",
    label_first_login: "First access",
    status_never_accessed: "Never accessed the system",
    status_in_progress: "In progress",
    status_execution_error: "Execution error",
    title_add_proctors_to_process: "Add proctors to process",
    title_add_graders_to_process: "Add graders to process",
    label_candidate_cpf: "Candidate CPF",
    option_generate_random_email: "Generate a random email when it is not found in the spreadsheet",
    label_birth_date_iso: "Birth date (YYYY-MM-DD)",
    label_cpf_digits_only: "CPF (digits only)",
    label_photo_link: "Photo link",
    candidate_documents: "Documents",
    candidate_documents_description: "View the candidate's profile, acceptance, and submitted document photos.",
    candidate_profile_photo: "User photo",
    candidate_acceptance_photo: "Photo taken on the acceptance screen",
    candidate_document_photos: "Document photos",
    candidate_document_composition: "Submitted composition",
    no_candidate_documents: "No documents found",
    no_candidate_documents_description: "Candidate and document photos will appear here when available.",
    face_photo: "Face photo",
    document_photo: "Document photo",
    sent_composition: "Submitted composition",
    click_to_zoom: "Click to enlarge and zoom",
    zoom_in: "Zoom in",
    zoom_out: "Zoom out",
    label_error: "Error",
    label_success: "Success",
    error_loading_modules: "Error loading modules",
    error_saving_settings: "Error saving settings",
    error_processing_server_response: "Error processing the server response",
    error_connecting_server: "Error connecting to the server",
    error_saving_permissions_prefix: "Error saving",
    error_saving_permissions_middle: "of",
    error_saving_permissions_suffix: "permissions",
    settings_student_portal: "Student portal",
    settings_student_portal_description: "Portal where students access information about the selection process.",
    settings_notice: "Notice",
    settings_results: "Results",
    action_view_exam_external: "View exam externally",
    description_exam_results: "Track this exam results.",
    description_show_exam_page: "Here you can view the exam questions and results.",
    description_show_essay_page: "Here you can view the essay support texts and results.",
    settings_appeals: "Appeals",
    settings_question_appeals: "Question appeals",
    label_time_milliseconds: "Time in milliseconds (ms)",
    action_release_reset_candidate_access: "Release or reset candidate access",
    title_system_logs: "System logs",
    label_from: "From",
    label_indexes: "Indexes",
    label_photos_without_face: "Photos with no face detected",
    process_summary_title: "Configuration summary",
    summary_identification: "Identification",
    summary_not_informed: "Not provided",
    summary_not_informed_yet: "Not provided yet",
    summary_filled_feminine: "Completed",
    summary_filled_plural: "Completed",
    summary_pending_plural: "Pending",
    summary_not_applicable: "Not applicable",
    summary_modality: "Modality",
    summary_assessment: "Assessment",
    summary_online: "Online",
    summary_in_person: "In person",
    summary_oral_assessment: "Oral assessment",
    summary_simulation: "Simulation",
    summary_compatibility: "Compatibility",
    summary_block_exam: "Block-based exam",
    summary_schedule: "Schedule",
    summary_start: "Start",
    summary_time: "Time",
    summary_restricted_after_access: "Restricted after access",
    summary_total_time: "Total time",
    summary_restricted_duration: "Restricted duration",
    summary_time_per_question: "Time per question",
    summary_required: "Required",
    summary_required_feminine: "Required",
    summary_disabled: "Disabled",
    summary_disabled_feminine: "Disabled",
    summary_optional: "Optional",
    summary_proctoring: "Proctoring",
    summary_chat: "Chat",
    summary_chat_before_exam: "Chat before the exam",
    summary_full_screen: "Full screen",
    summary_multiple_monitors: "Multiple monitors",
    summary_blocked_plural: "Blocked",
    summary_allowed_plural: "Allowed",
    summary_share_screen: "Screen sharing",
    summary_external_camera: "External camera",
    summary_not_required: "Not required",
    summary_validations: "Validations",
    summary_face_microphone: "Face and microphone",
    summary_on_entry: "On entry",
    summary_document: "Document",
    summary_release_button: "Release button",
    summary_minutes_before: "min before",
    summary_periodic_validation: "Periodic validation",
    summary_without_recognition: "without recognition",
    summary_candidate_resources: "Candidate resources",
    summary_mobile: "Mobile",
    summary_allowed: "Allowed",
    summary_blocked: "Blocked",
    summary_pauses: "Pauses",
    summary_allowed_feminine_plural: "Allowed",
    summary_blocked_feminine_plural: "Blocked",
    summary_scratchpad: "Scratchpad",
    summary_available: "Available",
    summary_unavailable: "Unavailable",
    summary_access: "Access",
    summary_time_restriction: "Time restriction",
    summary_active_feminine: "Active",
    summary_no_restriction: "No restriction",
    summary_allowed_period: "Allowed period",
    summary_until: "until",
    summary_define_time: "Set the time",
    unit_minutes: "minutes",
    unit_minutes_short: "min",
    unit_seconds_short: "s",
    form_exam_time: "Exam time",
    form_candidate_total_time: "Candidate can use the full exam time",
    form_candidate_restricted_time: "Candidate has a restricted exam time after access",
    form_exam_time_minutes: "Exam time in minutes",
    form_chat_type: "Chat type",
    form_capture_candidate_image_every: "Capture a candidate image every",
    form_block_multiple_extended_screens: "Block the use of two or more extended screens?",
    form_share_screen_simulation: "Require screen sharing for the test? (Simulates screen recording for use in a real exam)",
    form_record_candidate_screen: "Record the candidate's screen? (Requires screen sharing)",
    form_face_microphone_entry_question: "Use artificial intelligence for face and microphone validation on entry?",
    form_required_external_camera: "Require external camera?",
    description_required_external_camera: "When enabled, the candidate can only access and continue the assessment with the external camera connected from a phone.",
    form_record_before_exam_question: "Record candidate before the exam starts?",
    description_record_before_exam: "When enabled, recording starts before the scheduled start time and continues during validations, rules, and assessment.",
    form_record_before_exam_minutes: "Time before the start to begin recording (in minutes, maximum 30)",
    summary_record_before_exam: "Recording before start",
    summary_from_exam_start: "From exam start",
    form_face_microphone_periodic_question: "Perform face and microphone validation when they are not detected during the assessment?",
    form_access_interval_start_date: "Access interval start date",
    error_exam_start_after_access_start: "The exam start date and time must be after the access interval starts.",
    error_exam_end_after_access_end: "The exam end date and time must be after the access interval ends.",
    entity_process: "process",
    entity_vacancy_position: "vacancy/position",
    option_proctoring_video_image_stream: "Save video and images - With real-time streaming",
    option_proctoring_image_stream: "Save images only - With real-time streaming",
    option_proctoring_logs_only: "Save logs only - Without streaming",
    option_simulation_camera_audio: "Test camera and audio sharing",
    option_simulation_no_camera_audio: "Do not share camera and audio",
    option_chat_both: "Both can send messages",
    option_chat_proctor_only: "Only the proctor can send messages",
    option_chat_none: "No one can send messages",
    option_seconds_30: "30 seconds",
    option_seconds_15: "15 seconds",
    label_not_calculated: "Not calculated",
    title_blocks: "Blocks",
    description_manage_blocks: "Organize assessments and breaks",
    label_block: "Block",
    label_without_block: "No block",
    question_document_validation_on_entry: "Validate the candidate's document on entry?",
    description_document_validation_on_entry: "Compares the presented document with a photo of the candidate. Validation may also be performed by the proctor.",
    description_simulation_without_blocks: "Simulation processes cannot use blocks.",
    blocks_operation_error: "The operation could not be completed.",
    blocks_load_error: "Error loading blocks.",
    blocks_save_error: "Error saving the block.",
    blocks_delete_error: "Error deleting the block.",
    blocks_delete_confirm_prefix: "Delete",
    blocks_delete_confirm_suffix: "The assessments will be left without a block.",
    blocks_interval_description: "Break between assessments.",
    blocks_none_linked: "No assessments linked to this block.",
    blocks_selection_title: "Assessments in this block",
    blocks_transfer_description: "Selecting an assessment linked to another block will transfer it to this one.",
    empty_no_items_registered: "No items registered.",
    empty_state_default_description: "Review the filters or create a new item to continue.",
    empty_state_selection_description: "Add items to continue.",
    label_currently_in: "Currently in:",
    blocks_module_title: "Assessment blocks",
    blocks_module_description: "Organize exams, essays, questionnaires, and breaks in execution order.",
    blocks_linked_evaluations: "Linked assessments",
    blocks_empty_description: "Add the first block to organize this process's time and assessments.",
    label_order: "Order",
    action_add_block: "Add block",
    action_new_test: "New test",
    blocks_remaining_prefix: "There are still",
    blocks_remaining_suffix: "remaining to complete the assessment time.",
    blocks_exceeded_prefix: "The blocks exceed the assessment time by",
    label_exam_total: "Assessment total",
    label_distributed: "Allocated",
    label_type: "Type",
    block_type_assessment: "Exam block",
    block_type_interval: "Break block",
    label_block_type: "Block type",
    block_interval_no_evaluations: "Break blocks do not have linked exams, essays, or questionnaires.",
    placeholder_interval_name: "E.g.: Break",
    placeholder_block_name: "E.g.: Block 1",
    label_duration_minutes: "Duration in minutes",
    label_optional: "Optional",
    label_exam_total_time: "Total assessment time",
    label_already_distributed: "Already allocated",
    label_exceeded_time: "Exceeded time",
    label_remaining_after_save: "Remaining after saving",
    empty_no_blocks: "No blocks registered.",
    action_edit_block: "Edit block",
    action_delete_block: "Delete block",
    block_select_label: "Assessment block",
    block_select_option: "Select a block",
    block_select_empty: "First create an assessment block in the Blocks module.",
    empty_no_user_found: "No user found.",
    label_training_completed: "Completed the training",
    label_proctor: "Proctor",
    portal_candidate: "Candidate Portal",
    portal_evaluator: "Evaluator Portal",
    portal_proctor: "Proctor Portal",
    portal_grader: "Grader Portal",
    placeholder_search_evaluator: "Search evaluator by name",
    empty_register_first_vacancy: "Create the first vacancy/position for this process.",
    empty_register_first_process: "Create the first process for this institution.",
    empty_no_vacancy_found: "No vacancy/position found",
    empty_no_process_found: "No process found",
    placeholder_csv_proctors: ".csv file containing proctor data",
    placeholder_search_candidate_name_cpf: "Search candidate by name or CPF",
    placeholder_search_grader: "Search grader by name",
    option_all: "All",
    question_objective: "Objective question",
    difficulty_easy: "Easy",
    difficulty_medium: "Medium",
    difficulty_hard: "Hard",
    education_elementary: "Elementary school",
    education_high_school: "High school",
    education_higher: "Higher education",
    label_alternative_order: "Alternative order",
    label_correct: "Correct",
    label_answered_feminine: "Answered",
    label_response: "Answer",
    label_total: "Total",
    label_registered_order_alternatives: "Alternatives in registration order",
    label_random_order_alternatives: "Alternatives in random order",
    placeholder_select_one_or_more_rooms: "Select one or more rooms",
    option_all_feminine: "All",
    label_alternative_count: "Alternative count",
    question_discursive: "Discursive question",
    question_plural: "questions",
    question_singular: "question",
    question_group_prefix: "Question set",
    question_group_objective_common: "Objective question sets with a common statement",
    select_education_level: "Select an education level",
    select_difficulty_level: "Select a difficulty level",
    option_select: "Select an option",
    label_main_theme: "Main theme",
    placeholder_main_theme_example: "Ex: French Revolution",
    label_context: "Context",
    label_answer: "Answer",
    loading_question_generating_response: "Generating response, please wait...",
    loading_question_thinking: "Thinking through the best response...",
    loading_question_processing: "Processing your question, please wait a moment...",
    loading_question_calculating: "Calculating the best answer for you...",
    error_statement_required: "The Statement field is required",
    error_alternative_a_required: "The Alternative a) field is required",
    error_alternative_b_required: "The Alternative b) field is required",
    error_alternative_c_required: "The Alternative c) field is required",
    error_alternative_d_required: "The Alternative d) field is required",
    error_alternative_e_required: "The Alternative e) field is required",
    error_server_response: "Error getting server response",
    error_server_connection: "Error getting server response. Are you connected to the internet?",
    status_denied: "Denied",
    status_granted: "Granted",
    status_not_answered: "Not answered",
    status_answered: "Answered",
    status_not_finished: "Not finished",
    status_not_started: "Not started",
    status_not_corrected: "Not corrected",
    status_corrected: "Corrected",
    status_absent: "Absent",
    status_present: "Present",
    status_valid: "Valid",
    status_annulled: "Annulled",
    status_pending: "Pending",
    status_rejected: "Rejected",
    status_approved: "Approved",
    status_rejected_plural: "Rejected",
    status_approved_plural: "Approved",
    action_generating_csv: "Generating CSV...",
    label_request_made: "Request made",
    label_deadline_datetime: "Deadline date and time",
    label_general_statement: "General statement",
    label_alternatives: "Alternatives",
    label_generated_at: "Generated at",
    label_education_level: "Education level",
    label_difficulty: "Difficulty",
    label_question_type_modal: "Type",
    tooltip_rewind_5_seconds: "Rewind 5 seconds",
    tooltip_forward_5_seconds: "Forward 5 seconds",
    action_select_videos: "Select videos",
    label_total_video_size: "Total video size:",
    filter_all_videos: "All",
    filter_webcam_videos: "Webcam videos",
    filter_external_camera_videos: "External camera videos",
    label_cpf: "CPF",
    label_registration_number: "Registration number",
    summary_yes: "Yes",
    summary_no: "No",
    video_ai_title: "Video AI events",
    video_ai_report_title: "AI events",
    video_ai_report_description: "Review events automatically detected in candidate videos.",
    video_ai_candidate_module_description: "View AI-detected events in this candidate's videos.",
    video_ai_process_description: "Candidates with detected events, sorted by highest event count.",
    video_ai_candidate_description: "Events detected in the candidate's videos",
    video_ai_analysis_status: "Analysis status",
    video_ai_generate_events: "Generate events",
    video_ai_download_excel: "Download Excel",
    video_ai_search_candidate: "Search candidate",
    video_ai_search_event: "Search event",
    video_ai_search_candidate_placeholder: "Name, CPF or registration",
    video_ai_search_event_placeholder: "Event, source or website",
    video_ai_source: "Source",
    video_ai_all_sources: "All sources",
    video_ai_source_camera: "Webcam",
    video_ai_source_external_camera: "Room camera",
    video_ai_source_screen: "Screen",
    video_ai_event_type: "Event type",
    video_ai_all_event_types: "All types",
    video_ai_sort: "Sort",
    video_ai_sort_date_asc: "Oldest first",
    video_ai_sort_date_desc: "Newest first",
    video_ai_sort_events_desc: "Most events",
    video_ai_sort_events_asc: "Fewest events",
    video_ai_snapshot: "Image",
    video_ai_events: "AI events",
    video_ai_points: "Points",
    video_ai_detected_site: "Detected website",
    video_ai_clip: "Clip",
    video_ai_datetime: "Date/time",
    video_ai_view_details: "View details",
    video_ai_view_candidate_events: "View candidate events",
    video_ai_video_events: "Video AI events",
    video_ai_video: "Video",
    video_ai_video_unavailable: "Video unavailable",
    video_ai_image_unavailable: "Image unavailable",
    video_ai_first_event_datetime: "First event date/time",
    video_ai_analyzed_clip: "Analyzed clip",
    video_ai_analysis_source: "Analysis source",
    video_ai_video_available: "Video available",
    video_ai_total_events: "Total events",
    video_ai_detected_events: "Detected events",
    video_ai_snapshot_second: "Image second",
    video_ai_event_id: "Event ID",
    video_ai_no_events_found: "No events found",
    video_ai_adjust_search: "Try adjusting the search.",
    video_ai_generate_to_view: "Generate events to view video analyses.",
    video_ai_job_success: "Completed",
    video_ai_job_not_generated: "Not generated",
    action_generate_report: "Generate report",
    action_select_all: "Select all",
    action_clear_selection: "Clear selection",
    label_value: "Value",
    trust_options_title: "Items considered in reliability",
    trust_options_description: "Uncheck the items that should not be included in the calculation before generating the report.",
    trust_metrics_title: "Proctoring metrics",
    trust_ai_events_title: "Detailed AI events",
    trust_report_not_generated: "The reliability report has not been generated yet",
    trust_points_by_metric: "Points by metric",
    trust_video_ai_points: "Video AI points",
    trust_ai_points_details: "Detailed AI points",
    trust_events_count: "event(s)",
    trust_metric_reported_actions: "Reported actions",
    trust_metric_face_recognition_average: "Face recognition average",
    trust_metric_periodic_face_validations: "Periodic facial validations",
    trust_metric_photos_without_face: "Photos without face detected",
    trust_metric_fiscal_release_requests: "Proctor release requests",
    trust_metric_screen_exits: "Screen exits",
    trust_metric_screen_exit_time: "Time outside the exam screen",
    trust_metric_videos_without_face: "Videos without face",
    trust_metric_multiple_faces_videos: "Multiple faces in videos",
    trust_metric_identical_ips: "Identical IPs",
    video_ai_event_ai_assistant: "AI assistant",
    video_ai_event_book: "Book",
    video_ai_event_calculator: "Calculator",
    video_ai_event_cell_phone: "Cell phone",
    video_ai_event_earbuds: "Earbuds",
    video_ai_event_email: "Email",
    video_ai_event_external_website: "External website",
    video_ai_event_headphones: "Headphones",
    video_ai_event_laptop: "Laptop",
    video_ai_event_long_hair: "Long hair",
    video_ai_event_browser_new_tab: "New browser tab",
    video_ai_event_looking_away: "Looking away",
    video_ai_event_messaging: "Messaging",
    video_ai_event_multiple_faces: "Multiple faces",
    video_ai_event_multiple_people: "Multiple people",
    video_ai_event_multiple_speakers: "Multiple voices",
    video_ai_event_no_face: "No people",
    video_ai_event_no_person: "No people",
    video_ai_event_paper: "Paper",
    video_ai_event_person: "Person",
    video_ai_event_reference: "Reference",
    video_ai_event_search_engine: "Search engine",
    video_ai_event_second_speaker: "Second voice",
    video_ai_event_speech: "Speech detected",
    video_ai_event_start_menu: "Start menu",
    video_ai_event_smartwatch: "Smartwatch",
    video_ai_event_tv_monitor: "TV/Monitor",
    video_ai_event_unknown: "Unclassified event",
    video_ai_severity_info: "Informational",
    video_ai_severity_low: "Low",
    video_ai_severity_medium: "Medium",
    video_ai_severity_high: "High",
    video_ai_severity_critical: "Critical",
    label_docx_file: "DOCX file",
    label_selected_file: "Selected file:",
    action_choose_files: "Choose files",
    label_no_file_selected: "No file selected",
    label_files_selected: "files selected",
    action_clear: "Clear",
    action_clear_file: "Clear file",
    action_clear_all_files: "Clear all files",
    label_upload_pdf: "PDF upload",
    label_pdf_viewer: "PDF viewer",
    error_server_response: "Error getting the server response. Are you connected to the internet?",
    error_select_video_or_pdf: "To save, select a video or PDF file",
    upload_success: "Upload completed successfully",
    error_fetch_server_response_short: "Error getting the server response",
    error_fetch_contents: "Error fetching contents",
    error_delete_content: "Error deleting content",
    error_edit_question: "Error editing question",
    alert_delete_content_unavailable: "After deleting this content, it will no longer be available in the system",
    label_type_colon: "Type: ",
    label_created_at_colon: "Created at: ",
    action_delete_question: "Delete question",
    action_saving: "Saving",
    action_saving_resource: "Saving appeal",
    description_create_institutions: "Register the institutions in your system",
    description_create_processes: "Register the processes in your system",
    description_manage_institutions: "Manage institutions, pages and owners registered in the platform.",
    description_manage_processes: "Manage processes, pages and owners registered in the platform.",
    description_edit_institution: "Edit an institution in your system",
    description_edit_process: "Edit a process in your system",
    label_logo: "Logo",
    label_of_your_system: "of your system",
    label_of_vacancy_position: "for the vacancy/position",
    placeholder_url_path: "URL path",
    placeholder_search_by_name: "Search by name",
    title_process: "Processes",
    title_institution: "Institutions",
    title_demand: "Demands",
    title_demands: "Demand list",
    title_subjects: "Subjects",
    title_questions: "Questions",
    title_question_list: "Question list",
    title_modules: "Modules",
    title_system_modules: "System modules",
    title_team_members: "Team member list",
    title_authors: "Author list",
    title_assignments: "Assignments",
    title_question_assignments: "Question assignments",
    title_essay_assignments: "Essay assignments",
    title_create_layout: "Create layout",
    title_edit_layout: "Edit layout",
    title_create_question: "Create question",
    title_edit_question: "Edit question",
    title_quick_reports: "Quick reports",
    report_exam_results_by_institution: "Exam results",
    report_all_candidates_general: "General candidate report",
    report_candidates_world_map: "Candidate map",
    title_candidates_geolocation_map: "Candidate geolocation map",
    desc_candidates_geolocation_map: "Points and heat regions based on the first IP registered on the exam in progress screen.",
    title_quick_summary: "Quick summary",
    title_latest_updates: "Latest updates",
    title_realtime_indicators: "Real-time indicators",
    title_choose_module_manage: "Choose a module to manage",
    title_create_demand: "Create demand",
    title_edit_demand: "Edit demand",
    title_reliability: "Reliability",
    title_general_logs: "General logs",
    title_exam_and_template: "Exam and template",
    title_print_settings: "Print settings",
    role_administrator: "Administrator",
    role_user: "User",
    authors: "Authors",
    disciplines: "Subjects",
    action_back: "Back",
    action_next: "Next",
    action_add: "Add",
    action_new_institution: "New institution",
    action_new_process: "New process",
    action_view_institution: "View institution",
    action_view_process: "View process",
    action_add_question: "Add question",
    action_add_questions_docx: "Add questions via .docx",
    docx_add_exam_questions_title: "Add questions via DOCX",
    docx_select_file: "Select DOCX file",
    docx_file_by_disciplines_description: "DOCX file separated by subjects",
    docx_error_process_file: "Error processing file.",
    docx_error_import_questions: "Error importing questions.",
    docx_status_creating_bank: "Creating your question bank...",
    docx_error_poll_job: "Error checking processing status. Are you connected to the internet?",
    docx_error_select_file: "Select a DOCX file to continue.",
    docx_status_uploading_file: "Uploading file...",
    docx_error_upload_file: "Error uploading file. Are you connected to the internet?",
    docx_instructions_intro: "Use the model that matches the exam type. Each subject name must be on its own uppercase line, with the questions below it.",
    docx_objective_questions_title: "Objective questions",
    docx_objective_question_number_instruction: "Use \"Question N)\" at the beginning of each question.",
    docx_objective_alternatives_instruction: "Use alternatives a), b), c), d) and e) in sequence.",
    docx_correct_alternative_instruction: "Mark the correct alternative with highlight or a non-white background color.",
    docx_group_questions_title: "Question sets",
    docx_group_header_instruction: "Enter the base text with the range: \"Base text for questions X to Y:\".",
    docx_group_children_instruction: "The questions inside a set must be objective.",
    docx_group_added_instruction: "The set will be added as a single question in the exam table.",
    docx_discursive_questions_title: "Discursive questions",
    docx_discursive_question_number_instruction: "Use \"Question N)\" at the beginning of each question.",
    docx_discursive_no_alternatives_instruction: "Do not include alternatives; the type is identified by the absence of a), b), c), etc.",
    docx_metadata_optional_instruction: "Keywords, Difficulty and Education level are optional.",
    docx_download_objective_model: "Download model - objective",
    docx_download_objective_group_model: "Download model - objective and sets",
    docx_download_discursive_model: "Download model - discursive",
    docx_error_only_objective_for_discursive_exam: "This file contains only objective questions. Change the exam type or upload a file with discursive questions.",
    docx_error_only_discursive_for_objective_exam: "This file contains only discursive questions. Change the exam type or upload a file with objective questions.",
    docx_warning_objective_ignored_discursive_exam: "Objective questions were ignored because the exam is configured as discursive.",
    docx_warning_discursive_ignored_objective_exam: "Discursive questions were ignored because the exam is configured as objective.",
    action_add_edit_assignments: "Add/Edit assignments",
    action_add_edit_essay_assignments: "Add/Edit essay assignments",
    action_save: "Save",
    action_save_demand: "Save demand",
    action_save_member: "Save member",
    action_save_author: "Save author",
    action_save_assignments: "Save assignments",
    action_close: "Close",
    action_delete: "Delete",
    action_download_report: "Download report",
    action_download_csv: "Download CSV",
    action_generating_map: "Generating map...",
    action_view_map: "View map",
    action_access: "Access",
    action_view_terms: "View institution terms",
    action_include_keyword: "Add keyword",
    label_name: "Name",
    label_email: "Email",
    label_candidates: "candidates",
    label_actions: "Actions",
    label_status: "Status",
    label_auditor_status: "Auditor status",
    label_registered_by: "Registered by",
    label_created_at: "Created at",
    label_created_at_feminine: "Created at",
    label_pages_published: "Published pages",
    label_sort_by: "Sort by",
    label_showing: "Showing",
    label_to: "to",
    label_of: "of",
    sort_recent: "Most recent",
    sort_oldest: "Oldest",
    sort_name: "Name",
    unit_page_singular: "page",
    unit_page_plural: "pages",
    empty_no_institutions_registered: "No institution registered",
    empty_no_processes_registered: "No process registered",
    empty_register_first_institution: "Create the first institution to get started.",
    label_updated_at: "Updated at",
    label_description: "Description",
    label_descriptive: "Description",
    label_demand_description: "Demand description",
    label_keywords: "Keywords",
    label_subject: "Subject",
    label_statement: "Statement",
    label_correct_alternative: "Correct alternative",
    label_question_type: "Question type",
    label_objective_question_count: "Objective question count",
    label_essay_question_count: "Essay question count",
    label_selected_authors: "Selected authors",
    label_user_type: "User type",
    label_password_confirmation: "Password confirmation",
    label_end_time: "End time",
    label_start: "Start",
    label_end: "End",
    label_rules: "Rules",
    label_terms: "Terms",
    label_proctoring_type: "Proctoring type",
    label_save_videos_streaming: "Save videos and images with real-time streaming",
    label_module: "Module",
    label_module_status: "Status",
    label_present_count: "Present count",
    role_collaborator: "Collaborator",
    role_viewer: "Viewer",
    answer_yes: "Yes",
    answer_no: "No",
    value_not_specified: "Not specified",
    status_active: "Active",
    status_inactive: "Inactive",
    status_maintenance: "Under maintenance",
    status_finished: "Finished",
    desc_demands: "All demands in your system are listed here",
    desc_subject_questions: "All questions for the subject are listed here",
    desc_system_modules: "All system modules and their statuses are listed here",
    desc_team_members: "All your team members are listed here",
    desc_team_member_create: "Create your team members in the system",
    desc_authors: "All authors in your system are listed here",
    desc_question_resources: "All question appeals in your system are listed here",
    desc_process_dashboard_data: "General data consolidated from this process dashboard.",
    desc_institution_dashboard_data: "General data consolidated from this institution dashboard.",
    desc_quick_reports_process: "Access this process tracking reports.",
    desc_question_assignment: "Add/Edit question assignments for demand",
    desc_essay_assignment: "Add/Edit essay assignments for demand",
    desc_select_authors_subject: "Select one or more authors who should create questions for this subject and write a description",
    desc_selected_essay_authors: "Select an author who should create one or more essays for this demand",
    desc_status_active: "Active: Module operating normally",
    desc_status_maintenance: "Under maintenance: Module is being updated and may be unstable",
    desc_status_inactive: "Inactive: Module is offline",
    empty_no_answers_found: "No answer found",
    empty_no_records_found: "No record found",
    empty_no_geolocation_found: "No geolocation found for present candidates.",
    empty_no_questions_found: "No question found",
    empty_no_questions_found_dot: "No question found.",
    empty_no_subject_found_term: "No subject found with this term",
    empty_no_subject_added: "No subject added",
    empty_no_assignments_found: "No assignment found",
    empty_no_demand_found: "No demand found",
    empty_no_author_selected: "No author selected",
    empty_no_author_found: "No author found",
    empty_no_member_found: "No member found",
    empty_no_candidate_found: "No candidate found",
    empty_no_proctor_found: "No proctor found",
    empty_no_grader_found: "No grader found",
    empty_no_evaluator_found: "No evaluator found",
    empty_no_room_found: "No room found",
    empty_no_layout_found: "No layout found",
    empty_no_test_found: "No test found",
    placeholder_search_demand: "Search by demand name",
    placeholder_search_subject: "Search by category name",
    placeholder_search_subject_add: "Search a subject to add to this demand",
    placeholder_search_question: "Search by question statement",
    placeholder_search_room: "Search by room number",
    placeholder_search_author_subject: "Search by author name or subject name",
    placeholder_password: "Enter your password",
    validation_required_field: "The {field} field is required",
    feedback_essay_correction_started: "Correction started successfully!",
    feedback_essay_correction_error: "Error correcting the essay. Please try again later.",
    loading_essay_analyzing: "Analyzing your essay...",
    loading_essay_identifying_points: "Identifying main points...",
    loading_essay_evaluating_argument: "Evaluating argumentation...",
    loading_essay_checking_coherence: "Checking textual coherence...",
    loading_essay_applying_criteria: "Applying correction criteria...",
    loading_essay_generating_feedback: "Generating personalized feedback...",
    loading_almost_done: "Almost there...",
    back: "Back",
    chooseOption: "Choose an option to view",
    enter: "Sign in",
    entering: "Signing in...",
    email: "Email",
    english: "English",
    language: "Language",
    light: "Light",
    dark: "Dark",
    loginHeroTitle: "Assessment management with clarity and security.",
    loginHeroSubtitle: "Organize processes, candidates, proctors and results in a modern, direct dashboard.",
    myProfile: "My profile",
    password: "Password",
    passwordPlaceholder: "Enter your password",
    portuguese: "Portuguese",
    signInSubtitle: "Access your account to continue.",
    adminEnvironment: "Administrative area",
    spanish: "Spanish",
    system: "System",
    theme: "Theme",
    viewing: "Viewing",
    welcome: "Welcome",
    logout: "Sign out",
    adminOrganizer: "Organizer admin",
    analyses: "Analyses",
    analysisObjects: "Analysis objects",
    assignments: "Assignments",
    assessmentBank: "Question Bank",
    candidateConflicts: "Candidate conflicts",
    candidates: "Candidates",
    chooseProcessReports: "Choose a process to view reports",
    content: "Content",
    contents: "Contents",
    dashboard: "Dashboard",
    demands: "Demands",
    diagramLayouts: "Layouts",
    details: "Details",
    edit: "Edit",
    essays: "Essays",
    evaluators: "Evaluators",
    evaluateQuestions: "Evaluate questions",
    graders: "Graders",
    importExisting: "Import existing",
    interviews: "Interviews",
    link: "Link",
    linkedQuestionnaires: "Linked questionnaires",
    members: "Members",
    module: "Module",
    modules: "Modules",
    organization: "Institution",
    organizations: "Institutions",
    openProcessReports: "Open reports for this process.",
    organizers: "Organizers",
    process: "Process",
    processes: "Processes",
    proctors: "Proctors",
    publicQuestions: "Public questions",
    question: "Question",
    questionBank: "Question bank",
    questionResources: "Question Resources",
    questions: "Questions",
    questionnaires: "Questionnaires",
    register: "Register",
    registerAction: "Create",
    resources: "Resources",
    rooms: "Rooms",
    systemModules: "System modules",
    teamMembers: "Team members",
    tests: "Tests",
    training: "Training",
    trainingManagement: "Training management",
    trainings: "Trainings",
    vacancies: "Vacancies/Roles",
    vacancy: "Vacancy/Role",
    bulk_process_add_button: "Add processes in bulk",
    bulk_process_title: "Add processes in bulk",
    bulk_process_names_label: "Process names",
    bulk_vacancy_add_button: "Add vacancies in bulk",
    bulk_vacancy_title: "Add vacancies in bulk",
    bulk_vacancy_names_section: "Names",
    bulk_vacancy_config_section: "Settings",
    bulk_vacancy_jobs_section: "Executions",
    bulk_vacancy_names_count: "names ready to be created",
    bulk_vacancy_names_label: "Vacancy names",
    bulk_vacancy_names_description: "Type names separated by commas. When you add a comma, each name becomes a badge; click the badge to edit it or x to remove it. If you import a CSV spreadsheet, the first column of each row will be used.",
    bulk_vacancy_names_placeholder: "Type a name and use comma to add",
    bulk_vacancy_name_edit_hint: "Click to edit this name",
    bulk_vacancy_name_remove: "Remove name",
    bulk_vacancy_file_label: "Import names from spreadsheet",
    bulk_vacancy_file_description: "Use a .csv or .txt file with names in the first column.",
    bulk_vacancy_file_read_error: "The uploaded file could not be read.",
    bulk_vacancy_names_required: "Enter at least one vacancy name.",
    bulk_vacancy_config_required: "Fill in description and rules before saving.",
    bulk_vacancy_save_button: "Create :entity in bulk",
    bulk_vacancy_basic_data: "Basic data",
    bulk_vacancy_dates: "Dates",
    bulk_vacancy_start_time: "Start time",
    bulk_vacancy_restrict_access: "Restrict access period",
    bulk_vacancy_access_start: "Access start",
    bulk_vacancy_access_end: "Access end",
    bulk_vacancy_exam_settings: "Assessment settings",
    bulk_vacancy_mobile: "Mobile process",
    bulk_vacancy_exam_per_time: "One question per time",
    bulk_vacancy_need_pause: "Allow pause",
    bulk_vacancy_has_blocks: "Use blocks",
    bulk_vacancy_time_type: "Assessment time",
    bulk_vacancy_time_all: "Use the full configured period",
    bulk_vacancy_time_restrict: "Restrict time in minutes",
    bulk_vacancy_exam_time_minutes: "Time in minutes",
    bulk_vacancy_proctoring: "Proctoring",
    bulk_vacancy_proctoring_type: "Proctoring type",
    bulk_vacancy_proctoring_all: "Save video and image with streaming",
    bulk_vacancy_proctoring_image: "Save image only with streaming",
    bulk_vacancy_proctoring_none: "Save logs only, without streaming",
    bulk_vacancy_chat_type: "Chat permission",
    bulk_vacancy_chat_all: "Candidate and proctor can send messages",
    bulk_vacancy_chat_fiscal_to_student: "Only the proctor sends messages",
    bulk_vacancy_chat_none: "Chat disabled",
    bulk_vacancy_screen_sharing: "Require screen sharing",
    bulk_vacancy_screen_extended_restrict: "Block extended screen",
    bulk_vacancy_recording_before: "Start recording before the start in minutes",
    bulk_vacancy_draft: "Allow draft",
    bulk_vacancy_validations: "Validations",
    bulk_vacancy_face_validation: "Face validation on entry",
    bulk_vacancy_document_validation: "Document validation",
    bulk_vacancy_chat_time: "Chat interval in minutes",
    bulk_vacancy_request_time: "Request interval in minutes",
    bulk_vacancy_periodic_validation_time: "Periodic validation interval in minutes",
    action_refresh: "Refresh",
    legacy_acoes_rapidas: "Quick actions",
    legacy_adicionar_avaliadores: "Add evaluators",
    legacy_adicionar_corretor: "Add grader",
    legacy_adicionar_fiscais: "Add proctors",
    legacy_adicionar_disciplina: "Add subject",
    legacy_adicionar_elemento: "Add element",
    legacy_adicionar_elaborador: "Add author",
    legacy_adicionar_membro: "Add member",
    legacy_adicionar_novo_modulo: "Add new module",
    legacy_adicionar_novo_conteudo: "Add new content",
    legacy_adicionar_nova_questao: "Add new question",
    legacy_adicionar_questionario: "Add questionnaire",
    legacy_adicionar_pergunta: "Add question",
    legacy_adicionar_cursos: "Add courses",
    legacy_adicionar_usuarios: "Add users",
    legacy_adicionar_professores: "Add teachers",
    legacy_adicionar_candidato: "Add candidate",
    legacy_adicionar_fiscal: "Add proctor",
    legacy_adicionar_avaliador: "Add evaluator",
    legacy_adicionar_treinamento: "Add training",
    legacy_adicionar_organizadora: "Add organizer",
    legacy_adicionar_novo_treinamento: "Add new training",
    legacy_adicionar_entrevista: "Add interview",
    legacy_adicionar_topico: "Add topic",
    legacy_adicionar_criterio: "Add criterion",
    legacy_adicionar_alternativa_de_escolha_multipla: "Add multiple-choice option",
    legacy_adicionar_campo_de_texto: "Add text field",
    legacy_adicionar_prefiro_nao_informar: "Add \"Prefer not to answer\"",
    legacy_adicionar_perguntas: "Add questions",
    legacy_adicionar_formula: "Add formula",
    legacy_adicionar_nova_demanda: "Add new demand",
    legacy_adicionar_novo_recurso: "Add new appeal",
    legacy_adicionar_comentario: "Add comment",
    legacy_adicionar_zip_rar_de_redacoes_externas: "Add external essays .zip/.rar",
    legacy_adicionar_zip_rar_de_redacoes_existentes: "Add existing essays .zip/.rar",
    legacy_adicionar_editar_atribuicoes: "Add/Edit assignments",
    legacy_analise_de_objetos: "Object analysis",
    legacy_analise_facial: "Facial analysis",
    legacy_analise_movimentacoes_capturadas_pela_camera: "Analyze movements captured by the camera.",
    legacy_movimento_facial: "Facial movement",
    legacy_acompanhe_indicadores_de_confianca_dos_candidatos: "Track candidate confidence indicators.",
    legacy_acompanhe_acessos_e_eventos_registrados_durante_a_avaliacao: "Track access and events registered during the assessment.",
    legacy_acesse_as_versoes_nominais_dos_candidatos: "Access candidate nominal versions.",
    legacy_acesse_as_imagens_capturadas: "Access captured images.",
    legacy_aqui_sao_listados_todas_as_questoes_pendentes_do_seu_sistema: "All pending questions in your system are listed here",
    legacy_aqui_sao_listados_todas_as_organizadoras_do_seu_sistema: "All organizers in your system are listed here",
    legacy_aqui_sao_listados_todos_os_treinamentos_do_seu_sistema: "All trainings in your system are listed here",
    legacy_aqui_sao_listados_todos_os_conteudos_vinculados_com_o_modulo: "All contents linked to the module are listed here",
    legacy_aqui_sao_listados_todos_os_modulos_vinculados_com_o_treinamento: "All modules linked to the training are listed here",
    legacy_aqui_sao_listados_todas_as_suas_disciplinas: "All your subjects are listed here",
    legacy_aqui_sao_listados_todos_os_seus_questionarios: "All your questionnaires are listed here",
    legacy_aqui_sao_listados_todas_as_questoes_do_conteudo: "All questions for the content are listed here",
    legacy_aqui_sao_listados_todos_os_conteudos_do_seu_sistema: "All contents in your system are listed here",
    legacy_ao_deletar_este_modulo_ele_nao_estara_mais_disponivel_no_sistema: "When deleting this module, it will no longer be available in the system",
    legacy_atencao: "Attention",
    legacy_aqui_sao_listados_todos_os_modulos_do_seu_sistema: "All modules in your system are listed here",
    legacy_api_integrada_e_ativa: "API integrated and active",
    legacy_avaliacoes: "Evaluations",
    legacy_avaliar_questao: "Evaluate question",
    legacy_baixar_respostas: "Download answers",
    legacy_baixar_pdf_com_analises: "Download analysis PDF",
    legacy_baixar_analises_em_pdf: "Download analyses as PDF",
    legacy_baixar_planilha_excel: "Download Excel spreadsheet",
    legacy_baixar_todas_redacoes: "Download all essays",
    legacy_baixar_correcoes: "Download corrections",
    legacy_baixar_exemplo_de_arquivo: "Download sample file",
    legacy_baixar_pdf: "Download PDF",
    legacy_borda_visivel: "Show border?",
    legacy_candidatos_online: "Candidates online",
    legacy_candidatos_vinculados: "Linked candidates",
    legacy_cadastre_os_modulos_do_seu_sistema: "Create your system modules",
    legacy_cancelar: "Cancel",
    legacy_cadastrar_avaliador: "Create evaluator",
    legacy_cadastrar_corretor: "Create grader",
    legacy_cadastrar_disciplina: "Create subject",
    legacy_cadastrar_elaborador: "Create author",
    legacy_cadastrar_fiscal: "Create proctor",
    legacy_cadastrar_membro: "Create member",
    legacy_cadastrar_redacao: "Create essay",
    legacy_cadastrar_recurso_de_questao: "Create question appeal",
    legacy_cadastrar_disciplina_2: "Create subject",
    legacy_configuracoes: "Settings",
    legacy_configuracoes_da_instituicao: "Institution settings",
    legacy_configuracoes_do_processo: "Process settings",
    legacy_consulte_objetos_detectados_durante_a_avaliacao: "Review objects detected during the assessment.",
    legacy_confira_registros_de_troca_de_janela_ou_saida_da_tela: "Check window switch or screen exit records.",
    legacy_data_de_criacao: "Creation date",
    legacy_data_de_nascimento: "Birth date",
    legacy_data_de_inicio: "Start date",
    legacy_data_de_encerramento: "End date",
    legacy_data_de_encerammento: "End date",
    legacy_data_limite: "Deadline",
    legacy_data_da_resposta: "Answer date",
    legacy_data: "Date",
    legacy_download_relatorio: "Download report",
    legacy_deletar_demanda: "Delete demand",
    legacy_descricao: "Description:",
    legacy_descricao_do_modulo: "Module description",
    legacy_descricao_do_treinamento: "Training description",
    legacy_descricao_dos_fatos: "Description of facts",
    legacy_editar_pagina: "Edit page",
    legacy_editar_perfil: "Edit Profile",
    legacy_editar_avaliador: "Edit evaluator",
    legacy_editar_corretor: "Edit grader",
    legacy_editar_fiscal: "Edit proctor",
    legacy_editar_membro: "Edit member",
    legacy_editar_modulo_conteudos: "Edit module/contents",
    legacy_editar_questionario: "Edit questionnaire",
    legacy_editar_redacao: "Edit essay",
    legacy_editar_recurso_de_questao: "Edit question appeal",
    legacy_editar_disciplina: "Edit subject",
    legacy_editar_conteudo: "Edit content",
    legacy_editar_questao: "Edit question",
    legacy_editar_questionario_2: "Edit questionnaire",
    legacy_editar_candidato: "Edit candidate",
    legacy_editar_corretor_2: "Edit grader",
    legacy_editar_avaliador_2: "Edit evaluator",
    legacy_editar_fiscal_2: "Edit proctor",
    legacy_editar_membro_2: "Edit member",
    legacy_editar_elaborador: "Edit author",
    legacy_editar_recurso: "Edit appeal",
    legacy_editar_atribuicao: "Edit assignment",
    legacy_editar_treinamento: "Edit training",
    legacy_editar_organizadora: "Edit organizer",
    legacy_editar_horario: "Edit schedule",
    legacy_editar_elemento_da_folha_de_rosto: "Edit cover page element",
    legacy_elemento_selecionado_de_duplo_clique_nele_para_abrir_o_editor: "Element selected. Double-click it to open the editor.",
    legacy_editar_demanda: "Edit demand",
    legacy_editar_elaborador_2: "Edit author",
    legacy_edite_um_elaborador_do_seu_sistema: "Edit an author in your system",
    legacy_escolha_a_alternativa_correta: "Choose the correct alternative",
    legacy_esconder_paginacao: "Hide pagination?",
    legacy_enviar_e_mail_para_o_elaborador_com_senha_aleatoria: "Send email to the author with a random password?",
    legacy_enviar_e_mail_para_o_cliente_com_senha_aleatoria: "Send email to the client with a random password?",
    legacy_elaborador_pode_criar_redacao: "Can the author create essays?",
    legacy_elaborador_pode_ser_auditor: "Can the author be an auditor?",
    legacy_excluir_candidato: "Delete candidate",
    legacy_excluir_corretor: "Delete grader",
    legacy_excluir_avaliador: "Delete evaluator",
    legacy_excluir_fiscal: "Delete proctor",
    legacy_fiscais_online: "Proctors online",
    legacy_folha_de_rosto: "Cover page",
    legacy_gerencie: "Manage",
    legacy_gerencie_as_diagramacoes: "Manage layouts",
    legacy_gerencie_as_diagramacoes_vinculadas_ao_processo: "Manage layouts linked to the process",
    legacy_gerencie_as_redacoes: "Manage essays",
    legacy_gerencie_candidatos: "Manage candidates",
    legacy_gerencie_corretores: "Manage graders",
    legacy_gerencie_diagramacoes: "Manage layouts",
    legacy_gerencie_fiscais: "Manage proctors",
    legacy_gerencie_provas_e_itens: "Manage tests and items",
    legacy_gerencie_questionarios: "Manage questionnaires",
    legacy_gerencie_salas: "Manage rooms",
    legacy_gerencie_as_salas_vinculadas_ao_processo: "Manage rooms linked to the process",
    legacy_gerencie_os_fiscais_vinculados_ao_processo: "Manage proctors linked to the process",
    legacy_gerencie_os_corretores_vinculados_ao_processo: "Manage graders linked to the process",
    legacy_gerencie_os_candidatos_vinculados_ao_processo: "Manage candidates linked to the process",
    legacy_gerencie_os_candidatos_da_instituicao: "Manage institution candidates.",
    legacy_gerencie_os_candidatos_do_processo: "Manage process candidates.",
    legacy_gerencie_os_fiscais_da_instituicao: "Manage institution proctors.",
    legacy_gerencie_os_fiscais_do_processo: "Manage process proctors.",
    legacy_gerencie_os_avaliadores_da_instituicao: "Manage institution evaluators.",
    legacy_gerencie_os_avaliadores_do_processo: "Manage process evaluators.",
    legacy_gerencie_os_corretores_da_instituicao: "Manage institution graders.",
    legacy_gerencie_os_corretores_do_processo: "Manage process graders.",
    legacy_gerencie_os_treinamentos_vinculados_desta_instituicao: "Manage trainings linked to this institution.",
    legacy_gerencie_os_treinamentos_vinculados_deste_processo: "Manage trainings linked to this process.",
    legacy_gerencie_treinamentos: "Manage trainings",
    legacy_gerencie_as_entrevistas_vinculadas_ao_processo: "Manage interviews linked to the process.",
    legacy_gerencie_as_avaliacoes_orais_dos_candidatos: "Manage candidate oral assessments.",
    legacy_gerencie_os_membros_desta_organizadora: "Manage this organizer members.",
    legacy_gerencie_os_processos_seletivos: "Manage selection processes",
    legacy_gerencie_as_vagas_do_processo_seletivo: "Manage selection process vacancies",
    legacy_gerencie_as_vagas_vinculadas_ao_seletivo: "Manage vacancies linked to the selection process.",
    legacy_gerencie_os_processos_vinculados_a_instituicao: "Manage processes linked to the institution.",
    legacy_gerenciar: "Manage",
    action_manage_dashboard: "Manage dashboard",
    action_manage_proctors: "Manage proctors",
    action_manage_graders: "Manage graders",
    action_manage_evaluators: "Manage evaluators",
    legacy_horario_de_encerramento_do_intervalo: "Interval end time",
    legacy_ir_para_lista_de_correcoes: "Go to correction list",
    legacy_informacoes: "Information",
    legacy_margem_direita: "Right margin",
    legacy_margem_esquerda: "Left margin",
    legacy_margem_inferior: "Bottom margin",
    legacy_margem_superior: "Top margin",
    legacy_modulo_administrativo_utilizado_para_fazer_todos_os_cadastros_no_siste: "Administrative module used to manage registrations and download results/reports",
    legacy_modulo_para_correcao_de_questoes_dissertativas_e_redacoes: "Module for correcting essay questions and essays",
    legacy_modulo_para_aplicacao_de_prova_oral_onde_os_avaliadores_conseguem_entr: "Module for oral tests, where evaluators can join calls with candidates",
    legacy_modulo_para_cadastros_de_questoes_por_parte_de_professores_elaboradoes: "Module for teachers/authors to create questions, answer appeals, and handle demands",
    legacy_modulo_de_fiscalizacao_proctoring_do_candidato_durante_todo_o_perido_d: "Candidate proctoring module during the full online assessment period",
    legacy_modulo_para_acesso_do_candidato: "Candidate access module",
    legacy_modulos_vinculados: "Linked modules",
    legacy_multipla_escolha: "Multiple choice",
    legacy_escolha_multipla: "Multiple choice",
    legacy_administrador: "Administrator",
    legacy_corretor: "Grader",
    legacy_avaliador: "Evaluator",
    legacy_elaborador: "Author",
    legacy_fiscal: "Proctor",
    legacy_candidato: "Candidate",
    legacy_nenhum_conteudo_cadastrado: "No content registered",
    legacy_nenhum_conteudo_selecionado: "No content selected",
    legacy_nenhum_corretor_adicionado: "No grader added",
    legacy_nenhum_corretor_selecionado: "No grader selected",
    legacy_nenhum_modulo_selecionado: "No module selected",
    legacy_nenhum_questionario_cadastrado: "No questionnaire registered",
    legacy_nenhum_recurso_encontrado: "No appeal found",
    legacy_nenhum_aviso_encontrado: "No warning found",
    legacy_nenhuma_analise_encontrada: "No analysis found",
    legacy_nenhuma_disciplina_cadastrada: "No subject registered",
    legacy_nenhuma_execucao_encontrada: "No execution found",
    legacy_nenhuma_pergunta_adicionada: "No question added",
    legacy_nenhuma_questao_adicionada: "No question added",
    legacy_nenhuma_questao_cadastrada_nesta_demanda: "No question registered in this demand",
    legacy_nenhuma_questao_encontrada_com_os_filtros_aplicados: "No question found with the applied filters",
    action_search: "Search",
    action_apply_filters: "Apply filters",
    legacy_nenhuma_questao_selecionada: "No question selected",
    legacy_nenhuma_redacao_encontrada: "No essay found",
    legacy_nenhum_texto_de_apoio_adicionado: "No supporting text added",
    legacy_nenhuma_texto_encontrada: "No text found",
    legacy_nenhum_avaliador_selecionado: "No evaluator selected",
    legacy_nenhum_comentario_adicionado: "No comment added",
    legacy_nenhum_criterio_adicionado: "No criterion added",
    legacy_nenhuma_nota_registrada: "No grade registered",
    legacy_nenhuma_palavra_chave_vinculada: "No keyword linked",
    legacy_nome_do_modulo: "Module name",
    legacy_nome_da_disciplina: "Subject name",
    legacy_nome_da_categoria: "Category name",
    legacy_nome_do_corretor: "Grader name",
    legacy_nome_do_avaliador: "Evaluator name",
    legacy_nome_do_fiscal: "Proctor name",
    legacy_nome_do_aluno: "Student name",
    legacy_nome_do_membro: "Member name",
    legacy_nome_do_membro_da_equipe: "Team member name",
    legacy_nome_do_elaborador: "Author name",
    legacy_nome_da_redacao: "Essay name",
    legacy_nome_da_demanda: "Demand name",
    legacy_nome_do_recurso: "Appeal name",
    legacy_nome_do_treinamento: "Training name",
    legacy_nome_da_entrevista: "Interview name",
    legacy_nome_da_organizadora: "Organizer name",
    legacy_nome_da_prova: "Test name",
    legacy_nome_do_padrao: "Template name",
    legacy_nome_organizacao: "Organization name",
    legacy_nome_usuario: "User name",
    legacy_numero_de_alternativas: "Number of alternatives",
    legacy_numero_de_modulos: "Number of modules",
    legacy_numero_de_colunas_da_avaliacao: "Assessment column count",
    legacy_numero_de_colunas_na_pagina: "Number of columns on the page",
    legacy_numero_de_colunas: "Column count",
    legacy_presentes: "Present",
    legacy_alunos: "Students",
    legacy_nota_minima: "Minimum score",
    legacy_nota_maxima: "Maximum score",
    legacy_nota: "Score",
    legacy_criterios: "Criteria",
    legacy_codigo_do_criterio: "Criterion code",
    legacy_texto_do_criterio: "Criterion text",
    legacy_n: "No.",
    legacy_paginas: "Pages",
    legacy_palavras_chaves: "Keywords",
    legacy_palavra_chave: "Keyword",
    legacy_palavra_chave_2: "Keyword",
    legacy_palavras_chave: "Keywords:",
    legacy_termos_nao_cadastrados: "Terms not registered",
    legacy_termos_de_uso: "Terms of use",
    legacy_alternativa_correta: "Correct alternative",
    legacy_alternativa_a: "Alternative a)",
    legacy_alternativa_b: "Alternative b)",
    legacy_alternativa_c: "Alternative c)",
    legacy_alternativa_d: "Alternative d)",
    legacy_alternativa_e: "Alternative e)",
    legacy_comentarios: "Comments",
    legacy_correcao_da_redacao: "Essay correction",
    legacy_enunciado_da_redacao: "Essay statement",
    legacy_escolaridade: "Education",
    legacy_solucao: "Solution",
    legacy_pesquisa: "Search",
    legacy_pesquisar_pelo_nome_do_arquivo: "Search by file name",
    legacy_pesquisar_pelo_nome_cpf_numero_de_inscricao_do_candidato: "Search by candidate name/CPF/registration number",
    legacy_pesquisar_por_nome_cpf_ou_inscricao: "Search by name, CPF, or registration",
    legacy_pesquisar_pelo_nome_do_questionario: "Search by questionnaire name",
    legacy_pesquisar_pelo_nome_da_prova: "Search by test name",
    legacy_pesquisar_pelo_enunciado_ou_nome_da_redacao: "Search by statement or essay name",
    legacy_pesquisar_pelo_nome_do_recurso: "Search by appeal name",
    legacy_pesquisar_pelo_nome_da_organizadora: "Search by organizer name",
    legacy_pesquisar_pelo_nome_do_treinamento: "Search by training name",
    legacy_pesquisar_pelo_nome_da_entrevista: "Search by interview name",
    legacy_pesquisar_pelo_nome_da_imagem: "Search by image name",
    legacy_pesquisar_pelo_nome_do_video: "Search by video name",
    legacy_pesquisar_pelo_nome_do_elaborador_ou_nome_da_categoria: "Search by author name or category name",
    legacy_pesquisar_pelo_enunciado_ou_nome_do_elaborador: "Search by statement or author name",
    legacy_pesquisar_pelo_nome_da_diagramacao: "Search by layout name",
    legacy_pesquisar_pelo_nome_do_candidato: "Search by candidate name",
    legacy_pesquisar_pelo_nome_do_conteudo: "Search by content name",
    legacy_pesquisar_pelo_nome_do_corretor: "Search by grader name",
    legacy_pesquisar_pelo_nome_do_elaborador: "Search by author name",
    legacy_pesquisar_pelo_nome_do_fiscal: "Search by proctor name",
    legacy_pesquisar_pelo_nome_do_membro: "Search by member name",
    legacy_pesquisar_pelo_nome_do_modulo: "Search by module name",
    legacy_pesquise_pelo_nome_do_conteudo: "Search by content name",
    legacy_pesquise_pelo_nome_do_fiscal: "Search by proctor name",
    legacy_pesquise_a_questao_pelo_enunciado: "Search question by statement",
    legacy_permissoes_concedidas: "Granted permissions",
    legacy_processo_seletivo_do_recurso: "Appeal selection process",
    legacy_prova_objetiva: "Objective test",
    legacy_prova_atualizada: "Test updated",
    legacy_provas_cadastradas: "Registered tests",
    legacy_questao_objetiva: "Objective question",
    legacy_questao_unica: "Single question",
    legacy_questao_selecionada: "Selected question",
    legacy_questoes_selecionadas: "Selected questions",
    legacy_questoes_cadastradas: "Registered questions",
    legacy_questao_de_multipa_escolha: "Multiple-choice question",
    legacy_questao_dissertativa: "Essay question",
    legacy_conjunto_de_questoes_de_multipa_escolha_com_enunciado_em_comum: "Multiple-choice question set with shared statement",
    legacy_lista_de_questionarios: "Questionnaire list",
    legacy_lista_de_diagramacoes: "Layout list",
    legacy_lista_de_organizadoras: "Organizer list",
    legacy_lista_de_questoes_para_avaliacao: "Questions pending evaluation list",
    legacy_lista_de_recursos_de_questoes: "Question appeal list",
    legacy_registros_de_tela: "Screen records",
    legacy_videos: "Videos",
    legacy_logs_de_conexao: "Connection logs",
    legacy_diagramacoes_nominais: "Nominal layouts",
    legacy_recolher_configuracoes: "Collapse settings",
    legacy_relatorio_rapido: "Quick report",
    legacy_relatorios: "Reports",
    legacy_relatorios_gerais: "General reports",
    legacy_relatorios_por_vaga_cargo: "Reports by vacancy/role",
    legacy_remover_elemento: "Remove element",
    legacy_redacao_criada: "Essay created",
    legacy_redacoes_cadastradas: "Registered essays",
    legacy_revise_validacoes_imagens_e_ocorrencias_de_reconhecimento_facial: "Review facial recognition validations, images, and events.",
    legacy_ver_regras: "View rules",
    legacy_ver_questao: "View question",
    legacy_ver: "View",
    legacy_sala: "Room",
    legacy_saidas_de_tela: "Screen exits",
    legacy_salvar_imagens_com_streaming_em_tempo_real: "Save images with real-time streaming",
    legacy_sem_fiscalizacao: "No proctoring",
    legacy_salvar_diagramacao: "Save layout",
    legacy_salvar_diagramacao_como_padrao: "Save layout as template?",
    legacy_salvar_diagramacao_e_imprimir: "Save layout and print",
    legacy_salvar_configuracoes: "Save settings",
    legacy_salvar_questao: "Save question",
    legacy_salvar_comentario: "Save comment",
    legacy_salvar_recurso: "Save appeal",
    legacy_salvar_corretor: "Save grader",
    legacy_salvar_corretores: "Save graders",
    legacy_salvar_fiscal: "Save proctor",
    legacy_salvar_fiscais: "Save proctors",
    legacy_salvar_avaliador: "Save evaluator",
    legacy_salvar_modulo: "Save module",
    legacy_salvar_treinamento: "Save training",
    legacy_salvar_organizadora: "Save organizer",
    legacy_salvar_redacoes: "Save essays",
    legacy_salvar_redacao: "Save essay",
    legacy_salvar_aluno: "Save student",
    legacy_salvar_prova: "Save test",
    legacy_salvar_prova_e_ir_para_diagramacao: "Save test and go to layout",
    legacy_salvar_questoes: "Save questions",
    legacy_salvar_questionario: "Save questionnaire",
    legacy_salvar_questionarios: "Save questionnaires",
    legacy_salvar_conteudo: "Save content",
    legacy_salvar_formula: "Save formula",
    legacy_salvar_entrevista: "Save interview",
    legacy_mostrar_configuracoes: "Show settings",
    legacy_selecione_a_disciplina: "Select the subject",
    legacy_selecione_a_quantidade: "Select the quantity",
    legacy_selecione_uma_disciplina: "Select a subject",
    legacy_selecione_uma_alternativa_correta: "Select a correct alternative",
    legacy_selecione_um_processo_seletivo: "Select a selection process",
    legacy_selecione_um_ou_mais_elaboradores: "Select one or more authors",
    legacy_selecione_um_ou_mais_elaboradores_que_deverao_cadastrar_questoes_dessa: "Select one or more authors who should create questions for this subject",
    legacy_selecione_um_elemento_no_preview_de_duplo_clique_para_editar_o_texto: "Select an element in the preview. Double-click to edit the text.",
    legacy_selecione_um_padrao_de_diagramacao: "Select a layout template",
    legacy_selecione_uma_prova: "Select a test",
    legacy_sim_desejo_apagar: "Yes, delete",
    legacy_subtitulo_cabecalho: "Header subtitle",
    legacy_tipo: "Type",
    legacy_tipo_da_questao: "Question type",
    legacy_tipo_de_pergunta: "Question type",
    legacy_tipos_de_status: "Status types:",
    legacy_titulo: "Title",
    legacy_titulo_do_questionario: "Questionnaire title",
    legacy_titulo_do_texto_de_apoio: "Supporting text title",
    legacy_titulo_campo_1: "Field 1 title",
    legacy_titulo_campo_2: "Field 2 title",
    legacy_titulo_ex_escola_x: "Title. E.g. School X",
    legacy_tamanho_da_fonte_do_texto: "Text font size",
    legacy_termos_cadastrados: "Registered terms",
    legacy_titulo_ex_instituicao: "Title (e.g. Institution)",
    legacy_titulo_cabecalho: "Header title",
    legacy_todos_os_relatorios: "All reports",
    legacy_n_candidatos: "Candidate count",
    legacy_n_fiscais: "Proctor count",
    legacy_n_corretores: "Grader count",
    legacy_vagas: "Vacancies",
    legacy_veja_candidatos_e_avaliadores_conectados_no_momento: "See candidates and evaluators connected now.",
    legacy_ver_enunciado: "View statement",
    legacy_visualize_indicadores: "View indicators",
    legacy_visualize_as_atribuicoes_desta_demanda: "View this demand assignments.",
    legacy_visualize_as_atribuicoes_deste_recurso: "View this appeal assignments.",
    legacy_visualize_os_modulos_vinculados_ao_treinamento: "View modules linked to the training.",
    legacy_visualize_os_candidatos_vinculados_a_entrevista: "View candidates linked to the interview.",
    legacy_visualize_as_questoes_do_questionario: "View questionnaire questions.",
    legacy_visualize_as_questoes_desta_diagramacao: "View this layout questions.",
    legacy_visualize_os_registros_de_tela: "View screen records.",
    legacy_consulte_os_relatorios_da_analise_facial: "View facial analysis reports.",
    legacy_consulte_os_relatorios_e_pontos_de_confianca: "View reports and confidence points.",
    legacy_quem_ja_fez_login: "Who logged in",
    legacy_online_agora: "Online now",
    legacy_abrir_modulo: "Open module",
    legacy_encerramento: "End:",
    legacy_e_mail_do_elaborador: "Author email",
    legacy_baixe_relatorios_gerais_ou_abra_a_area_completa_de_relatorios: "Download general reports or open the full reports area.",
    legacy_avaliadores_online: "Evaluators online",
    legacy_avaliadores_vinculados: "Linked evaluators",
    legacy_fiscais_vinculados: "Linked proctors",
    legacy_candidato_vinculado: "Candidate linked",
    legacy_baixar_pdf_2: "Download PDF",
    legacy_baixar_planilha: "Download spreadsheet",
    legacy_baixar_gabarito_da_prova: "Download test answer key",
    legacy_baixar_respostas_da_prova: "Download test answers",
    legacy_baixar_folhas_de_resposta_em_pdf: "Download answer sheets as .pdf",
    legacy_baixar_caderno_com_respostas_em_pdf: "Download booklet with answers as PDF",
    legacy_baixar_provas_em_pdf: "Download tests as .pdf",
    legacy_baixar_respostas_em_csv: "Download answers as .csv",
    legacy_baixar_resposta_em_pdf: "Download answer as .pdf",
    legacy_baixar_relatorio_de_saidas_de_tela: "Download screen exit report",
    legacy_baixar_pdf_com_imagens: "Download PDF with images",
    legacy_categoria: "Category",
    legacy_data_da_ultima_atualizacao: "Last update date",
    legacy_erro: "Error",
    legacy_identificador_da_demanda: "Demand identifier",
    legacy_numero_de_questoes: "Question count",
    legacy_numero_de_questoes_2: "Question count",
    legacy_numero_de_inscricao: "Registration number",
    legacy_numero_de_inscricao_2: "Registration number",
    legacy_numero_inscricao: "Registration number",
    legacy_numero_deteccoes: "Detection count",
    legacy_pesquise_o_fiscal_pelo_nome: "Search proctor by name",
    legacy_prova: "Test",
    legacy_relatorio: "Report",
    legacy_relatorio_de_acesso: "Access report",
    legacy_saidas: "Exits",
    legacy_tipo_de_arquivo: "File type",
    legacy_total: "Total",
    legacy_textos_de_apoio: "Supporting texts",
    legacy_corrigir_com_ia: "Correct with AI",
    legacy_cpf: "CPF",
    legacy_inscricao: "Registration",
    legacy_resultado: "Result",
    legacy_modelo: "Model",
    legacy_progresso: "Progress",
    legacy_primeira_deteccao: "First detection",
    legacy_pre_visualizacao_do_pdf: "PDF preview",
    legacy_upload_da_capa_do_video: "Video cover upload",
    legacy_pre_visualizacao_do_video: "Video preview",
    legacy_pre_visualizacao_da_capa: "Cover preview",
    legacy_busque_um_ou_mais_conteudos_que_deseja_vincular: "Search one or more contents to link",
    legacy_busque_um_ou_mais_corretores_que_deseja_vincular: "Search one or more graders to link",
    legacy_busque_um_ou_mais_fiscais_que_deseja_vincular: "Search one or more proctors to link",
    legacy_busque_um_ou_mais_candidatos_que_deseja_vincular: "Search one or more candidates to link",
    legacy_busque_questoes_da_disciplina: "Search subject questions",
    legacy_gerencie_os_textos_de_apoio_da_redacao: "Manage essay supporting texts.",
    legacy_acompanhe_os_resultados_desta_redacao: "Track this essay results.",
    legacy_acesse_a_correcao_assistida_por_ia: "Access AI-assisted correction.",
    legacy_visualize_e_organize_as_questoes_da_prova: "View and organize test questions.",
    legacy_visualize_os_conteudos_vinculados_ao_modulo: "View contents linked to the module.",
    legacy_visualize_o_arquivo_principal_do_conteudo: "View the main content file.",
    legacy_gerencie_as_questoes_vinculadas_ao_conteudo: "Manage questions linked to the content.",
    legacy_visualize_as_imagens_capturadas_na_analise: "View images captured in the analysis.",
    legacy_consulte_os_relatorios_da_analise: "View analysis reports.",
    legacy_consulte_os_candidatos_vinculados_a_esta_sala: "View candidates linked to this room.",
    legacy_veja_os_fiscais_responsaveis_pela_sala: "See proctors assigned to the room.",
    legacy_acompanhe_os_corretores_vinculados: "Track linked graders.",
    legacy_consulte_o_historico_e_os_indicadores_de_acesso: "View access history and indicators.",
    legacy_visualize_as_avaliacoes_do_candidato: "View candidate assessments.",
    legacy_acesse_os_videos_capturados: "Access captured videos.",
    legacy_consulte_os_logs_de_conexao: "View connection logs.",
    legacy_veja_os_videos_da_tela_do_candidato: "See candidate screen videos.",
    legacy_aqui_ficam_os_downloads_do_seletivo: "Here are the selection process downloads",
    legacy_aqui_ficam_os_modelos_da_prova: "Here are the test models",
    legacy_aqui_ficam_os_candidatos_que_possuem_conflito_de_cpf_com_outros_candid: "Here are the candidates with CPF conflicts with other candidates",
    legacy_arquivo_csv: ".csv file",
    legacy_arquivo_csv_contendo_os_dados_dos_corretores: ".csv file containing grader data",
    legacy_arquivo_de_redacoes_zip_rar: "Essay file (.zip/.rar)",
    legacy_busque_um_ou_mais_avaliadores_que_deseja_vincular: "Search one or more evaluators to link",
    legacy_busque_um_ou_mais_fiscais_que_deseja_vincular_no_treinamento: "Search one or more proctors to link to the training",
    legacy_busque_um_ou_mais_modulos_que_deseja_vincular: "Search one or more modules to link",
    legacy_busque_um_ou_mais_questionarios_que_deseja_vincular: "Search one or more questionnaires to link",
    legacy_campo_1: "Field 1",
    legacy_campo_1_ex_cargo_de_poilicia: "Field 1 (e.g. Police role)",
    legacy_campo_2: "Field 2",
    legacy_campo_2_ex_vespertino: "Field 2 (e.g. Afternoon)",
    legacy_corretores_selecionados: "Selected graders",
    legacy_deletar_disciplina: "Delete subject",
    legacy_deletar_elaborador: "Delete author",
    legacy_deletar_organizadora: "Delete organizer",
    legacy_deletar_recurso: "Delete appeal",
    legacy_deletar_texto: "Delete text",
    legacy_desvincular_candidato: "Unlink candidate",
    legacy_desvincular_fiscal: "Unlink proctor",
    legacy_digite_a_confirmacao_de_senha: "Enter password confirmation",
    legacy_fiscais_selecionados: "Selected proctors",
    legacy_gerenciar_aula: "Manage lesson",
    legacy_gerenciar_candidato: "Manage candidate",
    legacy_gerenciar_disciplina: "Manage subject",
    legacy_gerenciar_imagem: "Manage image",
    legacy_gerenciar_organizadora: "Manage organizer",
    legacy_gerenciar_prova: "Manage test",
    legacy_gerenciar_recurso: "Manage appeal",
    legacy_gerenciar_texto: "Manage text",
    legacy_historico_de_resposta_s: "Answer history:",
    legacy_imagem_s_arquivo_s_da_resposta: "Answer image(s)/file(s):",
    legacy_imagem_s_arquivo_s_do_recurso: "Appeal image(s)/file(s):",
    legacy_imagens_arquivos_do_recurso_maximo_10_arquivos: "Appeal images/files (maximum 10 files)",
    legacy_incluir_campo_de_titulo_na_redacao: "Include title field in the essay?",
    legacy_incluir_folha_em_branco_apos_folha_de_rosto: "Include a blank sheet after the cover page?",
    legacy_numero_de_linhas_na_folha_de_redacao: "Number of lines on the essay sheet",
    legacy_pedido_realizado: "Submitted request",
    legacy_pesquise_o_avaliador_pelo_nome: "Search evaluator by name",
    legacy_pesquisar_pelo_nome_do_membro_da_organizadora: "Search by organizer member name",
    legacy_questao_selecionada_2: "Selected question:",
    legacy_redacoes_zip_rar: "Essays (.zip/.rar)",
    legacy_subtitulo_ex_local: "Subtitle (e.g. Location)",
    legacy_subtitulo_ex_estado_de_sao_paulo: "Subtitle. E.g. State of Sao Paulo",
    legacy_subtitulo_do_cabecalho: "Header subtitle",
    legacy_texto_de_apoio_pdf: "Supporting text (.pdf)",
    legacy_texto_informativo_na_tela_de_login: "Informational text on the login screen",
    legacy_texto_informativo_para_os_candidatos_que_ira_aparecer_na_tela_de_login: "Informational text for candidates that will appear on the login screen.",
    legacy_titulo_campo_1_ex_cargo: "Field 1 title (e.g. Role)",
    legacy_titulo_campo_2_ex_turno: "Field 2 title (e.g. Shift)",
    legacy_titulo_do_cabecalho: "Header title",
    legacy_tamanho_da_fonte_das_instrucoes: "Instruction font size",
    legacy_tamanho_da_fonte_do_cabecalho_da_folha_de_rosto: "Cover page header font size",
    legacy_visualizar: "View",
    legacy_visualizar_texto: "View text",
    legacy_cabecalho_folha_de_rosto: "Cover page header",
    legacy_caminho_da_url: "URL path",
    legacy_cnpj: "CNPJ",
    legacy_escreva_a_alternativa: "Write the alternative",
    legacy_escreva_a_pergunta: "Write the question",
    legacy_escreva_a_pergunta_do_campo_texto: "Write the text field question",
    legacy_escreva_o_placeholder_do_campo_texto: "Write the text field placeholder",
    legacy_fundamentacao_do_pedido: "Request rationale",
    legacy_fundamentacao_do_pedido_2: "Request rationale:",
    legacy_horario_limite: "Deadline time",
    legacy_informacao_geral: "General information",
    legacy_informacao_geral_2: "General information:",
    legacy_informacao_para_o_avaliador: "Information for the evaluator",
    legacy_informacao_para_o_avaliador_2: "Information for the evaluator:",
    legacy_logo_superior: "Top logo",
    legacy_logo_inferior: "Bottom logo",
    legacy_numero_de_inscricao_do_candidato: "Candidate registration number",
    legacy_obrigatorio_sempre: "Always required",
    legacy_obrigatorio_se: "Required if",
    legacy_qual_a_alternativa_correta: "Which is the correct alternative?",
    legacy_texto_do_topico: "Topic text",
    legacy_visualizar_pergunta_do_questionario: "View questionnaire question",
    legacy_vincular_corretor_es: "Link grader(s)",
    legacy_dashboard: "← Dashboard",
    legacy_cadastrados_na_plataforma: "registered on the platform",
    legacy_as_vagas: "vacancies",
    legacy_os_processos: "processes",
    legacy_candidatos_e_equipe: ", candidates and team",
    legacy_da_instituicao: "of the institution",
    legacy_do_processo: "of the process",
    legacy_instituicoes: "institutions",
    legacy_processos: "processes",
    ui_sim_desejo_desvincular_91364237: "Yes, unlink",
    ui_ao_desvincular_este_questao_ele_nao_tera_mais_aces_7cad3b8d: "After unlinking this question, it will no longer have access to this process questions",
    ui_ao_deletar_este_candidato_ele_nao_estara_mais_disp_014976fb: "After deleting this candidate, they will no longer be available in the system",
    ui_cadastrar_candidato_00a96ef8: "Create Candidate",
    ui_cadastre_os_candidatos_cd2390f0: "Register candidates",
    ui_o_candidato_precisa_de_alguma_funcao_de_acessibili_9ef2ad9d: "Does the candidate need any accessibility feature? Example: listen to question text",
    ui_e_necessario_um_fiscal_supervisor_77284eb8: "Is a supervising proctor required?",
    ui_habilitar_opcao_de_ouvir_questao_redacao_744ae16d: "Enable option to listen to question/essay?",
    ui_habilitar_possibilidade_de_ampliar_questao_redacao_cb06350b: "Enable the option to enlarge question/essay?",
    ui_data_invalida_76fc5825: "Invalid date",
    ui_editar_candidato_de3b0830: "Edit Candidate",
    ui_aqui_ficam_as_analises_dos_candidatos_do_processo_4d85efa9: "Candidate analyses for process \"",
    ui_acuracia_media_ed46129a: "Average accuracy",
    ui_melhor_acuracia_9143c643: "Best accuracy",
    ui_pior_acuracia_eca7bfc4: "Worst accuracy",
    ui_acoes_reportadas_473f06f8: "Reported actions",
    ui_aqui_ficam_as_analises_das_imagens_do_candidato_8490cebb: "Image analyses for candidate \"",
    ui_acuracia_18c91bc7: "Accuracy",
    ui_ultimo_login_64f79636: "Last login:",
    ui_aqui_ficam_as_analises_dos_candidatos_vinculados_a_7ea29b91: "Analyses for candidates linked to process \"",
    ui_estatisticas_bd290229: "Statistics",
    ui_nao_detectada_0d0935c6: "Not detected:",
    ui_multiplas_faces_detectadas_944de664: "Multiple faces detected:",
    ui_ao_deletar_este_avaliador_ele_nao_estara_mais_disp_5a8e24a5: "After deleting this evaluator, they will no longer be available in the system",
    ui_gerencie_os_avaliadores_vinculados_ao_processo_e1675ff5: "Manage evaluators linked to the process",
    ui_ao_desvincular_este_avaliador_ele_nao_tera_mais_ac_341570a9: "After unlinking this evaluator, they will no longer have access to this process",
    ui_nenhum_avaliador_encontrado_com_este_termo_02f9a1af: "No evaluator found with this term",
    ui_salvar_avaliadores_07b49db6: "Save evaluators",
    ui_bem_vindo_a_questoes_publicas_043b7469: "Welcome to Public Questions!",
    ui_filtrar_questoes_6421faf4: "Filter Questions",
    ui_tipo_de_questao_d2c9716b: "Question Type",
    ui_ensino_medio_3712ec7a: "High School",
    ui_nivel_de_dificuldade_a85f6b3c: "Difficulty level",
    ui_facil_e304d15a: "Easy",
    ui_medio_4f48c19e: "Medium",
    ui_dificil_36dc8fb0: "Hard",
    ui_utilizar_questao_3fee6791: "Use Question",
    ui_alterar_questao_bbfea6ad: "Change question",
    ui_aqui_ficam_a_confiabilidade_dos_candidatos_no_d344db7b: "Candidate reliability indicators for \"",
    ui_quanto_menor_o_valor_mais_confiavel_6654eba4: "\". The lower the value, the more reliable",
    ui_acoes_reportadas_3b561a75: "Reported actions:",
    ui_media_do_reconhecimento_facial_cda4999c: "Average facial recognition:",
    ui_validacoes_faciais_periodicas_004cccb9: "Periodic facial validations:",
    ui_numero_de_pedidos_de_liberacao_para_o_fiscal_ae10b565: "Number of release requests to the proctor:",
    ui_saidas_de_tela_101c35f0: "Screen exits:",
    ui_tempo_de_saida_da_tela_de_prova_75e5fa8c: "Assessment screen exit time:",
    ui_videos_sem_rosto_39a8f692: "Videos without face:",
    ui_multiplas_rostos_2288af49: "Multiple faces:",
    ui_ips_identicos_a9e2cc1b: "Identical IPs:",
    ui_ao_desvincular_este_candidato_ele_nao_tera_mais_ac_1d2c882c: "After unlinking this candidate, they will no longer have access to this process",
    ui_aqui_ficam_os_candidatos_ordernados_por_saidas_da__b0224f9a: "Candidates ordered by assessment screen exits for \"",
    ui_quanto_menor_mais_confiavel_46a756c2: "The lower, the more reliable",
    ui_vincule_um_ou_mais_candidatos_ao_processo_aeb7a3be: "Link one or more candidates to the process",
    ui_nenhum_candidato_encontrado_com_este_termo_2b9da6d2: "No candidate found with this term",
    ui_candidatos_selecionados_c38f4abb: "Selected candidates",
    ui_nenhum_candidato_selecionado_5cf1f638: "No candidate selected",
    ui_salvar_candidatos_87fdb232: "Save candidates",
    ui_salvando_candidatos_bfb38308: "Saving candidates",
    ui_aqui_ficam_os_registros_de_tela_do_candidato_dd8ad37e: "Screen records for candidate \"",
    ui_ao_deletar_esta_imagem_ela_nao_estara_mais_disponi_fba6b358: "After deleting this image, it will no longer be available in the system",
    ui_aqui_ficam_as_imagens_do_candidato_6138c418: "Images for candidate \"",
    ui_proximo_64b2d0d6: "Next",
    ui_nenhuma_imagem_encontrada_2840b232: "No image found",
    ui_ao_deletar_este_image_ele_nao_estara_mais_disponiv_e2464011: "After deleting this image, it will no longer be available in the system",
    ui_aqui_fica_os_logs_de_conexao_do_candidato_d73a76d4: "Connection logs for candidate \"",
    ui_logs_de_conexao_86069e78: "Connection logs:",
    ui_ao_deletar_este_relatorio_ele_nao_estara_mais_disp_34cd8ca1: "After deleting this report, it will no longer be available in the system",
    ui_aqui_ficam_as_mensagens_do_candidato_92001b7d: "Messages for candidate \"",
    ui_ao_deletar_este_message_ele_nao_estara_mais_dispon_ff224805: "After deleting this message, it will no longer be available in the system",
    ui_adicionar_candidatos_no_processo_4fc3ab7a: "Add candidates to the process",
    ui_arquivo_csv_contendo_os_dados_dos_candidatos_272963f2: ".csv file containing candidate data",
    ui_padrao_3386172b: "Pattern:",
    ui_o_csv_nao_deve_ter_cabecalho_nome_das_colunas_as_c_641b51e4: "The .csv must not include a header row. Columns must be separated by “;” in the following format:",
    ui_numero_inscricao_nome_e_mail_data_de_nascimento_yy_e687bdde: "Registration number; Name; E-mail; Birth date (YYYY-MM-DD); CPF (without . or -); Password; Candidate photo link (Optional)",
    ui_nenhum_candidato_adicionado_33c9a2c9: "No candidate added",
    ui_aqui_ficam_as_avaliacoes_do_candidato_fd246cf8: "Assessments for candidate \"",
    ui_redacoes_30c87866: "Essays:",
    ui_redacao_cd320598: "Essay",
    ui_gerenciar_correcao_c17fdb3e: "Manage grading",
    ui_gerenciar_redacao_b69a0438: "Manage essay",
    ui_nenhuma_redacao_encontrado_eb318de7: "No essay found",
    ui_questionarios_fefc98ab: "Questionnaires:",
    ui_questionario_a3ec8d1d: "Questionnaire",
    ui_nenhum_questionario_encontrado_cc92c82e: "No questionnaire found",
    ui_aqui_fica_o_relatorio_do_candidato_37e99da8: "Candidate report for \"",
    ui_acao_d621dc82: "Action",
    ui_ate_fc454800: "Until",
    ui_saiu_da_pagina_da_aplicacao_fda9235a: "Left the application page:",
    ui_horario_3bd854d6: "Time",
    ui_ver_video_da_camera_0a3101ee: "View Camera Video",
    ui_ver_video_da_tela_b4b78e7f: "View Screen Video",
    ui_nenhuma_acao_registrada_aebf4fac: "No action recorded",
    ui_registros_de_saida_27d28fba: "Exit Records:",
    ui_avisos_de_restricao_de_horario_duas_ou_mais_telas__902f57ad: "Time restriction/two or more screens/permissions warnings:",
    ui_media_do_reconhecimento_facial_001ef5c2: "Average facial recognition",
    ui_validacoes_faciais_periodicas_f9280df8: "Periodic facial validations",
    ui_numero_de_pedidos_de_liberacao_para_o_fiscal_217b2c1f: "Number of release requests to the proctor",
    ui_tempo_de_saida_da_tela_de_prova_7fd35c63: "Assessment screen exit time",
    ui_videos_sem_rosto_57354ae0: "Videos without face",
    ui_multiplas_rostos_de74b532: "Multiple faces",
    ui_ips_identicos_df44355b: "Identical IPs",
    ui_sim_desejo_liberar_b38fec32: "Sí, deseo liberar",
    ui_ao_liberar_esse_candidato_ele_tera_acesso_a_avalia_8784a55f: "When released, this candidate will have access to the assessment if they did not enter during the configured time window or if they had already finished the assessment",
    ui_aqui_ficam_os_videos_da_tela_do_candidato_8209a3d0: "Screen videos for candidate \"",
    ui_nenhum_video_de_tela_encontrado_372de0f0: "No screen video found",
    ui_ao_deletar_este_video_ele_nao_estara_mais_disponiv_db74e885: "After deleting this video, it will no longer be available in the system",
    ui_aqui_ficam_os_videos_do_candidato_a563f69c: "Videos for candidate \"",
    ui_nenhum_video_encontrado_6180dcce: "No video found",
    ui_ao_deletar_esta_disciplina_ela_nao_estara_mais_dis_6ced45ee: "After deleting this subject, it will no longer be available in the system",
    ui_contexto_da_questao_36e5d6aa: "Question context",
    ui_tipo_de_questao_2e2adb09: "Question type:",
    ui_nivel_de_escolaridade_d4702d75: "Education level:",
    ui_nivel_de_dificuldade_0d029649: "Difficulty level:",
    ui_editar_criar_novo_contexto_0450e752: "Edit/Create new context",
    ui_gerar_questao_d655bb9d: "Generate question",
    ui_questoes_geradas_pendentes_de_validacao_18471a7e: "Generated questions pending validation",
    ui_altere_a_disciplina_do_contexto_para_ver_questao_p_815d5e95: "Change the context subject to view pending questions from another subject",
    ui_validar_questao_787fc7b5: "Validate question",
    ui_salvar_disciplina_b7d69832: "Save subject",
    ui_cadastre_as_questoes_da_disciplina_2788a383: "Register questions for the subject",
    ui_criando_questao_a_partir_de_uma_questao_gerada_por_fa6bba4a: "*Creating a question from an AI-generated question*",
    ui_criar_questao_com_ia_e87441a1: "Create question with AI",
    ui_nivel_de_escolaridade_a4c58d10: "Education level",
    ui_gerenciar_questao_71268f08: "Manage question",
    ui_deletar_questao_6f8e24a2: "Delete question",
    ui_salvando_questao_848b910e: "Saving question",
    ui_editar_disciplina_3a3c3d30: "Edit Subject",
    ui_edite_uma_questao_da_disciplina_dec9ff97: "Edit a question for the subject",
    ui_questao_56688686: "Question -",
    ui_abra_o_teclado_de_formula_clicando_em_3de9635e: "Open the formula keyboard by clicking",
    ui_aperte_shift_em_cada_aba_do_teclado_para_ver_mais__8e0b3b8b: "Press SHIFT on each keyboard tab to see more options",
    ui_salvando_formula_f82737d5: "Saving formula",
    ui_solucao_b354e358: "Solution:",
    ui_questao_de_31457044: "Question from",
    ui_adicionar_questoes_na_disciplina_03c19af6: "Add questions to subject",
    ui_palavras_chaves_palavras_que_serao_aplicadas_para__c51efe30: "Keywords (words used to identify every question in the file)",
    ui_arquivo_docx_contendo_as_questoes_f5bf5ebe: ".docx file containing the questions",
    ui_o_docx_deve_ter_os_seguintes_caracteres_dividindo__d9815b36: "The .docx must use the following characters to separate each question: $$$$$",
    ui_o_docx_deve_ter_os_seguintes_caracteres_dividindo__37d81673: "The .docx must use the following characters to separate each alternative: &&&&&",
    ui_se_for_a_ultima_questao_ao_final_do_arquivo_tambem_e587849a: "For the last question, the end of the file must also include the characters: $$$$$",
    ui_o_docx_deve_ter_os_seguintes_caracteres_para_indic_1d1f63f4: "The .docx must use the following characters to indicate that the line below contains the question answer: =====",
    ui_nenhuma_questao_cadastrada_2b696d49: "No question registered",
    ui_ao_deletar_esta_questao_ela_nao_estara_mais_dispon_a09d435b: "After deleting this question, it will no longer be available in the system",
    ui_deseja_marcar_essa_questao_como_b8074843: "Do you want to mark this question as",
    ui_defina_o_contexto_da_questao_4d71daea: "Define the question context",
    ui_crie_uma_questao_utilizando_inteligencia_artificia_66097e93: "Create a question using artificial intelligence",
    ui_descreva_o_assunto_especifico_da_questao_b704a6ac: "Describe the specific question topic",
    ui_avancar_82625e8f: "Continue",
    ui_essa_questao_foi_criada_por_ia_voce_deve_confirmar_74018da6: "This question was created by AI. You must confirm the quality of the generated question.",
    ui_voce_tem_certeza_que_deseja_validar_esta_questao_9e34f2f8: "Are you sure you want to validate this question?",
    ui_ao_confirmar_sera_redirecionado_para_a_pagina_de_b3319da3: "After confirming, you will be redirected to the page",
    ui_criar_questao_beccec03: "\"Create Question\"",
    ui_onde_podera_editar_seu_conteudo_como_desejar_10c9f36f: ", where you can edit its content as needed.",
    ui_ao_deletar_este_membro_ele_nao_tera_mais_acesso_ao_65edeccd: "After deleting this member, they will no longer have access to the system",
    ui_deletar_conteudo_654f6956: "Delete content",
    ui_cadastrar_conteudo_419aa739: "Register content",
    ui_cadastre_os_conteudos_do_seu_sistema_2deb6d86: "Register your system content",
    ui_nome_do_conteudo_103bd7e3: "Content name",
    ui_selecione_qual_sera_o_tipo_do_arquivo_5c78c931: "Select the file type",
    ui_video_03e7e13e: "Video",
    ui_upload_do_video_menor_do_que_200_mb_3a58957f: "Video upload (less than 200 MB)",
    ui_pre_visualizacao_65cab02c: "Preview",
    ui_salvando_conteudo_03d904a8: "Saving content",
    ui_cadastre_as_questoes_do_conteudo_c3aecc68: "Register content questions",
    ui_nome_da_questao_fbe10cc2: "Question name",
    ui_editar_conteudo_f001902a: "Edit content",
    ui_upload_do_pdf_caso_seja_o_mesmo_nao_escolha_nenhum_2e4b8884: "PDF upload (if unchanged, do not choose a file)",
    ui_upload_do_video_caso_seja_o_mesmo_nao_escolha_nenh_a0aacf5a: "Video upload (if unchanged, do not choose a file)",
    ui_upload_da_capa_do_video_caso_seja_o_mesmo_nao_esco_ba01a936: "Video cover upload (if unchanged, do not choose a file)",
    ui_seu_navegador_nao_suporta_o_elemento_de_video_05b48753: "Your browser does not support the video element.",
    ui_edite_uma_questao_do_conteudo_5a52b2a7: "Edit a content question",
    ui_editar_perguntas_9063b9f2: "Edit questions",
    ui_nao_foi_possivel_encontrar_o_arquivo_080c0a5a: "Could not find the file.",
    ui_questao_de_6a47d07b: "Question from:",
    ui_ao_deletar_este_corretor_ele_nao_estara_mais_dispo_823c3f53: "After deleting this grader, they will no longer be available in the system",
    ui_correcoes_redacoes_440ee433: "Essay corrections",
    ui_correcoes_dissertativas_926a5325: "Discursive corrections",
    ui_ao_desvincular_este_corretor_ele_nao_tera_mais_ace_2636a0a7: "After unlinking this grader, they will no longer have access to this process rooms",
    ui_nenhum_corretor_encontrado_com_este_termo_6d600488: "No grader found with this term",
    ui_corrigira_quais_redacoes_9a93a9ff: "Which essays will be graded?",
    ui_nenhuma_sala_selecionada_bf0df991: "No room selected",
    ui_nome_e_mail_senha_cpf_candidato_opcional_numero_da_dc2d93eb: "Name; E-mail; Password; Candidate CPF (optional); Question number (optional); Rooms (optional)",
    ui_para_o_corretor_deve_ser_especificado_um_ou_mais_c_6d982098: "For the grader, one or more candidates must be specified along with the question number for discursive assessment grading, or an essay.",
    ui_ao_deletar_esta_atribuicao_o_elaborador_nao_tera_m_aedfe8f4: "After deleting this assignment, the author will no longer have access to this subject/demand",
    ui_horario_invalido_6d7a8390: "Invalid time",
    ui_salvando_demanda_f0fa62e8: "Saving demand",
    ui_gerenciar_demanda_d6f65913: "Manage demand",
    ui_ao_deletar_esta_demanda_ela_nao_estara_mais_dispon_c569a1d6: "After deleting this demand, it will no longer be available in the system",
    ui_edite_a_demanda_do_seu_sistema_ab251ef1: "Edit your system demand",
    ui_aqui_sao_listados_todas_as_questoes_da_demanda_0edb9c97: "All questions for demand \"",
    ui_questoes_objetivas_d444777a: "Objective questions:",
    ui_questoes_dissertativas_8b8bb598: "Discursive questions:",
    ui_descritivo_a0d41125: "Descritivo:",
    ui_cadastre_uma_diagramacao_de_prova_e9cacaf0: "Create an assessment layout",
    ui_nenhuma_prova_encontrada_para_diagramar_8d13fd70: "No test found to create a layout",
    ui_trazer_as_questoes_diagramadas_do_padrao_seleciona_840f3d1d: "Bring laid out questions from the selected template?",
    ui_instrucoes_7961e863: "Instructions",
    ui_numero_de_colunas_das_instrucoes_d22515a8: "Number of instruction columns",
    ui_salvando_diagramacao_303cdc1f: "Saving layout",
    ui_instrucoes_gerais_e7875311: "GENERAL INSTRUCTIONS",
    ui_realizacao_898ecc72: "Held by",
    ui_pagina_b3a7f96a: "Page",
    ui_nova_diagramacao_3f8a792f: "New Layout",
    ui_cadastre_a_primeira_diagramacao_deste_processo_921ee032: "Create the first layout for this process.",
    ui_ao_deletar_esta_diagramacao_ele_nao_estara_mais_di_596f476a: "After deleting this layout, it will no longer be available in the system",
    ui_aqui_ficam_as_respostas_da_prova_db6a9721: "Answers for test \"",
    ui_ao_desvincular_este_prova_ele_nao_tera_mais_acesso_b74083f3: "After unlinking this test, it will no longer have access to this process",
    ui_edite_uma_diagramacao_de_prova_6fc036bd: "Edit an assessment layout",
    ui_modulo_nao_habilitado_f5792cfe: "Module not enabled",
    ui_visualizar_diagramacao_b0136eb9: "View layout",
    ui_diagramacao_de_prova_do_aluno_a8bb0ec6: "Student test layout",
    ui_nenhum_download_registrado_6211f004: "No download recorded",
    ui_candidatos_da_entrevista_a9e44072: "Interview candidates",
    ui_avaliacao_b83b6158: "Assessment",
    ui_inicio_3ea3dd6c: "Start:",
    ui_nenhum_candidato_foi_vinculado_a_entrevista_1a26c285: "No candidate was linked to the interview.",
    ui_ao_desvincular_este_entrevista_ele_nao_tera_mais_a_3e116a66: "After unlinking this interview, it will no longer have access to this process",
    ui_horario_de_inicio_701ca30c: "Start time",
    ui_criterios_5fb45232: "Criteria:",
    ui_cadastrar_entrevista_2914b77a: "Create interview",
    ui_topicos_0e1d8c1b: "Topics",
    ui_remover_topico_e918d570: "Remove topic",
    ui_remover_criterio_ae4a7cae: "Remove criterion",
    ui_editar_entrevista_19c99dac: "Edit interview",
    ui_nenhuma_entrevista_encontrada_3eed3914: "No interview found",
    ui_ao_deletar_esta_entrevista_ele_nao_estara_mais_dis_2a6785b8: "After deleting this interview, it will no longer be available for candidates to answer",
    ui_topicos_e6378334: "Topics:",
    ui_configure_os_modulos_e_funcionalidades_disponiveis_208f88ed: "Configure the modules and features available to candidates",
    ui_configuracoes_salvas_com_sucesso_6f4c5595: "Settings saved successfully!",
    ui_ativacao_de_modulos_e_funcionalidades_d3a0ba81: "Module and Feature Activation",
    ui_nenhum_modulo_disponivel_018261fe: "No module available",
    ui_nao_existem_modulos_disponiveis_para_configuracao_43292f9a: "There are no modules available for configuration.",
    ui_total_candidatos_878e3013: "Total candidates",
    ui_candidatos_que_fizeram_login_14f0d12d: "Candidates who logged in",
    ui_candidatos_que_acessaram_a_tela_de_termos_e9f9141c: "Candidates who accessed the terms screen",
    ui_candidatos_que_acessaram_a_tela_de_avaliacao_nao_i_a41a4375: "Candidates who accessed the assessment not started screen",
    ui_candidatos_que_acessaram_a_tela_de_aceite_de_regra_da5f04ad: "Candidates who accessed the rules acceptance screen",
    ui_candidatos_que_acessaram_a_tela_de_avaliacao_em_an_1b4c8a44: "Candidates who accessed the assessment in progress screen",
    ui_candidatos_que_acessaram_a_tela_de_avaliacao_final_7987b18b: "Candidates who accessed the completed assessment screen",
    ui_candidatos_ausentes_906899d3: "Absent candidates",
    ui_candidatos_que_acessaram_e_nao_finalizaram_fe2f36f7: "Candidates who accessed and did not finish",
    ui_candidatos_que_acessaram_e_finalizaram_c9793b24: "Candidates who accessed and finished",
    ui_descicao_8a9d0ffe: "Description:",
    ui_nao_iniciado_79f0570c: "Not started",
    ui_opcoes_de_relatorio_b2f110b8: "Report options:",
    ui_candidatos_avaliadores_online_639e532c: "Candidates/Evaluators online",
    ui_analises_faciais_5ef2980a: "Facial analyses",
    ui_analises_objetos_7b70af86: "Object analyses",
    ui_analises_movimento_facial_9f470e32: "Facial movement analyses",
    ui_candidatos_online_por_sala_c4a7fb6b: "Online candidates by room:",
    ui_candidatos_online_fe6d8bc6: "Online candidates",
    ui_nenhum_avaliador_online_vinculado_a_este_cargo_85e7dc18: "No online evaluator linked to this position",
    ui_nenhum_a_13fdab50: "None",
    ui_cadastre_a_primeira_para_comecar_6d5dc4dd: "Create the first one to get started.",
    ui_ao_deletar_esta_faculdade_ela_nao_estara_mais_disp_09656d24: "After deleting this institution, it will no longer be available in the system",
    ui_responsavel_dac53a5e: "Owner:",
    ui_voltar_para_cd10d454: "← Back to",
    ui_instituicao_criada_em_8e333c6a: "Institution created on",
    ui_ao_deletar_este_fiscal_ele_nao_estara_mais_disponi_ba3bc4ca: "After deleting this proctor, they will no longer be available in the system",
    ui_nenhum_fiscal_encontrado_com_este_termo_7c6340f3: "No proctor found with this term",
    ui_nenhum_fiscal_selecionado_b8684c0e: "No proctor selected",
    ui_ao_desvincular_este_fiscal_ele_nao_tera_mais_acess_05fc2cf3: "After unlinking this proctor, they will no longer have access to this process",
    ui_nome_e_mail_senha_tipo_fiscal_coordenador_ou_fisca_3df45539: "Name; E-mail; Password; Type (coordinator_proctor or regular_proctor); Rooms",
    ui_as_salas_devem_ser_especificadas_entre_ou_seja_se__164c8379: "Rooms must be specified separated by commas. For example, to assign a proctor to rooms 1, 2 and 3, use: 1,2,3",
    ui_nenhum_fiscal_adicionado_151a84e5: "No proctor added",
    ui_cadastrar_membro_da_equipe_02c4e5d7: "Create Team Member",
    ui_editar_membro_da_equipe_9c426afb: "Edit Team Member",
    ui_cadastrar_modulo_a9b6ba58: "Create Module",
    ui_nenhum_conteudo_encontrado_com_este_termo_a1a14166: "No content found with this term",
    ui_conteudos_vinculados_7adf15fe: "Linked content",
    ui_salvando_modulo_c5640cd0: "Saving module",
    ui_editar_modulo_cead4a60: "Edit Module",
    ui_edite_um_modulo_do_seu_sistema_435e4985: "Edit a module in your system",
    ui_cadastrar_organizadora_6386ed45: "Create Organizer",
    ui_dados_do_usuario_549a26c8: "User data",
    ui_editar_organizadora_54d2b6d8: "Edit Organizer",
    ui_nenhuma_organizadora_encontrada_f5da8ee0: "No organizer found",
    ui_ao_deletar_esta_organizadora_ela_nao_tera_mais_ace_05022d02: "After deleting this organizer, it will no longer have access to the system",
    ui_e_suas_regras_9951434d: "e suas regras.",
    ui_a_avaliacao_e_online_63f6668d: "Is the assessment online?",
    ui_e_um_avaliacao_oral_031e9629: "Is this an oral assessment?",
    ui_se_habilitado_esta_vaga_cargo_sera_uma_entrevista__b2e828a7: "If enabled, this vacancy/position will be an interview (oral assessment) with linked candidates.",
    ui_e_um_simulado_para_teste_de_compatibilidade_dos_ca_be36cb46: "Is this a mock test to check candidate compatibility?",
    ui_se_habilitado_essa_vaga_cargo_sera_um_teste_para_o_6222b09d: "If enabled, this vacancy/position will be a test so candidates can access the system and test their equipment.",
    ui_cada_avaliacao_tera_um_tempo_maximo_para_fazer_e0de075c: "Will each assessment have a maximum completion time?",
    ui_se_habilitado_na_hora_de_criar_a_prova_sera_obriga_8f8b7f7f: "If enabled, when creating the test it will be required to define the time, in minutes, that each question can take.",
    ui_o_candidato_podera_solicitar_pausa_durante_a_prova_6d5871fc: "Can the candidate request a pause during the test?",
    ui_se_habilitado_e_exibilido_um_botao_de_pedir_pausa__a63c10d6: "If enabled, a “request pause” button is shown to the candidate during the assessment.",
    ui_o_candidato_podera_acessar_por_dispositivos_moveis_f529a234: "Can the candidate access from mobile devices?",
    ui_se_habilitado_a_avaliacao_tambem_podera_ser_realiz_ccf181b9: "If enabled, the assessment can also be taken on mobile devices, but some features may be limited.",
    ui_disponibilizar_campo_para_rascunho_em_cada_questao_59890895: "Provide a draft field for each question?",
    ui_se_habilitado_em_cada_questao_tera_um_botao_de_ras_29b1be64: "If enabled, each question will have a draft button for the candidate. A text box will open for writing notes. Drafts are not saved by the system.",
    ui_obrigar_o_uso_de_tela_cheia_para_ver_a_avaliacao_81575207: "Require full screen to view the assessment?",
    ui_se_habilitado_o_candidato_so_conseguira_fazer_a_av_c5c6d2f3: "If enabled, the candidate can only take the assessment in full screen. If they leave full screen, the system records it as a screen exit.",
    ui_tempo_de_prova_em_minutos_que_o_candidato_tera_apo_f25d6411: "Assessment time in minutes after the candidate first accesses it",
    ui_tempo_em_minuntos_anterior_a_avaliacao_que_deve_ap_6be44aeb: "Minutes before the assessment when the proctor chat should appear to the candidate",
    ui_exemplo_caso_seja_colocado_60_minutos_entao_uma_ho_3f08b307: "Example: if 60 minutes is configured, one hour before the assessment starts the chat with proctors will appear for the candidate.",
    ui_se_habilitada_o_candidato_so_conseguira_acessar_a__104a32e1: "If enabled, the candidate can only access the test after a single face is identified in the camera image, head movements are validated, and a microphone phrase is spoken.",
    ui_tempo_em_minuntos_anterior_a_avaliacao_que_deve_ap_018422a2: "Minutes before the assessment when a release request button should appear to the candidate",
    ui_exemplo_caso_seja_colocado_60_minutos_entao_uma_ho_333a557f: "Example: if 60 minutes is configured, one hour before the assessment starts a release request button will appear if the candidate cannot complete facial validation.",
    ui_se_habilitada_caso_apos_o_candidato_acessar_a_aval_76209b26: "If enabled, if no face or microphone audio is detected for a configured time after the candidate accesses the assessment, the candidate must validate again.",
    ui_tempo_sem_reconhecimento_para_o_candidato_ter_que__36fb327b: "Time without recognition before the candidate must redo facial validation (in seconds)",
    ui_restringir_horario_de_acesso_do_candidato_ff671aed: "Restrict candidate access time?",
    ui_candidatos_que_nao_tiverem_acessado_o_sistema_dent_db3aa123: "Candidates who have not accessed the system within a configured time window will not be able to access the test",
    ui_horario_inicial_do_intervalo_dbb8ab8c: "Interval start time",
    ui_data_de_encerramento_do_intervalo_ca148297: "Interval end date",
    ui_o_evento_sera_dividido_em_blocos_d2406ebe: "Will the event be split into blocks?",
    ui_caso_sim_e_possivel_definir_o_tempo_de_cada_bloco__e1f7d3b8: "If yes, it is possible to define the duration of each block and an interval duration.",
    ui_ao_deletar_este_processo_ele_nao_estara_mais_dispo_d822045c: "After deleting this process, it will no longer be available in the system",
    ui_ao_deletar_este_elaborador_ele_nao_tera_mais_acess_c6438fc1: "After deleting this author, they will no longer have access to the system",
    ui_cadastrar_prova_05e853e9: "Create test",
    ui_configuracoes_adicionais_0d9c9733: "Additional settings",
    ui_ordem_das_questoes_d3f085f2: "Question order",
    ui_selecao_das_questoes_c85b2f2d: "Question selection",
    ui_forma_de_aleatorizacao_499ad86d: "Randomization method",
    ui_numero_de_questoes_que_devem_ser_selecionadas_c940b4a7: "Number of questions to be selected",
    ui_numero_de_questoes_que_devem_ser_selecionadas_def12a81: "Number of questions to be selected:",
    ui_exibicao_das_questoes_8463a65b: "Question display",
    ui_definir_um_numero_maximo_de_provas_aleatorias_gera_78fd6056: "Set a maximum number of generated random tests?",
    ui_numero_de_provas_geradas_5c4213f8: "Number of generated tests:",
    ui_numero_de_provas_que_vao_ser_geradas_ebe3dc3e: "Number of tests to be generated",
    ui_o_candidato_podera_retornar_para_a_questao_anterio_9d388b4d: "Can the candidate return to the previous question after moving to the next one?",
    form_auto_advance_on_answer_question: "After answering, automatically move to the next question?",
    form_auto_advance_on_answer_yes: "Yes, move forward and block answer changes",
    form_auto_advance_on_answer_no: "No, keep the candidate on the current question",
    form_show_answer_map_question: "Show answer map during the exam?",
    description_show_answer_map: "When disabled, the candidate will not see the answered questions summary above the current question.",
    form_finished_result_visibility: "At the end of the exam, show",
    form_finished_result_answer_sheet: "Candidate answer sheet",
    form_finished_result_accuracy_sheet: "Correct and incorrect answers report",
    form_finished_result_answer_and_accuracy: "Answer sheet with correct and incorrect answers",
    form_finished_result_exam_booklet: "Exam booklet",
    form_finished_result_exam_booklet_correct: "Exam booklet with answer key",
    form_finished_result_exam_booklet_candidate: "Exam booklet with answer key and candidate answers",
    form_allow_download_answer_and_accuracy_sheet: "Download answer sheet with correct and incorrect answers",
    form_finished_result_none: "None of the options",
    form_finished_result_mirror: "Exam booklet",
    description_finished_result_mirror: "Shows the exam booklet mirror with questions, alternatives, and the configured correctness rules.",
    form_finished_result_period: "Candidate display period",
    description_finished_result_period: "Leave blank to display immediately and without an end date.",
    form_finished_result_downloads: "Allow download",
    form_allow_download_answer_sheet: "Download answer sheet",
    form_allow_download_accuracy_sheet: "Download correct and incorrect answers report",
    form_allow_download_mirror: "Download exam booklet",
    legacy_prova_dissertativa: "Essay exam",
    exam_options_summary_eyebrow: "Settings",
    exam_options_summary_title: "Options selected when creating the exam",
    exam_options_summary_description: "Summary of display, organization, result and download rules configured for this exam.",
    exam_options_basic: "Exam data",
    exam_options_randomization: "Question organization",
    exam_options_candidate_view: "Candidate view",
    exam_options_one_question: "One question at a time",
    exam_options_all_questions: "All questions",
    exam_options_exam_time: "Exam time",
    exam_options_use_exam_models: "Use exam models",
    exam_options_exam_models_count: "Number of models",
    exam_options_shuffle_questions: "Shuffle questions",
    exam_options_shuffle_alternatives: "Shuffle alternatives",
    exam_options_select_from_group: "Select from group",
    exam_options_random_by_subject: "Random by subject",
    exam_options_block_return_after_pause: "Block return after pause",
    exam_options_immediate_display: "Immediate display, with no end date",
    exam_options_no_downloads: "No download enabled for this option",
    ui_bloquear_de_alterar_respostas_de_questoes_ja_vista_aaa83af2: "Block changes to answers for questions already viewed after a pause request?",
    ui_tempo_por_questao_em_minutos_5407240a: "Time per question in minutes",
    ui_tempo_por_questao_eaffb704: "Time per question",
    ui_selecionar_todas_as_questoes_desta_disciplina_7d72b315: "Select all questions from this subject",
    ui_selecionar_questoes_por_palavra_chave_76d0ed50: "Select questions by keyword",
    ui_nenhuma_questao_encontrada_com_este_termo_69f1b489: "No question found with this term",
    ui_editar_prova_097be7e1: "Edit test",
    ui_bloquear_de_alterar_respostas_de_questoes_ja_vista_cb647283: "Block changes to answers for questions already viewed after a pause request?",
    ui_buscar_questoes_da_disciplina_93831202: "Search subject questions",
    ui_salvando_questoes_187c0279: "Saving questions",
    ui_gerencie_as_provas_vinculadas_ao_processo_5ce1abb6: "Manage tests linked to the process",
    ui_ao_deletar_esta_prova_ele_nao_estara_mais_disponiv_7c8cffac: "After deleting this test, it will no longer be available for candidates to answer",
    ui_aqui_ficam_as_questoes_da_prova_62cf730a: "Questions for test \"",
    ui_cadastrar_questionario_c27e40cd: "Create Questionnaire",
    ui_cadastre_um_novo_questionario_no_sistema_9b7d9485: "Create a new questionnaire in the system",
    ui_ver_questionario_08339686: "View questionnaire",
    ui_salvando_questionario_446add5a: "Saving questionnaire",
    ui_edite_um_questionario_do_sistema_9c25790b: "Edit a system questionnaire",
    ui_cadastrar_pergunta_do_questionario_21b5431b: "Create Questionnaire Question",
    ui_paragrafo_1c4bc2b2: "Paragraph",
    ui_nao_e_obrigatorio_4b5bab2b: "Not required",
    ui_obrigatorio_se_assinalado_59d615fd: "Required if checked \"(",
    ui_gerenciar_questionario_4cf424e3: "Manage questionnaire",
    ui_deletar_questionario_44d0f59c: "Delete questionnaire",
    ui_ao_deletar_este_questionario_ela_nao_estara_mais_d_523483a1: "After deleting this questionnaire, it will no longer be available in the system",
    ui_vincular_questionario_s_0c995c4c: "Link Questionnaire(s)",
    ui_vincule_um_ou_mais_questionarios_ao_processo_a186a3eb: "Link one or more questionnaires to the process",
    ui_onde_o_questionario_ira_aparecer_be82f196: "Where will the questionnaire appear?",
    ui_pesquise_o_questionario_pelo_nome_ab3d430c: "Search questionnaire by name",
    ui_nenhum_questionario_encontrado_com_este_termo_a4b1cd9f: "No questionnaire found with this term",
    ui_questionarios_selecionados_6a604e81: "Selected questionnaires",
    ui_desvincular_questionario_ac6d9747: "Unlink questionnaire",
    ui_nenhum_questionario_selecionado_d6a1afb8: "No questionnaire selected",
    ui_salvando_questionarios_0ee57d98: "Saving questionnaires",
    ui_gerencie_os_questionarios_vinculados_ao_processo_10b384f8: "Manage questionnaires linked to the process",
    ui_adicionar_questionarios_2a88af71: "Add Questionnaires",
    ui_vincule_o_primeiro_questionario_ao_processo_958376ac: "Link the first questionnaire to the process.",
    ui_ao_desvincular_este_questionario_ele_nao_estara_ma_574217ce: "After unlinking this questionnaire, it will no longer be available in this process",
    ui_aqui_ficam_as_respostas_do_questionario_1755792c: "Responses for questionnaire \"",
    ui_aqui_ficam_as_questoes_do_questionario_264de9be: "Questions for questionnaire \"",
    ui_aqui_ficam_as_atribuicoes_da_demanda_25de260e: "Assignments for demand \"",
    ui_gerenciar_atribuicao_224a10c0: "Manage assignment",
    ui_deletar_atribuicao_ae0a77d8: "Delete assignment",
    ui_ao_deletar_esta_atribuicao_o_elaborador_nao_tera_m_55bce2dd: "After deleting this assignment, the author will no longer have access to this category/demand",
    ui_questao_avaliada_com_sucesso_55663755: "Question assessed successfully!",
    ui_carregando_comentarios_c260c035: "Loading comments...",
    ui_escreva_seu_comentario_aqui_c2486f14: "Write your comment here...",
    ui_enviar_avaliacao_629e5d59: "Submit assessment",
    ui_adicione_edite_atribuicoes_a_demanda_d174b85f: "Add/Edit assignments to demand \"",
    ui_numero_de_questoes_2fb10acf: "Number of questions:",
    ui_cadastre_um_recurso_de_uma_questao_do_seu_sistema_62fc3a72: "Create an appeal for a question in your system",
    ui_busque_a_questao_da_disciplina_55512db0: "Search the subject question",
    ui_nome_do_responsavel_df1f0fe8: "Responsible person name:",
    ui_e_mail_do_responsavel_6f9ed412: "Responsible person e-mail:",
    ui_edite_um_recurso_de_uma_questao_do_seu_sistema_4692e136: "Edit an appeal for a question in your system",
    ui_nao_especificar_ddfc6e39: "Do not specify",
    ui_ao_deletar_este_recurso_ela_nao_estara_mais_dispon_0ccc7650: "After deleting this appeal, it will no longer be available in the system",
    ui_avaliacao_de_questao_27fd4ee1: "Question assessment",
    ui_dados_da_questao_e4f73f31: "Question data",
    ui_data_de_criacao_b8ae5b5f: "Creation date:",
    ui_demanda_relacionada_e62c1518: "Related demand:",
    ui_o_campo_comentario_e_obrigatorio_2d86054e: "The comment field is required",
    ui_caso_a_questao_tenha_sido_editada_ela_so_sera_salv_2b9818fb: "If the question was edited, it will only be saved when submitting the assessment.",
    ui_descricao_dos_fatos_e3186d0b: "Description of facts:",
    ui_cadastre_as_redacoes_cd8d699e: "Create essays",
    ui_salvando_redacao_2875125c: "Saving essay",
    ui_edite_uma_redacao_f80c5cfb: "Edit an essay",
    ui_gerencie_as_redacoes_vinculadas_ao_processo_9e0682a4: "Manage essays linked to the process",
    ui_nova_redacao_f7f8f71a: "New Essay",
    ui_cadastre_a_primeira_redacao_deste_processo_7b43c0f0: "Create the first essay for this process.",
    ui_ao_deletar_esta_redacao_ele_nao_estara_mais_dispon_1440dab3: "After deleting this essay, it will no longer be available for candidates to answer",
    ui_todas_as_redacoes_devem_estar_no_formato_png_ou_jp_48fe5b0b: "All essays must be in .png or .jpg format, with the registration number as the image name, and compressed into a .zip/.rar file that can be selected below.",
    ui_salvando_redacoes_0ec9631b: "Saving essays",
    ui_aqui_ficam_as_respostas_da_redacao_d8e417d4: "Responses for essay \"",
    ui_ao_desvincular_este_redacao_ele_nao_tera_mais_aces_ea522608: "After unlinking this essay, it will no longer have access to this process",
    ui_aqui_ficam_as_correcoes_da_redacao_1feaced4: "Corrections for essay \"",
    ui_realizadas_por_inteligencia_artificial_e9b909ee: "\" performed by artificial intelligence",
    ui_ir_para_progresso_da_correcao_94b462b0: "Go to Correction Progress",
    ui_imprimir_template_da_redacao_42731392: "Print essay template",
    ui_aqui_ficam_os_textos_de_apoio_da_redacao_f7a787bd: "Supporting texts for essay \"",
    ui_ao_desvincular_este_texto_ele_nao_tera_mais_acesso_0fb3b0af: "After unlinking this text, it will no longer have access to this process texts",
    ui_baixe_relatorios_gerais_d7ab5b34: "Download general reports",
    ui_candidatos_62b9af6b: "candidates",
    ui_nenhuma_sala_foi_vinculada_a_este_processo_cc8c090a: "No room was linked to this process.",
    ui_ao_desvincular_este_sala_ele_nao_tera_mais_acesso__15f445ac: "After unlinking this room, it will no longer have access to this process rooms",
    ui_aqui_ficam_os_candidatos_da_sala_609742e7: "Candidates in Room \"",
    ui_aqui_ficam_os_fiscais_da_sala_b90de17f: "Proctors in Room \"",
    ui_aqui_ficam_os_corretores_da_sala_2997b757: "Graders in Room \"",
    ui_cadastrar_treinamento_4f504c6b: "Create Training",
    ui_nenhum_modulo_encontrado_com_este_termo_40aad181: "No module found with this term",
    ui_nenhum_usuario_encontrado_07e706e0: "No user found.",
    ui_editar_treinamento_2a8da4ce: "Edit Training",
    ui_editar_treinamento_modulos_e4254df3: "Edit Training/Modules",
    ui_nenhum_modulo_cadastrado_f4cff322: "No module registered",
    ui_nenhum_treinamento_cadastrado_1114c17b: "No training registered",
    ui_periodo_9d2b2bb8: "Period",
    ui_nenhum_treinamento_encontrado_327ab048: "No training found",
    ui_aqui_estao_listados_todos_os_treinamentos_do_seu_s_066f2573: "All trainings in your system are listed here",
    ui_nenhum_treinamento_encontrado_com_este_termo_01f25665: "No training found with this term",
    ui_videos_da_tela_6e150a3a: "Screen Videos",
    ui_gerenciar_candidatos_a4e149c2: "Manage candidates",
    ui_acessar_configuracoes_e95ce866: "Access settings",
    ui_gerencie_avaliadores_00986d21: "Manage evaluators",
    ui_avaliacao_oral_f015a022: "Oral Assessment",
    ui_configuracoes_da_avaliacao_oral_f1c2d588: "Oral assessment settings",
    ui_antes_de_iniciar_a_avaliacao_1026e291: "Before starting the assessment",
    ui_durante_a_avaliacao_b2e19d2f: "During the assessment",
    ui_apos_finalizada_a_avaliacao_4f08017f: "After the assessment is completed",
    ui_acompanhe_os_resultados_do_questionario_b2346d60: "Track questionnaire results.",
    ui_lista_os_candidatos_que_acessaram_a_plataforma_2258f573: "Lists candidates who accessed the platform.",
    ui_lista_quem_concedeu_permissoes_e_chegou_na_tela_de_47155e81: "Lists who granted permissions and reached the not-started assessment screen.",
  },
  es: {
    title_link_candidates: "Vincular candidatos",
    title_link_proctors: "Vincular supervisores",
    description_link_proctors: "Vincula uno o más supervisores al proceso",
    description_link_graders: "Vincula uno o más correctores al proceso",
    label_images: "Imágenes",
    label_messages: "Mensajes",
    description_candidate_messages: "Consulta los mensajes enviados durante el proceso.",
    action_import_csv: "Importar CSV",
    action_add_graders: "Agregar correctores",
    action_add_grader: "Agregar corrector",
    action_add_image: "Agregar imagen",
    action_add_video: "Agregar video",
    action_delete_image: "Eliminar imagen",
    action_delete_video: "Eliminar video",
    action_delete_candidate: "Eliminar candidato",
    action_delete_proctor: "Eliminar supervisor",
    action_delete_grader: "Eliminar corrector",
    action_delete_room: "Eliminar sala",
    action_unlink_grader: "Desvincular corrector",
    action_select_all_rooms: "Seleccionar todas las salas",
    action_previous: "Anterior",
    loading_generating_zip: "Generando ZIP...",
    loading_saving_proctors: "Guardando supervisores",
    loading_saving_graders: "Guardando correctores",
    label_first_login: "Primer acceso",
    status_never_accessed: "Nunca accedió al sistema",
    status_in_progress: "En curso",
    status_execution_error: "Error de ejecución",
    title_add_proctors_to_process: "Agregar supervisores al proceso",
    title_add_graders_to_process: "Agregar correctores al proceso",
    label_candidate_cpf: "CPF del candidato",
    option_generate_random_email: "Generar un correo aleatorio cuando no se encuentre en la planilla",
    label_birth_date_iso: "Fecha de nacimiento (AAAA-MM-DD)",
    label_cpf_digits_only: "CPF (solo números)",
    label_photo_link: "Enlace de la foto",
    candidate_documents: "Documentos",
    candidate_documents_description: "Consulta las fotos de perfil, aceptación y documentos enviados por el candidato.",
    candidate_profile_photo: "Foto del usuario",
    candidate_acceptance_photo: "Foto tomada en la pantalla de aceptación",
    candidate_document_photos: "Fotos de los documentos",
    candidate_document_composition: "Composición enviada",
    no_candidate_documents: "Ningún documento encontrado",
    no_candidate_documents_description: "Las fotos del candidato y de los documentos aparecerán aquí cuando estén disponibles.",
    face_photo: "Foto del rostro",
    document_photo: "Foto del documento",
    sent_composition: "Composición enviada",
    click_to_zoom: "Haz clic para ampliar y usar zoom",
    zoom_in: "Aumentar zoom",
    zoom_out: "Disminuir zoom",
    label_error: "Error",
    label_success: "Éxito",
    error_loading_modules: "Error al cargar los módulos",
    error_saving_settings: "Error al guardar la configuración",
    error_processing_server_response: "Error al procesar la respuesta del servidor",
    error_connecting_server: "Error al conectar con el servidor",
    error_saving_permissions_prefix: "Error al guardar",
    error_saving_permissions_middle: "de",
    error_saving_permissions_suffix: "permisos",
    settings_student_portal: "Portal del estudiante",
    settings_student_portal_description: "Portal donde el estudiante accede a la información del proceso selectivo.",
    settings_notice: "Convocatoria",
    settings_results: "Resultados",
    action_view_exam_external: "Ver examen externamente",
    description_exam_results: "Acompaña los resultados de este examen.",
    description_show_exam_page: "Aquí puedes ver las preguntas y los resultados del examen.",
    description_show_essay_page: "Aquí puedes ver los textos de apoyo y los resultados de la redacción.",
    settings_appeals: "Recursos",
    settings_question_appeals: "Recursos de preguntas",
    label_time_milliseconds: "Tiempo en milisegundos (ms)",
    action_release_reset_candidate_access: "Liberar o restablecer el acceso del candidato",
    title_system_logs: "Registros del sistema",
    label_from: "De",
    label_indexes: "Índices",
    label_photos_without_face: "Fotos sin rostro detectado",
    process_summary_title: "Resumen de la configuración",
    summary_identification: "Identificación",
    summary_not_informed: "No informado",
    summary_not_informed_yet: "Aún no informado",
    summary_filled_feminine: "Completada",
    summary_filled_plural: "Completadas",
    summary_pending_plural: "Pendientes",
    summary_not_applicable: "No se aplica",
    summary_modality: "Modalidad",
    summary_assessment: "Evaluación",
    summary_online: "En línea",
    summary_in_person: "Presencial",
    summary_oral_assessment: "Evaluación oral",
    summary_simulation: "Simulacro",
    summary_compatibility: "Compatibilidad",
    summary_block_exam: "Examen por bloques",
    summary_schedule: "Cronograma",
    summary_start: "Inicio",
    summary_time: "Tiempo",
    summary_restricted_after_access: "Restringido después del acceso",
    summary_total_time: "Tiempo total",
    summary_restricted_duration: "Duración restringida",
    summary_time_per_question: "Tiempo por pregunta",
    summary_required: "Obligatorio",
    summary_required_feminine: "Obligatoria",
    summary_disabled: "Deshabilitado",
    summary_disabled_feminine: "Deshabilitada",
    summary_optional: "Opcional",
    summary_proctoring: "Supervisión",
    summary_chat: "Chat",
    summary_chat_before_exam: "Chat antes del examen",
    summary_full_screen: "Pantalla completa",
    summary_multiple_monitors: "Múltiples monitores",
    summary_blocked_plural: "Bloqueados",
    summary_allowed_plural: "Permitidos",
    summary_share_screen: "Compartir pantalla",
    summary_external_camera: "Cámara externa",
    summary_not_required: "No requerido",
    summary_validations: "Validaciones",
    summary_face_microphone: "Rostro y micrófono",
    summary_on_entry: "Al ingresar",
    summary_document: "Documento",
    summary_release_button: "Botón de liberación",
    summary_minutes_before: "min antes",
    summary_periodic_validation: "Validación periódica",
    summary_without_recognition: "sin reconocimiento",
    summary_candidate_resources: "Recursos del candidato",
    summary_mobile: "Móvil",
    summary_allowed: "Permitido",
    summary_blocked: "Bloqueado",
    summary_pauses: "Pausas",
    summary_allowed_feminine_plural: "Permitidas",
    summary_blocked_feminine_plural: "Bloqueadas",
    summary_scratchpad: "Borrador",
    summary_available: "Disponible",
    summary_unavailable: "No disponible",
    summary_access: "Acceso",
    summary_time_restriction: "Restricción por horario",
    summary_active_feminine: "Activa",
    summary_no_restriction: "Sin restricción",
    summary_allowed_period: "Período permitido",
    summary_until: "hasta",
    summary_define_time: "Defina el tiempo",
    unit_minutes: "minutos",
    unit_minutes_short: "min",
    unit_seconds_short: "s",
    form_exam_time: "Tiempo del examen",
    form_candidate_total_time: "El candidato puede usar el tiempo total del examen",
    form_candidate_restricted_time: "El candidato tiene un tiempo restringido desde el acceso",
    form_exam_time_minutes: "Tiempo del examen en minutos",
    form_chat_type: "Tipo de chat",
    form_capture_candidate_image_every: "Generar una imagen del candidato cada",
    form_block_multiple_extended_screens: "¿Bloquear el uso de dos o más pantallas extendidas?",
    form_share_screen_simulation: "¿Exigir compartir pantalla para la prueba? (Simula la grabación para su uso en un examen real)",
    form_record_candidate_screen: "¿Grabar la pantalla del candidato? (Requiere compartir pantalla)",
    form_face_microphone_entry_question: "¿Usar inteligencia artificial para validar el rostro y el micrófono al ingresar?",
    form_required_external_camera: "¿Exigir cámara externa?",
    description_required_external_camera: "Cuando esté habilitado, el candidato solo podrá acceder y continuar la evaluación con la cámara externa conectada desde el celular.",
    form_record_before_exam_question: "¿Grabar al candidato antes de iniciar el examen?",
    description_record_before_exam: "Cuando está habilitado, la grabación comienza antes del horario de inicio y continúa durante validaciones, reglas y evaluación.",
    form_record_before_exam_minutes: "Tiempo antes del inicio para comenzar la grabación (en minutos, máximo 30)",
    summary_record_before_exam: "Grabación antes del inicio",
    summary_from_exam_start: "Desde el inicio del examen",
    form_face_microphone_periodic_question: "¿Validar el rostro y el micrófono cuando no se detecten durante la evaluación?",
    form_access_interval_start_date: "Fecha inicial del intervalo de acceso",
    error_exam_start_after_access_start: "La fecha y hora de inicio del examen deben ser posteriores al inicio del intervalo de acceso.",
    error_exam_end_after_access_end: "La fecha y hora de finalización del examen deben ser posteriores al fin del intervalo de acceso.",
    entity_process: "proceso",
    entity_vacancy_position: "vacante/cargo",
    option_proctoring_video_image_stream: "Guardar video e imágenes - Con transmisión en tiempo real",
    option_proctoring_image_stream: "Guardar solo imágenes - Con transmisión en tiempo real",
    option_proctoring_logs_only: "Guardar solo registros - Sin transmisión",
    option_simulation_camera_audio: "Probar el uso compartido de cámara y audio",
    option_simulation_no_camera_audio: "No compartir cámara ni audio",
    option_chat_both: "Ambos pueden enviar mensajes",
    option_chat_proctor_only: "Solo el supervisor puede enviar mensajes",
    option_chat_none: "Nadie puede enviar mensajes",
    option_seconds_30: "30 segundos",
    option_seconds_15: "15 segundos",
    label_not_calculated: "No calculada",
    title_blocks: "Bloques",
    description_manage_blocks: "Organiza evaluaciones e intervalos",
    label_block: "Bloque",
    label_without_block: "Sin bloque",
    question_document_validation_on_entry: "¿Validar el documento del candidato al ingresar?",
    description_document_validation_on_entry: "Compara el documento presentado con una foto del candidato. La validación también podrá ser realizada por el supervisor.",
    description_simulation_without_blocks: "Los procesos de tipo simulación no pueden utilizar bloques.",
    blocks_operation_error: "No fue posible completar la operación.",
    blocks_load_error: "Error al cargar los bloques.",
    blocks_save_error: "Error al guardar el bloque.",
    blocks_delete_error: "Error al eliminar el bloque.",
    blocks_delete_confirm_prefix: "Eliminar",
    blocks_delete_confirm_suffix: "Las evaluaciones quedarán sin bloque.",
    blocks_interval_description: "Intervalo entre evaluaciones.",
    blocks_none_linked: "No hay evaluaciones vinculadas a este bloque.",
    blocks_selection_title: "Evaluaciones de este bloque",
    blocks_transfer_description: "Al seleccionar una evaluación vinculada a otro bloque, se transferirá a este.",
    empty_no_items_registered: "No hay elementos registrados.",
    empty_state_default_description: "Revisa los filtros o registra un nuevo elemento para continuar.",
    empty_state_selection_description: "Agrega elementos para continuar.",
    label_currently_in: "Actualmente en:",
    blocks_module_title: "Bloques de la evaluación",
    blocks_module_description: "Organiza exámenes, redacciones, cuestionarios e intervalos en el orden de ejecución.",
    blocks_linked_evaluations: "Evaluaciones vinculadas",
    blocks_empty_description: "Agrega el primer bloque para organizar el tiempo y las evaluaciones de este proceso.",
    label_order: "Orden",
    action_add_block: "Agregar bloque",
    action_new_test: "Nueva prueba",
    blocks_remaining_prefix: "Aún faltan",
    blocks_remaining_suffix: "para completar el tiempo de la evaluación.",
    blocks_exceeded_prefix: "Los bloques exceden el tiempo de la evaluación en",
    label_exam_total: "Total de la evaluación",
    label_distributed: "Distribuido",
    label_type: "Tipo",
    block_type_assessment: "Bloque de examen",
    block_type_interval: "Bloque de intervalo",
    label_block_type: "Tipo de bloque",
    block_interval_no_evaluations: "Los bloques de intervalo no tienen exámenes, redacciones ni cuestionarios vinculados.",
    placeholder_interval_name: "Ej.: Intervalo",
    placeholder_block_name: "Ej.: Bloque 1",
    label_duration_minutes: "Duración en minutos",
    label_optional: "Opcional",
    label_exam_total_time: "Tiempo total de la evaluación",
    label_already_distributed: "Ya distribuido",
    label_exceeded_time: "Tiempo excedido",
    label_remaining_after_save: "Restará después de guardar",
    empty_no_blocks: "No hay bloques registrados.",
    action_edit_block: "Editar bloque",
    action_delete_block: "Eliminar bloque",
    block_select_label: "Bloque de la evaluación",
    block_select_option: "Selecciona el bloque",
    block_select_empty: "Primero crea un bloque de evaluación en el módulo Bloques.",
    empty_no_user_found: "Ningún usuario encontrado.",
    label_training_completed: "Completó la capacitación",
    label_proctor: "Fiscal",
    portal_candidate: "Portal del Candidato",
    portal_evaluator: "Portal del Evaluador",
    portal_proctor: "Portal del Fiscal",
    portal_grader: "Portal del Corrector",
    placeholder_search_evaluator: "Buscar evaluador por nombre",
    empty_register_first_vacancy: "Registra la primera vacante/cargo de este proceso.",
    empty_register_first_process: "Registra el primer proceso de esta institución.",
    empty_no_vacancy_found: "Ninguna vacante/cargo encontrado",
    empty_no_process_found: "Ningún proceso encontrado",
    placeholder_csv_proctors: "Archivo .csv con los datos de los fiscales",
    placeholder_search_candidate_name_cpf: "Buscar candidato por nombre o CPF",
    placeholder_search_grader: "Buscar corrector por nombre",
    option_all: "Todos",
    question_objective: "Pregunta objetiva",
    difficulty_easy: "Fácil",
    difficulty_medium: "Medio",
    difficulty_hard: "Difícil",
    education_elementary: "Educación primaria",
    education_high_school: "Educación secundaria",
    education_higher: "Educación superior",
    label_alternative_order: "Orden de las alternativas",
    label_correct: "Correcta",
    label_answered_feminine: "Respondida",
    label_response: "Respuesta",
    label_total: "Total",
    label_registered_order_alternatives: "Alternativas en orden de registro",
    label_random_order_alternatives: "Alternativas en orden aleatorio",
    placeholder_select_one_or_more_rooms: "Seleccione una o más salas",
    option_all_feminine: "Todas",
    label_alternative_count: "Cantidad de alternativas",
    question_discursive: "Pregunta discursiva",
    question_plural: "preguntas",
    question_singular: "pregunta",
    question_group_prefix: "Conjunto de preguntas",
    question_group_objective_common: "Conjuntos de preguntas objetivas con enunciado en común",
    select_education_level: "Seleccione un nivel educativo",
    select_difficulty_level: "Seleccione un nivel de dificultad",
    option_select: "Seleccione una opción",
    label_main_theme: "Tema principal",
    placeholder_main_theme_example: "Ej: Revolución Francesa",
    label_context: "Contexto",
    label_answer: "Respuesta",
    loading_question_generating_response: "Generando respuesta, por favor espere...",
    loading_question_thinking: "Estoy pensando en la mejor respuesta...",
    loading_question_processing: "Procesando su pregunta, espere un momento...",
    loading_question_calculating: "Calculando la mejor respuesta para usted...",
    error_statement_required: "El campo Enunciado es obligatorio",
    error_alternative_a_required: "El campo Alternativa a) es obligatorio",
    error_alternative_b_required: "El campo Alternativa b) es obligatorio",
    error_alternative_c_required: "El campo Alternativa c) es obligatorio",
    error_alternative_d_required: "El campo Alternativa d) es obligatorio",
    error_alternative_e_required: "El campo Alternativa e) es obligatorio",
    error_server_response: "Error al obtener respuesta del servidor",
    error_server_connection: "Error al obtener respuesta del servidor. ¿Está conectado a internet?",
    status_denied: "Rechazado",
    status_granted: "Aceptado",
    status_not_answered: "No respondido",
    status_answered: "Respondido",
    status_not_finished: "No finalizado",
    status_not_started: "No iniciado",
    status_not_corrected: "No corregida",
    status_corrected: "Corregida",
    status_absent: "Ausente",
    status_present: "Presente",
    status_valid: "Valida",
    status_annulled: "Anulada",
    status_pending: "Pendiente",
    status_rejected: "Rechazado",
    status_approved: "Aprobado",
    status_rejected_plural: "Rechazadas",
    status_approved_plural: "Aprobadas",
    action_generating_csv: "Generando CSV...",
    label_request_made: "Solicitud realizada",
    label_deadline_datetime: "Fecha y hora limite",
    label_general_statement: "Enunciado general",
    label_alternatives: "Alternativas",
    label_generated_at: "Generada en",
    label_education_level: "Escolaridad",
    label_difficulty: "Dificultad",
    label_question_type_modal: "Tipo",
    tooltip_rewind_5_seconds: "Retroceder 5 segundos",
    tooltip_forward_5_seconds: "Avanzar 5 segundos",
    action_select_videos: "Seleccionar videos",
    label_total_video_size: "Tamaño total de los videos:",
    filter_all_videos: "Todos",
    filter_webcam_videos: "Videos de webcam",
    filter_external_camera_videos: "Videos de cámara externa",
    label_cpf: "CPF",
    label_registration_number: "Inscripción",
    summary_yes: "Sí",
    summary_no: "No",
    video_ai_title: "Eventos de IA de videos",
    video_ai_report_title: "Eventos IA",
    video_ai_report_description: "Revisa eventos detectados automáticamente en los videos de candidatos.",
    video_ai_candidate_module_description: "Consulta eventos detectados por IA en los videos de este candidato.",
    video_ai_process_description: "Candidatos con eventos detectados, ordenados por mayor cantidad de eventos.",
    video_ai_candidate_description: "Eventos detectados en los videos del candidato",
    video_ai_analysis_status: "Estado del análisis",
    video_ai_generate_events: "Generar eventos",
    video_ai_download_excel: "Descargar Excel",
    video_ai_search_candidate: "Buscar candidato",
    video_ai_search_event: "Buscar evento",
    video_ai_search_candidate_placeholder: "Nombre, CPF o inscripción",
    video_ai_search_event_placeholder: "Evento, origen o sitio",
    video_ai_source: "Origen",
    video_ai_all_sources: "Todos los orígenes",
    video_ai_source_camera: "Cámara normal",
    video_ai_source_external_camera: "Cámara ambiente",
    video_ai_source_screen: "Pantalla",
    video_ai_event_type: "Tipo de evento",
    video_ai_all_event_types: "Todos los tipos",
    video_ai_sort: "Ordenación",
    video_ai_sort_date_asc: "Fecha ascendente",
    video_ai_sort_date_desc: "Fecha descendente",
    video_ai_sort_events_desc: "Más eventos",
    video_ai_sort_events_asc: "Menos eventos",
    video_ai_snapshot: "Imagen",
    video_ai_events: "Eventos IA",
    video_ai_points: "Puntos",
    video_ai_detected_site: "Sitio detectado",
    video_ai_clip: "Fragmento",
    video_ai_datetime: "Fecha/hora",
    video_ai_view_details: "Ver detalles",
    video_ai_view_candidate_events: "Ver eventos del candidato",
    video_ai_video_events: "Eventos IA del video",
    video_ai_video: "Video",
    video_ai_video_unavailable: "Video no disponible",
    video_ai_image_unavailable: "Imagen no disponible",
    video_ai_first_event_datetime: "Fecha/hora del primer evento",
    video_ai_analyzed_clip: "Fragmento analizado",
    video_ai_analysis_source: "Origen del análisis",
    video_ai_video_available: "Video disponible",
    video_ai_total_events: "Total de eventos",
    video_ai_detected_events: "Eventos detectados",
    video_ai_snapshot_second: "Segundo de la imagen",
    video_ai_event_id: "ID del evento",
    video_ai_no_events_found: "No se encontraron eventos",
    video_ai_adjust_search: "Intenta ajustar la búsqueda.",
    video_ai_generate_to_view: "Genera los eventos para ver los análisis de videos.",
    video_ai_job_success: "Concluida",
    video_ai_job_not_generated: "No generada",
    action_generate_report: "Generar informe",
    action_select_all: "Seleccionar todo",
    action_clear_selection: "Limpiar selección",
    label_value: "Valor",
    trust_options_title: "Ítems considerados en la confiabilidad",
    trust_options_description: "Desmarca los ítems que no deben entrar en el cálculo antes de generar el informe.",
    trust_metrics_title: "Métricas de fiscalización",
    trust_ai_events_title: "Eventos de IA detallados",
    trust_report_not_generated: "El informe de confiabilidad aún no fue generado",
    trust_points_by_metric: "Puntos por métrica",
    trust_video_ai_points: "Puntos IA de video",
    trust_ai_points_details: "Puntos IA detallados",
    trust_events_count: "evento(s)",
    trust_metric_reported_actions: "Acciones reportadas",
    trust_metric_face_recognition_average: "Promedio del reconocimiento facial",
    trust_metric_periodic_face_validations: "Validaciones faciales periódicas",
    trust_metric_photos_without_face: "Fotos sin rostro detectado",
    trust_metric_fiscal_release_requests: "Solicitudes de liberación al fiscal",
    trust_metric_screen_exits: "Salidas de pantalla",
    trust_metric_screen_exit_time: "Tiempo fuera de la pantalla de evaluación",
    trust_metric_videos_without_face: "Videos sin rostro",
    trust_metric_multiple_faces_videos: "Múltiples rostros en videos",
    trust_metric_identical_ips: "IPs idénticas",
    video_ai_event_ai_assistant: "Asistente de IA",
    video_ai_event_book: "Libro",
    video_ai_event_calculator: "Calculadora",
    video_ai_event_cell_phone: "Celular",
    video_ai_event_earbuds: "Auriculares intraurales",
    video_ai_event_email: "Correo",
    video_ai_event_external_website: "Sitio externo",
    video_ai_event_headphones: "Auriculares",
    video_ai_event_laptop: "Notebook",
    video_ai_event_long_hair: "Cabello largo",
    video_ai_event_browser_new_tab: "Nueva pestaña del navegador",
    video_ai_event_looking_away: "Mirada desviada",
    video_ai_event_messaging: "Mensajes",
    video_ai_event_multiple_faces: "Múltiples rostros",
    video_ai_event_multiple_people: "Múltiples personas",
    video_ai_event_multiple_speakers: "Múltiples voces",
    video_ai_event_no_face: "Sin personas",
    video_ai_event_no_person: "Sin personas",
    video_ai_event_paper: "Papel",
    video_ai_event_person: "Persona",
    video_ai_event_reference: "Referencia",
    video_ai_event_search_engine: "Buscador",
    video_ai_event_second_speaker: "Segunda voz",
    video_ai_event_speech: "Habla detectada",
    video_ai_event_start_menu: "Menú de inicio",
    video_ai_event_smartwatch: "Reloj inteligente",
    video_ai_event_tv_monitor: "TV/Monitor",
    video_ai_event_unknown: "Evento no clasificado",
    video_ai_severity_info: "Informativo",
    video_ai_severity_low: "Bajo",
    video_ai_severity_medium: "Medio",
    video_ai_severity_high: "Alto",
    video_ai_severity_critical: "Crítico",
    label_docx_file: "Archivo .docx",
    label_selected_file: "Archivo seleccionado:",
    action_choose_files: "Elegir archivos",
    label_no_file_selected: "Ningún archivo seleccionado",
    label_files_selected: "archivos seleccionados",
    action_clear: "Limpiar",
    action_clear_file: "Limpiar archivo",
    action_clear_all_files: "Limpiar todos los archivos",
    label_upload_pdf: "Carga del PDF",
    label_pdf_viewer: "Visor de PDF",
    error_server_response: "Error al obtener la respuesta del servidor. ¿Tienes conexión a internet?",
    error_select_video_or_pdf: "Para guardar, selecciona un video o archivo PDF",
    upload_success: "Carga realizada con éxito",
    error_fetch_server_response_short: "Error al obtener la respuesta del servidor",
    error_fetch_contents: "Error al buscar contenidos",
    error_delete_content: "Error al eliminar contenido",
    error_edit_question: "Error al editar la pregunta",
    alert_delete_content_unavailable: "Al eliminar este contenido, ya no estará disponible en el sistema",
    label_type_colon: "Tipo: ",
    label_created_at_colon: "Creado el: ",
    action_delete_question: "Eliminar pregunta",
    action_saving: "Guardando",
    action_saving_resource: "Guardando recurso",
    description_create_institutions: "Registra las instituciones de tu sistema",
    description_create_processes: "Registra los procesos de tu sistema",
    description_manage_institutions: "Gestiona instituciones, páginas y responsables registrados en la plataforma.",
    description_manage_processes: "Gestiona procesos, páginas y responsables registrados en la plataforma.",
    description_edit_institution: "Edita una institución de tu sistema",
    description_edit_process: "Edita un proceso de tu sistema",
    label_logo: "Logo",
    label_of_your_system: "de tu sistema",
    label_of_vacancy_position: "de la vacante/cargo",
    placeholder_url_path: "Ruta de la URL",
    placeholder_search_by_name: "Buscar por nombre",
    title_process: "Procesos",
    title_institution: "Instituciones",
    title_demand: "Demandas",
    title_demands: "Lista de demandas",
    title_subjects: "Disciplinas",
    title_questions: "Preguntas",
    title_question_list: "Lista de preguntas",
    title_modules: "Módulos",
    title_system_modules: "Módulos del sistema",
    title_team_members: "Lista de miembros del equipo",
    title_authors: "Lista de elaboradores",
    title_assignments: "Asignaciones",
    title_question_assignments: "Asignaciones de preguntas",
    title_essay_assignments: "Asignaciones de redacciones",
    title_create_layout: "Crear diagramación",
    title_edit_layout: "Editar diagramación",
    title_create_question: "Crear pregunta",
    title_edit_question: "Editar pregunta",
    title_quick_reports: "Informes rápidos",
    report_exam_results_by_institution: "Resultados de las pruebas",
    report_all_candidates_general: "Informe general de candidatos",
    report_candidates_world_map: "Mapa de candidatos",
    title_candidates_geolocation_map: "Mapa de geolocalización de candidatos",
    desc_candidates_geolocation_map: "Puntos y regiones de calor basados en la primera IP registrada en la pantalla de evaluación en curso.",
    title_quick_summary: "Resumen rápido",
    title_latest_updates: "Últimas actualizaciones",
    title_realtime_indicators: "Indicadores en tiempo real",
    title_choose_module_manage: "Elige un módulo para gestionar",
    title_create_demand: "Crear demanda",
    title_edit_demand: "Editar demanda",
    title_reliability: "Confiabilidad",
    title_general_logs: "Registros generales",
    title_exam_and_template: "Prueba y plantilla",
    title_print_settings: "Configuración de impresión",
    role_administrator: "Administrador",
    role_user: "Usuario",
    authors: "Elaboradores",
    disciplines: "Disciplinas",
    action_back: "Volver",
    action_next: "Siguiente",
    action_add: "Agregar",
    action_new_institution: "Nueva institución",
    action_new_process: "Nuevo proceso",
    action_view_institution: "Ver institución",
    action_view_process: "Ver proceso",
    action_add_question: "Agregar pregunta",
    action_add_questions_docx: "Agregar preguntas vía .docx",
    docx_add_exam_questions_title: "Agregar preguntas vía DOCX",
    docx_select_file: "Seleccionar archivo DOCX",
    docx_file_by_disciplines_description: "Archivo DOCX separado por disciplinas",
    docx_error_process_file: "Error al procesar el archivo.",
    docx_error_import_questions: "Error al importar preguntas.",
    docx_status_creating_bank: "Creando tu banco de preguntas...",
    docx_error_poll_job: "Error al consultar el procesamiento. ¿Estás conectado a internet?",
    docx_error_select_file: "Selecciona un archivo DOCX para continuar.",
    docx_status_uploading_file: "Cargando archivo...",
    docx_error_upload_file: "Error al enviar el archivo. ¿Estás conectado a internet?",
    docx_instructions_intro: "Usa el modelo correspondiente al tipo de prueba. El nombre de cada disciplina debe estar en una línea propia, en mayúsculas, con las preguntas debajo.",
    docx_objective_questions_title: "Preguntas objetivas",
    docx_objective_question_number_instruction: "Usa \"Pregunta N)\" al inicio de cada pregunta.",
    docx_objective_alternatives_instruction: "Usa alternativas a), b), c), d) y e) en secuencia.",
    docx_correct_alternative_instruction: "Marca la alternativa correcta con resaltado o color de fondo diferente de blanco.",
    docx_group_questions_title: "Preguntas en conjunto",
    docx_group_header_instruction: "Informa el texto base con el intervalo: \"Texto base para las preguntas X a Y:\".",
    docx_group_children_instruction: "Las subpreguntas del conjunto deben ser objetivas.",
    docx_group_added_instruction: "El conjunto se agregará como una única pregunta en la tabla de la prueba.",
    docx_discursive_questions_title: "Preguntas discursivas",
    docx_discursive_question_number_instruction: "Usa \"Pregunta N)\" al inicio de cada pregunta.",
    docx_discursive_no_alternatives_instruction: "No incluyas alternativas; el tipo se identifica por la ausencia de a), b), c), etc.",
    docx_metadata_optional_instruction: "Palabras clave, Dificultad y Escolaridad son opcionales.",
    docx_download_objective_model: "Descargar modelo - objetivas",
    docx_download_objective_group_model: "Descargar modelo - objetivas y conjunto",
    docx_download_discursive_model: "Descargar modelo - discursivas",
    docx_error_only_objective_for_discursive_exam: "Este archivo contiene solo preguntas objetivas. Cambia el tipo de prueba o envía un archivo con preguntas discursivas.",
    docx_error_only_discursive_for_objective_exam: "Este archivo contiene solo preguntas discursivas. Cambia el tipo de prueba o envía un archivo con preguntas objetivas.",
    docx_warning_objective_ignored_discursive_exam: "Las preguntas objetivas fueron ignoradas porque la prueba está configurada como discursiva.",
    docx_warning_discursive_ignored_objective_exam: "Las preguntas discursivas fueron ignoradas porque la prueba está configurada como objetiva.",
    action_add_edit_assignments: "Agregar/Editar asignaciones",
    action_add_edit_essay_assignments: "Agregar/Editar asignaciones de redacciones",
    action_save: "Guardar",
    action_save_demand: "Guardar demanda",
    action_save_member: "Guardar miembro",
    action_save_author: "Guardar elaborador",
    action_save_assignments: "Guardar asignaciones",
    action_close: "Cerrar",
    action_delete: "Eliminar",
    action_download_report: "Descargar informe",
    action_download_csv: "Descargar CSV",
    action_generating_map: "Generando mapa...",
    action_view_map: "Ver mapa",
    action_access: "Acceder",
    action_view_terms: "Ver términos de la institución",
    action_include_keyword: "Agregar palabra clave",
    label_name: "Nombre",
    label_email: "Correo",
    label_candidates: "candidatos",
    label_actions: "Acciones",
    label_status: "Estado",
    label_auditor_status: "Estado del auditor",
    label_registered_by: "Registrado por",
    label_created_at: "Creado el",
    label_created_at_feminine: "Creado el",
    label_pages_published: "Páginas publicadas",
    label_sort_by: "Ordenar por",
    label_showing: "Mostrando",
    label_to: "a",
    label_of: "de",
    sort_recent: "Más recientes",
    sort_oldest: "Más antiguas",
    sort_name: "Nombre",
    unit_page_singular: "página",
    unit_page_plural: "páginas",
    empty_no_institutions_registered: "Ninguna institución registrada",
    empty_no_processes_registered: "Ningún proceso registrado",
    empty_register_first_institution: "Registra la primera institución para empezar.",
    label_updated_at: "Actualizado el",
    label_description: "Descripción",
    label_descriptive: "Descripción",
    label_demand_description: "Descripción de la demanda",
    label_keywords: "Palabras clave",
    label_subject: "Disciplina",
    label_statement: "Enunciado",
    label_correct_alternative: "Alternativa correcta",
    label_question_type: "Tipo de pregunta",
    label_objective_question_count: "Cantidad de preguntas objetivas",
    label_essay_question_count: "Cantidad de preguntas discursivas",
    label_selected_authors: "Elaboradores seleccionados",
    label_user_type: "Tipo de usuario",
    label_password_confirmation: "Confirmación de contraseña",
    label_end_time: "Horario de cierre",
    label_start: "Inicio",
    label_end: "Cierre",
    label_rules: "Reglas",
    label_terms: "Términos",
    label_proctoring_type: "Tipo de fiscalización",
    label_save_videos_streaming: "Guardar videos e imágenes con streaming en tiempo real",
    label_module: "Módulo",
    label_module_status: "Estado",
    label_present_count: "N.º de presentes",
    role_collaborator: "Colaborador",
    role_viewer: "Visualizador",
    answer_yes: "Sí",
    answer_no: "No",
    value_not_specified: "No especificado",
    status_active: "Activo",
    status_inactive: "Inactivo",
    status_maintenance: "En mantenimiento",
    status_finished: "Finalizado",
    desc_demands: "Aquí se listan todas las demandas de tu sistema",
    desc_subject_questions: "Aquí se listan todas las preguntas de la disciplina",
    desc_system_modules: "Aquí se listan todos los módulos del sistema y sus estados",
    desc_team_members: "Aquí se listan todos los miembros de tu equipo en el sistema",
    desc_team_member_create: "Registra los miembros de tu equipo en el sistema",
    desc_authors: "Aquí se listan todos los elaboradores de tu sistema",
    desc_question_resources: "Aquí se listan todos los recursos de preguntas de tu sistema",
    desc_process_dashboard_data: "Datos generales consolidados del dashboard de este proceso.",
    desc_institution_dashboard_data: "Datos generales consolidados del dashboard de esta institución.",
    desc_quick_reports_process: "Accede a los informes de seguimiento de este proceso.",
    desc_question_assignment: "Agrega/Edita asignaciones de preguntas a la demanda",
    desc_essay_assignment: "Agrega/Edita asignaciones de redacciones a la demanda",
    desc_select_authors_subject: "Selecciona uno o más elaboradores que deberán registrar preguntas de esta disciplina y escribe una descripción",
    desc_selected_essay_authors: "Selecciona un elaborador que deberá crear una o más redacciones en esta demanda",
    desc_status_active: "Activo: módulo operando normalmente",
    desc_status_maintenance: "En mantenimiento: el módulo está siendo actualizado y puede presentar inestabilidad",
    desc_status_inactive: "Inactivo: el módulo está apagado",
    empty_no_answers_found: "Ninguna respuesta encontrada",
    empty_no_records_found: "Ningún registro encontrado",
    empty_no_geolocation_found: "No se encontró geolocalización para los candidatos presentes.",
    empty_no_questions_found: "Ninguna pregunta encontrada",
    empty_no_questions_found_dot: "Ninguna pregunta encontrada.",
    empty_no_subject_found_term: "Ninguna disciplina encontrada con este término",
    empty_no_subject_added: "Ninguna disciplina agregada",
    empty_no_assignments_found: "Ninguna asignación encontrada",
    empty_no_demand_found: "Ninguna demanda encontrada",
    empty_no_author_selected: "Ningún elaborador seleccionado",
    empty_no_author_found: "Ningún elaborador encontrado",
    empty_no_member_found: "Ningún miembro encontrado",
    empty_no_candidate_found: "Ningún candidato encontrado",
    empty_no_proctor_found: "Ningún fiscal encontrado",
    empty_no_grader_found: "Ningún corrector encontrado",
    empty_no_evaluator_found: "Ningún evaluador encontrado",
    empty_no_room_found: "Ninguna sala encontrada",
    empty_no_layout_found: "Ninguna diagramación encontrada",
    empty_no_test_found: "Ninguna prueba encontrada",
    placeholder_search_demand: "Buscar por nombre de la demanda",
    placeholder_search_subject: "Buscar por nombre de la categoría",
    placeholder_search_subject_add: "Busca una disciplina para agregar a esta demanda",
    placeholder_search_question: "Buscar por enunciado de la pregunta",
    placeholder_search_room: "Buscar por número de sala",
    placeholder_search_author_subject: "Buscar por nombre del elaborador o de la disciplina",
    placeholder_password: "Ingresa tu contraseña",
    validation_required_field: "El campo {field} es obligatorio",
    feedback_essay_correction_started: "Corrección iniciada correctamente!",
    feedback_essay_correction_error: "Error al corregir la redacción. Inténtalo nuevamente más tarde.",
    loading_essay_analyzing: "Analizando tu redacción...",
    loading_essay_identifying_points: "Identificando puntos principales...",
    loading_essay_evaluating_argument: "Evaluando la argumentación...",
    loading_essay_checking_coherence: "Verificando coherencia textual...",
    loading_essay_applying_criteria: "Aplicando criterios de corrección...",
    loading_essay_generating_feedback: "Generando feedback personalizado...",
    loading_almost_done: "Casi listo...",
    back: "Volver",
    chooseOption: "Elige una opción para ver",
    enter: "Entrar",
    entering: "Entrando...",
    email: "Correo",
    english: "Inglés",
    language: "Idioma",
    light: "Claro",
    dark: "Oscuro",
    loginHeroTitle: "Gestión de evaluaciones con claridad y seguridad.",
    loginHeroSubtitle: "Organiza procesos, candidatos, fiscales y resultados en un panel moderno y directo.",
    myProfile: "Mi perfil",
    password: "Contraseña",
    passwordPlaceholder: "Ingresa tu contraseña",
    portuguese: "Portugués",
    signInSubtitle: "Accede a tu cuenta para continuar.",
    adminEnvironment: "Ambiente administrativo",
    spanish: "Español",
    system: "Sistema",
    theme: "Tema",
    viewing: "Visualizando",
    welcome: "Bienvenido",
    logout: "Salir",
    adminOrganizer: "Admin organizadora",
    analyses: "Análisis",
    analysisObjects: "Objetos de análisis",
    assignments: "Asignaciones",
    assessmentBank: "Banco de preguntas",
    candidateConflicts: "Conflictos de candidatos",
    candidates: "Candidatos",
    chooseProcessReports: "Elige un proceso para ver los informes",
    content: "Contenido",
    contents: "Contenidos",
    dashboard: "Dashboard",
    demands: "Demandas",
    diagramLayouts: "Diagramaciones",
    details: "Detalles",
    edit: "Editar",
    essays: "Redacciones",
    evaluators: "Evaluadores",
    evaluateQuestions: "Evaluar preguntas",
    graders: "Correctores",
    importExisting: "Importar existente",
    interviews: "Entrevistas",
    link: "Vincular",
    linkedQuestionnaires: "Cuestionarios vinculados",
    members: "Miembros",
    module: "Módulo",
    modules: "Módulos",
    organization: "Institución",
    organizations: "Instituciones",
    openProcessReports: "Abrir informes de este proceso.",
    organizers: "Organizadoras",
    process: "Proceso",
    processes: "Procesos",
    proctors: "Fiscales",
    publicQuestions: "Preguntas públicas",
    question: "Pregunta",
    questionBank: "Banco de preguntas",
    questionResources: "Recursos de pregunta",
    questions: "Preguntas",
    questionnaires: "Cuestionarios",
    register: "Registro",
    registerAction: "Registrar",
    resources: "Recursos",
    rooms: "Salas",
    systemModules: "Módulos del sistema",
    teamMembers: "Miembros del equipo",
    tests: "Pruebas",
    training: "Capacitación",
    trainingManagement: "Gestión de capacitaciones",
    trainings: "Capacitaciones",
    vacancies: "Vacantes/Cargos",
    vacancy: "Vacante/Cargo",
    bulk_process_add_button: "Agregar procesos por lote",
    bulk_process_title: "Agregar procesos por lote",
    bulk_process_names_label: "Nombres de los procesos",
    bulk_vacancy_add_button: "Agregar vacantes por lote",
    bulk_vacancy_title: "Agregar vacantes por lote",
    bulk_vacancy_names_section: "Nombres",
    bulk_vacancy_config_section: "Configuraciones",
    bulk_vacancy_jobs_section: "Ejecuciones",
    bulk_vacancy_names_count: "nombres listos para crear",
    bulk_vacancy_names_label: "Nombres de las vacantes",
    bulk_vacancy_names_description: "Ingresa los nombres separados por coma. Al agregar una coma, cada nombre se convierte en una badge; haz clic en la badge para editarla o en x para eliminarla. Si importas una planilla CSV, se usará la primera columna de cada línea.",
    bulk_vacancy_names_placeholder: "Escribe un nombre y usa coma para agregar",
    bulk_vacancy_name_edit_hint: "Haz clic para editar este nombre",
    bulk_vacancy_name_remove: "Eliminar nombre",
    bulk_vacancy_file_label: "Importar nombres por planilla",
    bulk_vacancy_file_description: "Usa un archivo .csv o .txt con los nombres en la primera columna.",
    bulk_vacancy_file_read_error: "No fue posible leer el archivo enviado.",
    bulk_vacancy_names_required: "Ingresa al menos un nombre de vacante.",
    bulk_vacancy_config_required: "Completa descripción y reglas antes de guardar.",
    bulk_vacancy_save_button: "Crear :entity por lote",
    bulk_vacancy_basic_data: "Datos básicos",
    bulk_vacancy_dates: "Fechas",
    bulk_vacancy_start_time: "Horario de inicio",
    bulk_vacancy_restrict_access: "Restringir periodo de acceso",
    bulk_vacancy_access_start: "Inicio del acceso",
    bulk_vacancy_access_end: "Fin del acceso",
    bulk_vacancy_exam_settings: "Configuraciones de la evaluación",
    bulk_vacancy_mobile: "Proceso móvil",
    bulk_vacancy_exam_per_time: "Una pregunta por tiempo",
    bulk_vacancy_need_pause: "Permitir pausa",
    bulk_vacancy_has_blocks: "Usar bloques",
    bulk_vacancy_time_type: "Tiempo de la evaluación",
    bulk_vacancy_time_all: "Usar todo el periodo configurado",
    bulk_vacancy_time_restrict: "Restringir tiempo en minutos",
    bulk_vacancy_exam_time_minutes: "Tiempo en minutos",
    bulk_vacancy_proctoring: "Fiscalización",
    bulk_vacancy_proctoring_type: "Tipo de fiscalización",
    bulk_vacancy_proctoring_all: "Guardar video e imagen con streaming",
    bulk_vacancy_proctoring_image: "Guardar solo imagen con streaming",
    bulk_vacancy_proctoring_none: "Guardar solo logs, sin streaming",
    bulk_vacancy_chat_type: "Permiso de chat",
    bulk_vacancy_chat_all: "Candidato y fiscal pueden enviar mensajes",
    bulk_vacancy_chat_fiscal_to_student: "Solo el fiscal envía mensajes",
    bulk_vacancy_chat_none: "Chat desactivado",
    bulk_vacancy_screen_sharing: "Exigir compartir pantalla",
    bulk_vacancy_screen_extended_restrict: "Bloquear pantalla extendida",
    bulk_vacancy_recording_before: "Empezar grabación antes del inicio en minutos",
    bulk_vacancy_draft: "Permitir borrador",
    bulk_vacancy_validations: "Validaciones",
    bulk_vacancy_face_validation: "Validación facial al ingresar",
    bulk_vacancy_document_validation: "Validación de documento",
    bulk_vacancy_chat_time: "Intervalo del chat en minutos",
    bulk_vacancy_request_time: "Intervalo de solicitudes en minutos",
    bulk_vacancy_periodic_validation_time: "Intervalo de validación periódica en minutos",
    action_refresh: "Actualizar",
    legacy_acoes_rapidas: "Acciones rápidas",
    legacy_adicionar_avaliadores: "Agregar evaluadores",
    legacy_adicionar_corretor: "Agregar corrector",
    legacy_adicionar_fiscais: "Agregar fiscales",
    legacy_adicionar_disciplina: "Agregar disciplina",
    legacy_adicionar_elemento: "Agregar elemento",
    legacy_adicionar_elaborador: "Agregar elaborador",
    legacy_adicionar_membro: "Agregar miembro",
    legacy_adicionar_novo_modulo: "Agregar nuevo módulo",
    legacy_adicionar_novo_conteudo: "Agregar nuevo contenido",
    legacy_adicionar_nova_questao: "Agregar nueva pregunta",
    legacy_adicionar_questionario: "Agregar cuestionario",
    legacy_adicionar_pergunta: "Agregar pregunta",
    legacy_adicionar_cursos: "Agregar cursos",
    legacy_adicionar_usuarios: "Agregar usuarios",
    legacy_adicionar_professores: "Agregar profesores",
    legacy_adicionar_candidato: "Agregar candidato",
    legacy_adicionar_fiscal: "Agregar fiscal",
    legacy_adicionar_avaliador: "Agregar evaluador",
    legacy_adicionar_treinamento: "Agregar capacitación",
    legacy_adicionar_organizadora: "Agregar organizadora",
    legacy_adicionar_novo_treinamento: "Agregar nueva capacitación",
    legacy_adicionar_entrevista: "Agregar entrevista",
    legacy_adicionar_topico: "Agregar tema",
    legacy_adicionar_criterio: "Agregar criterio",
    legacy_adicionar_alternativa_de_escolha_multipla: "Agregar alternativa de opción múltiple",
    legacy_adicionar_campo_de_texto: "Agregar campo de texto",
    legacy_adicionar_prefiro_nao_informar: "Agregar \"Prefiero no informar\"",
    legacy_adicionar_perguntas: "Agregar preguntas",
    legacy_adicionar_formula: "Agregar fórmula",
    legacy_adicionar_nova_demanda: "Agregar nueva demanda",
    legacy_adicionar_novo_recurso: "Agregar nuevo recurso",
    legacy_adicionar_comentario: "Agregar comentario",
    legacy_adicionar_zip_rar_de_redacoes_externas: "Agregar .zip/.rar de redacciones externas",
    legacy_adicionar_zip_rar_de_redacoes_existentes: "Agregar .zip/.rar de redacciones existentes",
    legacy_adicionar_editar_atribuicoes: "Agregar/Editar asignaciones",
    legacy_analise_de_objetos: "Análisis de objetos",
    legacy_analise_facial: "Análisis facial",
    legacy_analise_movimentacoes_capturadas_pela_camera: "Analiza movimientos capturados por la cámara.",
    legacy_movimento_facial: "Movimiento facial",
    legacy_acompanhe_indicadores_de_confianca_dos_candidatos: "Sigue indicadores de confianza de los candidatos.",
    legacy_acompanhe_acessos_e_eventos_registrados_durante_a_avaliacao: "Sigue accesos y eventos registrados durante la evaluación.",
    legacy_acesse_as_versoes_nominais_dos_candidatos: "Accede a las versiones nominales de los candidatos.",
    legacy_acesse_as_imagens_capturadas: "Accede a las imágenes capturadas.",
    legacy_aqui_sao_listados_todas_as_questoes_pendentes_do_seu_sistema: "Aquí se listan todas las preguntas pendientes de tu sistema",
    legacy_aqui_sao_listados_todas_as_organizadoras_do_seu_sistema: "Aquí se listan todas las organizadoras de tu sistema",
    legacy_aqui_sao_listados_todos_os_treinamentos_do_seu_sistema: "Aquí se listan todas las capacitaciones de tu sistema",
    legacy_aqui_sao_listados_todos_os_conteudos_vinculados_com_o_modulo: "Aquí se listan todos los contenidos vinculados al módulo",
    legacy_aqui_sao_listados_todos_os_modulos_vinculados_com_o_treinamento: "Aquí se listan todos los módulos vinculados a la capacitación",
    legacy_aqui_sao_listados_todas_as_suas_disciplinas: "Aquí se listan todas tus disciplinas",
    legacy_aqui_sao_listados_todos_os_seus_questionarios: "Aquí se listan todos tus cuestionarios",
    legacy_aqui_sao_listados_todas_as_questoes_do_conteudo: "Aquí se listan todas las preguntas del contenido",
    legacy_aqui_sao_listados_todos_os_conteudos_do_seu_sistema: "Aquí se listan todos los contenidos de tu sistema",
    legacy_ao_deletar_este_modulo_ele_nao_estara_mais_disponivel_no_sistema: "Al eliminar este módulo, ya no estará disponible en el sistema",
    legacy_atencao: "Atención",
    legacy_aqui_sao_listados_todos_os_modulos_do_seu_sistema: "Aquí se listan todos los módulos de tu sistema",
    legacy_api_integrada_e_ativa: "API integrada y activa",
    legacy_avaliacoes: "Evaluaciones",
    legacy_avaliar_questao: "Evaluar pregunta",
    legacy_baixar_respostas: "Descargar respuestas",
    legacy_baixar_pdf_com_analises: "Descargar PDF con análisis",
    legacy_baixar_analises_em_pdf: "Descargar análisis en PDF",
    legacy_baixar_planilha_excel: "Descargar hoja Excel",
    legacy_baixar_todas_redacoes: "Descargar todas las redacciones",
    legacy_baixar_correcoes: "Descargar correcciones",
    legacy_baixar_exemplo_de_arquivo: "Descargar archivo de ejemplo",
    legacy_baixar_pdf: "Descargar PDF",
    legacy_borda_visivel: "¿Mostrar borde?",
    legacy_candidatos_online: "Candidatos en línea",
    legacy_candidatos_vinculados: "Candidatos vinculados",
    legacy_cadastre_os_modulos_do_seu_sistema: "Registra los módulos de tu sistema",
    legacy_cancelar: "Cancelar",
    legacy_cadastrar_avaliador: "Crear evaluador",
    legacy_cadastrar_corretor: "Crear corrector",
    legacy_cadastrar_disciplina: "Crear disciplina",
    legacy_cadastrar_elaborador: "Crear elaborador",
    legacy_cadastrar_fiscal: "Crear fiscal",
    legacy_cadastrar_membro: "Crear miembro",
    legacy_cadastrar_redacao: "Crear redacción",
    legacy_cadastrar_recurso_de_questao: "Crear recurso de pregunta",
    legacy_cadastrar_disciplina_2: "Crear disciplina",
    legacy_configuracoes: "Configuraciones",
    legacy_configuracoes_da_instituicao: "Configuraciones de la institución",
    legacy_configuracoes_do_processo: "Configuraciones del proceso",
    legacy_consulte_objetos_detectados_durante_a_avaliacao: "Consulta objetos detectados durante la evaluación.",
    legacy_confira_registros_de_troca_de_janela_ou_saida_da_tela: "Consulta registros de cambio de ventana o salida de pantalla.",
    legacy_data_de_criacao: "Fecha de creación",
    legacy_data_de_nascimento: "Fecha de nacimiento",
    legacy_data_de_inicio: "Fecha de inicio",
    legacy_data_de_encerramento: "Fecha de cierre",
    legacy_data_de_encerammento: "Fecha de cierre",
    legacy_data_limite: "Fecha límite",
    legacy_data_da_resposta: "Fecha de respuesta",
    legacy_data: "Fecha",
    legacy_download_relatorio: "Descargar informe",
    legacy_deletar_demanda: "Eliminar demanda",
    legacy_descricao: "Descripción:",
    legacy_descricao_do_modulo: "Descripción del módulo",
    legacy_descricao_do_treinamento: "Descripción de la capacitación",
    legacy_descricao_dos_fatos: "Descripción de los hechos",
    legacy_editar_pagina: "Editar página",
    legacy_editar_perfil: "Editar perfil",
    legacy_editar_avaliador: "Editar evaluador",
    legacy_editar_corretor: "Editar corrector",
    legacy_editar_fiscal: "Editar fiscal",
    legacy_editar_membro: "Editar miembro",
    legacy_editar_modulo_conteudos: "Editar módulo/contenidos",
    legacy_editar_questionario: "Editar cuestionario",
    legacy_editar_redacao: "Editar redacción",
    legacy_editar_recurso_de_questao: "Editar recurso de pregunta",
    legacy_editar_disciplina: "Editar disciplina",
    legacy_editar_conteudo: "Editar contenido",
    legacy_editar_questao: "Editar pregunta",
    legacy_editar_questionario_2: "Editar cuestionario",
    legacy_editar_candidato: "Editar candidato",
    legacy_editar_corretor_2: "Editar corrector",
    legacy_editar_avaliador_2: "Editar evaluador",
    legacy_editar_fiscal_2: "Editar fiscal",
    legacy_editar_membro_2: "Editar miembro",
    legacy_editar_elaborador: "Editar elaborador",
    legacy_editar_recurso: "Editar recurso",
    legacy_editar_atribuicao: "Editar asignación",
    legacy_editar_treinamento: "Editar capacitación",
    legacy_editar_organizadora: "Editar organizadora",
    legacy_editar_horario: "Editar horario",
    legacy_editar_elemento_da_folha_de_rosto: "Editar elemento de la portada",
    legacy_elemento_selecionado_de_duplo_clique_nele_para_abrir_o_editor: "Elemento seleccionado. Haz doble clic para abrir el editor.",
    legacy_editar_demanda: "Editar demanda",
    legacy_editar_elaborador_2: "Editar elaborador",
    legacy_edite_um_elaborador_do_seu_sistema: "Edita un elaborador de tu sistema",
    legacy_escolha_a_alternativa_correta: "Elige la alternativa correcta",
    legacy_esconder_paginacao: "¿Ocultar paginación?",
    legacy_enviar_e_mail_para_o_elaborador_com_senha_aleatoria: "¿Enviar correo al elaborador con contraseña aleatoria?",
    legacy_enviar_e_mail_para_o_cliente_com_senha_aleatoria: "¿Enviar correo al cliente con contraseña aleatoria?",
    legacy_elaborador_pode_criar_redacao: "¿El elaborador puede crear redacciones?",
    legacy_elaborador_pode_ser_auditor: "¿El elaborador puede ser auditor?",
    legacy_excluir_candidato: "Eliminar candidato",
    legacy_excluir_corretor: "Eliminar corrector",
    legacy_excluir_avaliador: "Eliminar evaluador",
    legacy_excluir_fiscal: "Eliminar fiscal",
    legacy_fiscais_online: "Fiscales en línea",
    legacy_folha_de_rosto: "Portada",
    legacy_gerencie: "Gestiona",
    legacy_gerencie_as_diagramacoes: "Gestiona las diagramaciones",
    legacy_gerencie_as_diagramacoes_vinculadas_ao_processo: "Gestiona las diagramaciones vinculadas al proceso",
    legacy_gerencie_as_redacoes: "Gestiona las redacciones",
    legacy_gerencie_candidatos: "Gestiona candidatos",
    legacy_gerencie_corretores: "Gestiona correctores",
    legacy_gerencie_diagramacoes: "Gestiona diagramaciones",
    legacy_gerencie_fiscais: "Gestiona fiscales",
    legacy_gerencie_provas_e_itens: "Gestiona pruebas e ítems",
    legacy_gerencie_questionarios: "Gestiona cuestionarios",
    legacy_gerencie_salas: "Gestiona salas",
    legacy_gerencie_as_salas_vinculadas_ao_processo: "Gestiona las salas vinculadas al proceso",
    legacy_gerencie_os_fiscais_vinculados_ao_processo: "Gestiona los fiscales vinculados al proceso",
    legacy_gerencie_os_corretores_vinculados_ao_processo: "Gestiona los correctores vinculados al proceso",
    legacy_gerencie_os_candidatos_vinculados_ao_processo: "Gestiona los candidatos vinculados al proceso",
    legacy_gerencie_os_candidatos_da_instituicao: "Gestiona los candidatos de la institución.",
    legacy_gerencie_os_candidatos_do_processo: "Gestiona los candidatos del proceso.",
    legacy_gerencie_os_fiscais_da_instituicao: "Gestiona los fiscales de la institución.",
    legacy_gerencie_os_fiscais_do_processo: "Gestiona los fiscales del proceso.",
    legacy_gerencie_os_avaliadores_da_instituicao: "Gestiona los evaluadores de la institución.",
    legacy_gerencie_os_avaliadores_do_processo: "Gestiona los evaluadores del proceso.",
    legacy_gerencie_os_corretores_da_instituicao: "Gestiona los correctores de la institución.",
    legacy_gerencie_os_corretores_do_processo: "Gestiona los correctores del proceso.",
    legacy_gerencie_os_treinamentos_vinculados_desta_instituicao: "Gestiona las capacitaciones vinculadas a esta institución.",
    legacy_gerencie_os_treinamentos_vinculados_deste_processo: "Gestiona las capacitaciones vinculadas a este proceso.",
    legacy_gerencie_treinamentos: "Gestiona capacitaciones",
    legacy_gerencie_as_entrevistas_vinculadas_ao_processo: "Gestiona las entrevistas vinculadas al proceso.",
    legacy_gerencie_as_avaliacoes_orais_dos_candidatos: "Gestiona las evaluaciones orales de los candidatos.",
    legacy_gerencie_os_membros_desta_organizadora: "Gestiona los miembros de esta organizadora.",
    legacy_gerencie_os_processos_seletivos: "Gestiona los procesos selectivos",
    legacy_gerencie_as_vagas_do_processo_seletivo: "Gestiona las vacantes del proceso selectivo",
    legacy_gerencie_as_vagas_vinculadas_ao_seletivo: "Gestiona las vacantes vinculadas al proceso selectivo.",
    legacy_gerencie_os_processos_vinculados_a_instituicao: "Gestiona los procesos vinculados a la institución.",
    legacy_gerenciar: "Gestionar",
    action_manage_dashboard: "Gestionar dashboard",
    action_manage_proctors: "Gestionar fiscales",
    action_manage_graders: "Gestionar correctores",
    action_manage_evaluators: "Gestionar evaluadores",
    legacy_horario_de_encerramento_do_intervalo: "Horario de cierre del intervalo",
    legacy_ir_para_lista_de_correcoes: "Ir a la lista de correcciones",
    legacy_informacoes: "Información",
    legacy_margem_direita: "Margen derecho",
    legacy_margem_esquerda: "Margen izquierdo",
    legacy_margem_inferior: "Margen inferior",
    legacy_margem_superior: "Margen superior",
    legacy_modulo_administrativo_utilizado_para_fazer_todos_os_cadastros_no_siste: "Módulo administrativo utilizado para gestionar registros y descargar resultados/informes",
    legacy_modulo_para_correcao_de_questoes_dissertativas_e_redacoes: "Módulo para corrección de preguntas discursivas y redacciones",
    legacy_modulo_para_aplicacao_de_prova_oral_onde_os_avaliadores_conseguem_entr: "Módulo para aplicación de prueba oral, donde los evaluadores pueden entrar en llamada con los candidatos",
    legacy_modulo_para_cadastros_de_questoes_por_parte_de_professores_elaboradoes: "Módulo para que profesores/elaboradores registren preguntas, respondan recursos y atiendan demandas",
    legacy_modulo_de_fiscalizacao_proctoring_do_candidato_durante_todo_o_perido_d: "Módulo de fiscalización/proctoring del candidato durante todo el período de evaluación en línea",
    legacy_modulo_para_acesso_do_candidato: "Módulo para acceso del candidato",
    legacy_modulos_vinculados: "Módulos vinculados",
    legacy_multipla_escolha: "Opción múltiple",
    legacy_escolha_multipla: "Opción múltiple",
    legacy_administrador: "Administrador",
    legacy_corretor: "Corrector",
    legacy_avaliador: "Evaluador",
    legacy_elaborador: "Elaborador",
    legacy_fiscal: "Fiscal",
    legacy_candidato: "Candidato",
    legacy_nenhum_conteudo_cadastrado: "Ningún contenido registrado",
    legacy_nenhum_conteudo_selecionado: "Ningún contenido seleccionado",
    legacy_nenhum_corretor_adicionado: "Ningún corrector agregado",
    legacy_nenhum_corretor_selecionado: "Ningún corrector seleccionado",
    legacy_nenhum_modulo_selecionado: "Ningún módulo seleccionado",
    legacy_nenhum_questionario_cadastrado: "Ningún cuestionario registrado",
    legacy_nenhum_recurso_encontrado: "Ningún recurso encontrado",
    legacy_nenhum_aviso_encontrado: "Ningún aviso encontrado",
    legacy_nenhuma_analise_encontrada: "Ningún análisis encontrado",
    legacy_nenhuma_disciplina_cadastrada: "Ninguna disciplina registrada",
    legacy_nenhuma_execucao_encontrada: "Ninguna ejecución encontrada",
    legacy_nenhuma_pergunta_adicionada: "Ninguna pregunta agregada",
    legacy_nenhuma_questao_adicionada: "Ninguna pregunta agregada",
    legacy_nenhuma_questao_cadastrada_nesta_demanda: "Ninguna pregunta registrada en esta demanda",
    legacy_nenhuma_questao_encontrada_com_os_filtros_aplicados: "Ninguna pregunta encontrada con los filtros aplicados",
    action_search: "Buscar",
    action_apply_filters: "Aplicar filtros",
    legacy_nenhuma_questao_selecionada: "Ninguna pregunta seleccionada",
    legacy_nenhuma_redacao_encontrada: "Ninguna redacción encontrada",
    legacy_nenhum_texto_de_apoio_adicionado: "Ningún texto de apoyo agregado",
    legacy_nenhuma_texto_encontrada: "Ningún texto encontrado",
    legacy_nenhum_avaliador_selecionado: "Ningún evaluador seleccionado",
    legacy_nenhum_comentario_adicionado: "Ningún comentario agregado",
    legacy_nenhum_criterio_adicionado: "Ningún criterio agregado",
    legacy_nenhuma_nota_registrada: "Ninguna nota registrada",
    legacy_nenhuma_palavra_chave_vinculada: "Ninguna palabra clave vinculada",
    legacy_nome_do_modulo: "Nombre del módulo",
    legacy_nome_da_disciplina: "Nombre de la disciplina",
    legacy_nome_da_categoria: "Nombre de la categoría",
    legacy_nome_do_corretor: "Nombre del corrector",
    legacy_nome_do_avaliador: "Nombre del evaluador",
    legacy_nome_do_fiscal: "Nombre del fiscal",
    legacy_nome_do_aluno: "Nombre del alumno",
    legacy_nome_do_membro: "Nombre del miembro",
    legacy_nome_do_membro_da_equipe: "Nombre del miembro del equipo",
    legacy_nome_do_elaborador: "Nombre del elaborador",
    legacy_nome_da_redacao: "Nombre de la redacción",
    legacy_nome_da_demanda: "Nombre de la demanda",
    legacy_nome_do_recurso: "Nombre del recurso",
    legacy_nome_do_treinamento: "Nombre de la capacitación",
    legacy_nome_da_entrevista: "Nombre de la entrevista",
    legacy_nome_da_organizadora: "Nombre de la organizadora",
    legacy_nome_da_prova: "Nombre de la prueba",
    legacy_nome_do_padrao: "Nombre de la plantilla",
    legacy_nome_organizacao: "Nombre de la organización",
    legacy_nome_usuario: "Nombre de usuario",
    legacy_numero_de_alternativas: "Número de alternativas",
    legacy_numero_de_modulos: "Número de módulos",
    legacy_numero_de_colunas_da_avaliacao: "Número de columnas de la evaluación",
    legacy_numero_de_colunas_na_pagina: "Número de columnas en la página",
    legacy_numero_de_colunas: "Número de columnas",
    legacy_presentes: "Presentes",
    legacy_alunos: "Alumnos",
    legacy_nota_minima: "Nota mínima",
    legacy_nota_maxima: "Nota máxima",
    legacy_nota: "Nota",
    legacy_criterios: "Criterios",
    legacy_codigo_do_criterio: "Código del criterio",
    legacy_texto_do_criterio: "Texto del criterio",
    legacy_n: "N.º",
    legacy_paginas: "Páginas",
    legacy_palavras_chaves: "Palabras clave",
    legacy_palavra_chave: "Palabra clave",
    legacy_palavra_chave_2: "Palabra clave",
    legacy_palavras_chave: "Palabras clave:",
    legacy_termos_nao_cadastrados: "Términos no registrados",
    legacy_termos_de_uso: "Términos de uso",
    legacy_alternativa_correta: "Alternativa correcta",
    legacy_alternativa_a: "Alternativa a)",
    legacy_alternativa_b: "Alternativa b)",
    legacy_alternativa_c: "Alternativa c)",
    legacy_alternativa_d: "Alternativa d)",
    legacy_alternativa_e: "Alternativa e)",
    legacy_comentarios: "Comentarios",
    legacy_correcao_da_redacao: "Corrección de la redacción",
    legacy_enunciado_da_redacao: "Enunciado de la redacción",
    legacy_escolaridade: "Escolaridad",
    legacy_solucao: "Solución",
    legacy_pesquisa: "Búsqueda",
    legacy_pesquisar_pelo_nome_do_arquivo: "Buscar por nombre del archivo",
    legacy_pesquisar_pelo_nome_cpf_numero_de_inscricao_do_candidato: "Buscar por nombre/CPF/número de inscripción del candidato",
    legacy_pesquisar_por_nome_cpf_ou_inscricao: "Buscar por nombre, CPF o inscripción",
    legacy_pesquisar_pelo_nome_do_questionario: "Buscar por nombre del cuestionario",
    legacy_pesquisar_pelo_nome_da_prova: "Buscar por nombre de la prueba",
    legacy_pesquisar_pelo_enunciado_ou_nome_da_redacao: "Buscar por enunciado o nombre de la redacción",
    legacy_pesquisar_pelo_nome_do_recurso: "Buscar por nombre del recurso",
    legacy_pesquisar_pelo_nome_da_organizadora: "Buscar por nombre de la organizadora",
    legacy_pesquisar_pelo_nome_do_treinamento: "Buscar por nombre de la capacitación",
    legacy_pesquisar_pelo_nome_da_entrevista: "Buscar por nombre de la entrevista",
    legacy_pesquisar_pelo_nome_da_imagem: "Buscar por nombre de la imagen",
    legacy_pesquisar_pelo_nome_do_video: "Buscar por nombre del video",
    legacy_pesquisar_pelo_nome_do_elaborador_ou_nome_da_categoria: "Buscar por nombre del elaborador o de la categoría",
    legacy_pesquisar_pelo_enunciado_ou_nome_do_elaborador: "Buscar por enunciado o nombre del elaborador",
    legacy_pesquisar_pelo_nome_da_diagramacao: "Buscar por nombre de diagramación",
    legacy_pesquisar_pelo_nome_do_candidato: "Buscar por nombre del candidato",
    legacy_pesquisar_pelo_nome_do_conteudo: "Buscar por nombre del contenido",
    legacy_pesquisar_pelo_nome_do_corretor: "Buscar por nombre del corrector",
    legacy_pesquisar_pelo_nome_do_elaborador: "Buscar por nombre del elaborador",
    legacy_pesquisar_pelo_nome_do_fiscal: "Buscar por nombre del fiscal",
    legacy_pesquisar_pelo_nome_do_membro: "Buscar por nombre del miembro",
    legacy_pesquisar_pelo_nome_do_modulo: "Buscar por nombre del módulo",
    legacy_pesquise_pelo_nome_do_conteudo: "Busca por nombre del contenido",
    legacy_pesquise_pelo_nome_do_fiscal: "Busca por nombre del fiscal",
    legacy_pesquise_a_questao_pelo_enunciado: "Busca la pregunta por enunciado",
    legacy_permissoes_concedidas: "Permisos concedidos",
    legacy_processo_seletivo_do_recurso: "Proceso selectivo del recurso",
    legacy_prova_objetiva: "Prueba objetiva",
    legacy_prova_atualizada: "Prueba actualizada",
    legacy_provas_cadastradas: "Pruebas registradas",
    legacy_questao_objetiva: "Pregunta objetiva",
    legacy_questao_unica: "Pregunta única",
    legacy_questao_selecionada: "Pregunta seleccionada",
    legacy_questoes_selecionadas: "Preguntas seleccionadas",
    legacy_questoes_cadastradas: "Preguntas registradas",
    legacy_questao_de_multipa_escolha: "Pregunta de opción múltiple",
    legacy_questao_dissertativa: "Pregunta discursiva",
    legacy_conjunto_de_questoes_de_multipa_escolha_com_enunciado_em_comum: "Conjunto de preguntas de opción múltiple con enunciado común",
    legacy_lista_de_questionarios: "Lista de cuestionarios",
    legacy_lista_de_diagramacoes: "Lista de diagramaciones",
    legacy_lista_de_organizadoras: "Lista de organizadoras",
    legacy_lista_de_questoes_para_avaliacao: "Lista de preguntas para evaluación",
    legacy_lista_de_recursos_de_questoes: "Lista de recursos de preguntas",
    legacy_registros_de_tela: "Registros de pantalla",
    legacy_videos: "Videos",
    legacy_logs_de_conexao: "Logs de conexión",
    legacy_diagramacoes_nominais: "Diagramaciones nominales",
    legacy_recolher_configuracoes: "Contraer configuraciones",
    legacy_relatorio_rapido: "Informe rápido",
    legacy_relatorios: "Informes",
    legacy_relatorios_gerais: "Informes generales",
    legacy_relatorios_por_vaga_cargo: "Informes por vacante/cargo",
    legacy_remover_elemento: "Eliminar elemento",
    legacy_redacao_criada: "Redacción creada",
    legacy_redacoes_cadastradas: "Redacciones registradas",
    legacy_revise_validacoes_imagens_e_ocorrencias_de_reconhecimento_facial: "Revisa validaciones, imágenes y eventos de reconocimiento facial.",
    legacy_ver_regras: "Ver reglas",
    legacy_ver_questao: "Ver pregunta",
    legacy_ver: "Ver",
    legacy_sala: "Sala",
    legacy_saidas_de_tela: "Salidas de pantalla",
    legacy_salvar_imagens_com_streaming_em_tempo_real: "Guardar imágenes con streaming en tiempo real",
    legacy_sem_fiscalizacao: "Sin fiscalización",
    legacy_salvar_diagramacao: "Guardar diagramación",
    legacy_salvar_diagramacao_como_padrao: "¿Guardar diagramación como plantilla?",
    legacy_salvar_diagramacao_e_imprimir: "Guardar diagramación e imprimir",
    legacy_salvar_configuracoes: "Guardar configuraciones",
    legacy_salvar_questao: "Guardar pregunta",
    legacy_salvar_comentario: "Guardar comentario",
    legacy_salvar_recurso: "Guardar recurso",
    legacy_salvar_corretor: "Guardar corrector",
    legacy_salvar_corretores: "Guardar correctores",
    legacy_salvar_fiscal: "Guardar fiscal",
    legacy_salvar_fiscais: "Guardar fiscales",
    legacy_salvar_avaliador: "Guardar evaluador",
    legacy_salvar_modulo: "Guardar módulo",
    legacy_salvar_treinamento: "Guardar capacitación",
    legacy_salvar_organizadora: "Guardar organizadora",
    legacy_salvar_redacoes: "Guardar redacciones",
    legacy_salvar_redacao: "Guardar redacción",
    legacy_salvar_aluno: "Guardar alumno",
    legacy_salvar_prova: "Guardar prueba",
    legacy_salvar_prova_e_ir_para_diagramacao: "Guardar prueba e ir a diagramación",
    legacy_salvar_questoes: "Guardar preguntas",
    legacy_salvar_questionario: "Guardar cuestionario",
    legacy_salvar_questionarios: "Guardar cuestionarios",
    legacy_salvar_conteudo: "Guardar contenido",
    legacy_salvar_formula: "Guardar fórmula",
    legacy_salvar_entrevista: "Guardar entrevista",
    legacy_mostrar_configuracoes: "Mostrar configuraciones",
    legacy_selecione_a_disciplina: "Selecciona la disciplina",
    legacy_selecione_a_quantidade: "Selecciona la cantidad",
    legacy_selecione_uma_disciplina: "Selecciona una disciplina",
    legacy_selecione_uma_alternativa_correta: "Selecciona una alternativa correcta",
    legacy_selecione_um_processo_seletivo: "Selecciona un proceso selectivo",
    legacy_selecione_um_ou_mais_elaboradores: "Selecciona uno o más elaboradores",
    legacy_selecione_um_ou_mais_elaboradores_que_deverao_cadastrar_questoes_dessa: "Selecciona uno o más elaboradores que deberán registrar preguntas de esta disciplina",
    legacy_selecione_um_elemento_no_preview_de_duplo_clique_para_editar_o_texto: "Selecciona un elemento en la vista previa. Haz doble clic para editar el texto.",
    legacy_selecione_um_padrao_de_diagramacao: "Selecciona una plantilla de diagramación",
    legacy_selecione_uma_prova: "Selecciona una prueba",
    legacy_sim_desejo_apagar: "Sí, eliminar",
    legacy_subtitulo_cabecalho: "Subtítulo del encabezado",
    legacy_tipo: "Tipo",
    legacy_tipo_da_questao: "Tipo de pregunta",
    legacy_tipo_de_pergunta: "Tipo de pregunta",
    legacy_tipos_de_status: "Tipos de estado:",
    legacy_titulo: "Título",
    legacy_titulo_do_questionario: "Título del cuestionario",
    legacy_titulo_do_texto_de_apoio: "Título del texto de apoyo",
    legacy_titulo_campo_1: "Título campo 1",
    legacy_titulo_campo_2: "Título campo 2",
    legacy_titulo_ex_escola_x: "Título. Ej.: Escuela X",
    legacy_tamanho_da_fonte_do_texto: "Tamaño de fuente del texto",
    legacy_termos_cadastrados: "Términos registrados",
    legacy_titulo_ex_instituicao: "Título (Ej.: Institución)",
    legacy_titulo_cabecalho: "Título del encabezado",
    legacy_todos_os_relatorios: "Todos los informes",
    legacy_n_candidatos: "N.º candidatos",
    legacy_n_fiscais: "N.º fiscales",
    legacy_n_corretores: "N.º correctores",
    legacy_vagas: "Vacantes",
    legacy_veja_candidatos_e_avaliadores_conectados_no_momento: "Ve candidatos y evaluadores conectados ahora.",
    legacy_ver_enunciado: "Ver enunciado",
    legacy_visualize_indicadores: "Visualiza indicadores",
    legacy_visualize_as_atribuicoes_desta_demanda: "Visualiza las asignaciones de esta demanda.",
    legacy_visualize_as_atribuicoes_deste_recurso: "Visualiza las asignaciones de este recurso.",
    legacy_visualize_os_modulos_vinculados_ao_treinamento: "Visualiza los módulos vinculados a la capacitación.",
    legacy_visualize_os_candidatos_vinculados_a_entrevista: "Visualiza los candidatos vinculados a la entrevista.",
    legacy_visualize_as_questoes_do_questionario: "Visualiza las preguntas del cuestionario.",
    legacy_visualize_as_questoes_desta_diagramacao: "Visualiza las preguntas de esta diagramación.",
    legacy_visualize_os_registros_de_tela: "Visualiza los registros de pantalla.",
    legacy_consulte_os_relatorios_da_analise_facial: "Consulta los informes del análisis facial.",
    legacy_consulte_os_relatorios_e_pontos_de_confianca: "Consulta los informes y puntos de confianza.",
    legacy_quem_ja_fez_login: "Quién ya inició sesión",
    legacy_online_agora: "En línea ahora",
    legacy_abrir_modulo: "Abrir módulo",
    legacy_encerramento: "Cierre:",
    legacy_e_mail_do_elaborador: "Correo del elaborador",
    legacy_baixe_relatorios_gerais_ou_abra_a_area_completa_de_relatorios: "Descarga informes generales o abre el área completa de informes.",
    legacy_avaliadores_online: "Evaluadores en línea",
    legacy_avaliadores_vinculados: "Evaluadores vinculados",
    legacy_fiscais_vinculados: "Fiscales vinculados",
    legacy_candidato_vinculado: "Candidato vinculado",
    legacy_baixar_pdf_2: "Descargar PDF",
    legacy_baixar_planilha: "Descargar hoja",
    legacy_baixar_gabarito_da_prova: "Descargar plantilla de respuestas de la prueba",
    legacy_baixar_respostas_da_prova: "Descargar respuestas de la prueba",
    legacy_baixar_folhas_de_resposta_em_pdf: "Descargar hojas de respuesta en .pdf",
    legacy_baixar_caderno_com_respostas_em_pdf: "Descargar cuaderno con respuestas en PDF",
    legacy_baixar_provas_em_pdf: "Descargar pruebas en .pdf",
    legacy_baixar_respostas_em_csv: "Descargar respuestas en .csv",
    legacy_baixar_resposta_em_pdf: "Descargar respuesta en .pdf",
    legacy_baixar_relatorio_de_saidas_de_tela: "Descargar informe de salidas de pantalla",
    legacy_baixar_pdf_com_imagens: "Descargar PDF con imágenes",
    legacy_categoria: "Categoría",
    legacy_data_da_ultima_atualizacao: "Fecha de última actualización",
    legacy_erro: "Error",
    legacy_identificador_da_demanda: "Identificador de la demanda",
    legacy_numero_de_questoes: "Cantidad de preguntas",
    legacy_numero_de_questoes_2: "Cantidad de preguntas",
    legacy_numero_de_inscricao: "Número de inscripción",
    legacy_numero_de_inscricao_2: "Número de inscripción",
    legacy_numero_inscricao: "Número de inscripción",
    legacy_numero_deteccoes: "Cantidad de detecciones",
    legacy_pesquise_o_fiscal_pelo_nome: "Busca el fiscal por nombre",
    legacy_prova: "Prueba",
    legacy_relatorio: "Informe",
    legacy_relatorio_de_acesso: "Informe de acceso",
    legacy_saidas: "Salidas",
    legacy_tipo_de_arquivo: "Tipo de archivo",
    legacy_total: "Total",
    legacy_textos_de_apoio: "Textos de apoyo",
    legacy_corrigir_com_ia: "Corregir con IA",
    legacy_cpf: "CPF",
    legacy_inscricao: "Inscripción",
    legacy_resultado: "Resultado",
    legacy_modelo: "Modelo",
    legacy_progresso: "Progreso",
    legacy_primeira_deteccao: "Primera detección",
    legacy_pre_visualizacao_do_pdf: "Vista previa del PDF",
    legacy_upload_da_capa_do_video: "Subida de portada del video",
    legacy_pre_visualizacao_do_video: "Vista previa del video",
    legacy_pre_visualizacao_da_capa: "Vista previa de la portada",
    legacy_busque_um_ou_mais_conteudos_que_deseja_vincular: "Busca uno o más contenidos para vincular",
    legacy_busque_um_ou_mais_corretores_que_deseja_vincular: "Busca uno o más correctores para vincular",
    legacy_busque_um_ou_mais_fiscais_que_deseja_vincular: "Busca uno o más fiscales para vincular",
    legacy_busque_um_ou_mais_candidatos_que_deseja_vincular: "Busca uno o más candidatos para vincular",
    legacy_busque_questoes_da_disciplina: "Busca preguntas de la disciplina",
    legacy_gerencie_os_textos_de_apoio_da_redacao: "Gestiona los textos de apoyo de la redacción.",
    legacy_acompanhe_os_resultados_desta_redacao: "Sigue los resultados de esta redacción.",
    legacy_acesse_a_correcao_assistida_por_ia: "Accede a la corrección asistida por IA.",
    legacy_visualize_e_organize_as_questoes_da_prova: "Visualiza y organiza las preguntas de la prueba.",
    legacy_visualize_os_conteudos_vinculados_ao_modulo: "Visualiza los contenidos vinculados al módulo.",
    legacy_visualize_o_arquivo_principal_do_conteudo: "Visualiza el archivo principal del contenido.",
    legacy_gerencie_as_questoes_vinculadas_ao_conteudo: "Gestiona las preguntas vinculadas al contenido.",
    legacy_visualize_as_imagens_capturadas_na_analise: "Visualiza las imágenes capturadas en el análisis.",
    legacy_consulte_os_relatorios_da_analise: "Consulta los informes del análisis.",
    legacy_consulte_os_candidatos_vinculados_a_esta_sala: "Consulta los candidatos vinculados a esta sala.",
    legacy_veja_os_fiscais_responsaveis_pela_sala: "Ve los fiscales responsables de la sala.",
    legacy_acompanhe_os_corretores_vinculados: "Sigue los correctores vinculados.",
    legacy_consulte_o_historico_e_os_indicadores_de_acesso: "Consulta el historial y los indicadores de acceso.",
    legacy_visualize_as_avaliacoes_do_candidato: "Visualiza las evaluaciones del candidato.",
    legacy_acesse_os_videos_capturados: "Accede a los videos capturados.",
    legacy_consulte_os_logs_de_conexao: "Consulta los logs de conexión.",
    legacy_veja_os_videos_da_tela_do_candidato: "Ve los videos de pantalla del candidato.",
    legacy_aqui_ficam_os_downloads_do_seletivo: "Aquí están las descargas del proceso selectivo",
    legacy_aqui_ficam_os_modelos_da_prova: "Aquí están los modelos de la prueba",
    legacy_aqui_ficam_os_candidatos_que_possuem_conflito_de_cpf_com_outros_candid: "Aquí están los candidatos con conflicto de CPF con otros candidatos",
    legacy_arquivo_csv: "Archivo .csv",
    legacy_arquivo_csv_contendo_os_dados_dos_corretores: "Archivo .csv con los datos de los correctores",
    legacy_arquivo_de_redacoes_zip_rar: "Archivo de redacciones (.zip/.rar)",
    legacy_busque_um_ou_mais_avaliadores_que_deseja_vincular: "Busca uno o más evaluadores para vincular",
    legacy_busque_um_ou_mais_fiscais_que_deseja_vincular_no_treinamento: "Busca uno o más fiscales para vincular a la capacitación",
    legacy_busque_um_ou_mais_modulos_que_deseja_vincular: "Busca uno o más módulos para vincular",
    legacy_busque_um_ou_mais_questionarios_que_deseja_vincular: "Busca uno o más cuestionarios para vincular",
    legacy_campo_1: "Campo 1",
    legacy_campo_1_ex_cargo_de_poilicia: "Campo 1 (Ej.: Cargo policial)",
    legacy_campo_2: "Campo 2",
    legacy_campo_2_ex_vespertino: "Campo 2 (Ej.: Vespertino)",
    legacy_corretores_selecionados: "Correctores seleccionados",
    legacy_deletar_disciplina: "Eliminar disciplina",
    legacy_deletar_elaborador: "Eliminar elaborador",
    legacy_deletar_organizadora: "Eliminar organizadora",
    legacy_deletar_recurso: "Eliminar recurso",
    legacy_deletar_texto: "Eliminar texto",
    legacy_desvincular_candidato: "Desvincular candidato",
    legacy_desvincular_fiscal: "Desvincular fiscal",
    legacy_digite_a_confirmacao_de_senha: "Ingresa la confirmación de contraseña",
    legacy_fiscais_selecionados: "Fiscales seleccionados",
    legacy_gerenciar_aula: "Gestionar clase",
    legacy_gerenciar_candidato: "Gestionar candidato",
    legacy_gerenciar_disciplina: "Gestionar disciplina",
    legacy_gerenciar_imagem: "Gestionar imagen",
    legacy_gerenciar_organizadora: "Gestionar organizadora",
    legacy_gerenciar_prova: "Gestionar prueba",
    legacy_gerenciar_recurso: "Gestionar recurso",
    legacy_gerenciar_texto: "Gestionar texto",
    legacy_historico_de_resposta_s: "Historial de respuesta(s):",
    legacy_imagem_s_arquivo_s_da_resposta: "Imagen(es)/archivo(s) de la respuesta:",
    legacy_imagem_s_arquivo_s_do_recurso: "Imagen(es)/archivo(s) del recurso:",
    legacy_imagens_arquivos_do_recurso_maximo_10_arquivos: "Imágenes/archivos del recurso (máximo 10 archivos)",
    legacy_incluir_campo_de_titulo_na_redacao: "¿Incluir campo de título en la redacción?",
    legacy_incluir_folha_em_branco_apos_folha_de_rosto: "¿Incluir hoja en blanco después de la portada?",
    legacy_numero_de_linhas_na_folha_de_redacao: "Número de líneas en la hoja de redacción",
    legacy_pedido_realizado: "Solicitud realizada",
    legacy_pesquise_o_avaliador_pelo_nome: "Busca el evaluador por nombre",
    legacy_pesquisar_pelo_nome_do_membro_da_organizadora: "Buscar por nombre del miembro de la organizadora",
    legacy_questao_selecionada_2: "Pregunta seleccionada:",
    legacy_redacoes_zip_rar: "Redacciones (.zip/.rar)",
    legacy_subtitulo_ex_local: "Subtítulo (Ej.: Lugar)",
    legacy_subtitulo_ex_estado_de_sao_paulo: "Subtítulo. Ej.: Estado de Sao Paulo",
    legacy_subtitulo_do_cabecalho: "Subtítulo del encabezado",
    legacy_texto_de_apoio_pdf: "Texto de apoyo (.pdf)",
    legacy_texto_informativo_na_tela_de_login: "Texto informativo en la pantalla de inicio de sesión",
    legacy_texto_informativo_para_os_candidatos_que_ira_aparecer_na_tela_de_login: "Texto informativo para los candidatos que aparecerá en la pantalla de inicio de sesión.",
    legacy_titulo_campo_1_ex_cargo: "Título campo 1 (Ej.: Cargo)",
    legacy_titulo_campo_2_ex_turno: "Título campo 2 (Ej.: Turno)",
    legacy_titulo_do_cabecalho: "Título del encabezado",
    legacy_tamanho_da_fonte_das_instrucoes: "Tamaño de fuente de las instrucciones",
    legacy_tamanho_da_fonte_do_cabecalho_da_folha_de_rosto: "Tamaño de fuente del encabezado de la portada",
    legacy_visualizar: "Ver",
    legacy_visualizar_texto: "Ver texto",
    legacy_cabecalho_folha_de_rosto: "Encabezado de la portada",
    legacy_caminho_da_url: "Ruta de URL",
    legacy_cnpj: "CNPJ",
    legacy_escreva_a_alternativa: "Escribe la alternativa",
    legacy_escreva_a_pergunta: "Escribe la pregunta",
    legacy_escreva_a_pergunta_do_campo_texto: "Escribe la pregunta del campo de texto",
    legacy_escreva_o_placeholder_do_campo_texto: "Escribe el placeholder del campo de texto",
    legacy_fundamentacao_do_pedido: "Fundamentación de la solicitud",
    legacy_fundamentacao_do_pedido_2: "Fundamentación de la solicitud:",
    legacy_horario_limite: "Hora límite",
    legacy_informacao_geral: "Información general",
    legacy_informacao_geral_2: "Información general:",
    legacy_informacao_para_o_avaliador: "Información para el evaluador",
    legacy_informacao_para_o_avaliador_2: "Información para el evaluador:",
    legacy_logo_superior: "Logo superior",
    legacy_logo_inferior: "Logo inferior",
    legacy_numero_de_inscricao_do_candidato: "Número de inscripción del candidato",
    legacy_obrigatorio_sempre: "Siempre obligatorio",
    legacy_obrigatorio_se: "Obligatorio si",
    legacy_qual_a_alternativa_correta: "¿Cuál es la alternativa correcta?",
    legacy_texto_do_topico: "Texto del tema",
    legacy_visualizar_pergunta_do_questionario: "Ver pregunta del cuestionario",
    legacy_vincular_corretor_es: "Vincular corrector(es)",
    legacy_dashboard: "← Dashboard",
    legacy_cadastrados_na_plataforma: "registrados en la plataforma",
    legacy_as_vagas: "vacantes",
    legacy_os_processos: "procesos",
    legacy_candidatos_e_equipe: ", candidatos y equipo",
    legacy_da_instituicao: "de la institución",
    legacy_do_processo: "del proceso",
    legacy_instituicoes: "instituciones",
    legacy_processos: "procesos",
    ui_sim_desejo_desvincular_91364237: "Sí, deseo desvincular",
    ui_ao_desvincular_este_questao_ele_nao_tera_mais_aces_7cad3b8d: "Al desvincular esta pregunta, ya no tendrá acceso a las preguntas de este proceso",
    ui_ao_deletar_este_candidato_ele_nao_estara_mais_disp_014976fb: "Al eliminar este candidato, ya no estará disponible en el sistema",
    ui_cadastrar_candidato_00a96ef8: "Registrar candidato",
    ui_cadastre_os_candidatos_cd2390f0: "Registre los candidatos",
    ui_o_candidato_precisa_de_alguma_funcao_de_acessibili_9ef2ad9d: "El candidato necesita alguna funcion de accesibilidad? Ejemplo: escuchar el texto de la pregunta",
    ui_e_necessario_um_fiscal_supervisor_77284eb8: "Es necesario un supervisor fiscal?",
    ui_habilitar_opcao_de_ouvir_questao_redacao_744ae16d: "Habilitar opcion para escuchar pregunta/redaccion?",
    ui_habilitar_possibilidade_de_ampliar_questao_redacao_cb06350b: "Habilitar opcion para ampliar pregunta/redaccion?",
    ui_data_invalida_76fc5825: "Fecha invalida",
    ui_editar_candidato_de3b0830: "Editar candidato",
    ui_aqui_ficam_as_analises_dos_candidatos_do_processo_4d85efa9: "Análisis de candidatos del proceso \"",
    ui_acuracia_media_ed46129a: "Precision media",
    ui_melhor_acuracia_9143c643: "Mejor precision",
    ui_pior_acuracia_eca7bfc4: "Peor precision",
    ui_acoes_reportadas_473f06f8: "Acciones reportadas",
    ui_aqui_ficam_as_analises_das_imagens_do_candidato_8490cebb: "Análisis de imágenes del candidato \"",
    ui_acuracia_18c91bc7: "Precisión",
    ui_ultimo_login_64f79636: "Último inicio de sesión:",
    ui_aqui_ficam_as_analises_dos_candidatos_vinculados_a_7ea29b91: "Análisis de los candidatos vinculados al proceso \"",
    ui_estatisticas_bd290229: "Estadisticas",
    ui_nao_detectada_0d0935c6: "No detectada:",
    ui_multiplas_faces_detectadas_944de664: "Multiples rostros detectados:",
    ui_ao_deletar_este_avaliador_ele_nao_estara_mais_disp_5a8e24a5: "Al eliminar este evaluador, ya no estará disponible en el sistema",
    ui_gerencie_os_avaliadores_vinculados_ao_processo_e1675ff5: "Gestiona los evaluadores vinculados al proceso",
    ui_ao_desvincular_este_avaliador_ele_nao_tera_mais_ac_341570a9: "Al desvincular este evaluador, ya no tendrá acceso a este proceso",
    ui_nenhum_avaliador_encontrado_com_este_termo_02f9a1af: "Ningún evaluador encontrado con este término",
    ui_salvar_avaliadores_07b49db6: "Guardar evaluadores",
    ui_bem_vindo_a_questoes_publicas_043b7469: "¡Bienvenido a Preguntas públicas!",
    ui_filtrar_questoes_6421faf4: "Filtrar preguntas",
    ui_tipo_de_questao_d2c9716b: "Tipo de pregunta",
    ui_ensino_medio_3712ec7a: "Educación secundaria",
    ui_nivel_de_dificuldade_a85f6b3c: "Nivel de dificultad",
    ui_facil_e304d15a: "Fácil",
    ui_medio_4f48c19e: "Medio",
    ui_dificil_36dc8fb0: "Difícil",
    ui_utilizar_questao_3fee6791: "Usar pregunta",
    ui_alterar_questao_bbfea6ad: "Cambiar pregunta",
    ui_aqui_ficam_a_confiabilidade_dos_candidatos_no_d344db7b: "Indicadores de confiabilidad de candidatos en \"",
    ui_quanto_menor_o_valor_mais_confiavel_6654eba4: "\". Cuanto menor sea el valor, más confiable",
    ui_acoes_reportadas_3b561a75: "Acciones reportadas:",
    ui_media_do_reconhecimento_facial_cda4999c: "Promedio de reconocimiento facial:",
    ui_validacoes_faciais_periodicas_004cccb9: "Validaciones faciales periódicas:",
    ui_numero_de_pedidos_de_liberacao_para_o_fiscal_ae10b565: "Número de solicitudes de liberación al fiscal:",
    ui_saidas_de_tela_101c35f0: "Salidas de pantalla:",
    ui_tempo_de_saida_da_tela_de_prova_75e5fa8c: "Tiempo de salida de la pantalla de evaluación:",
    ui_videos_sem_rosto_39a8f692: "Videos sin rostro:",
    ui_multiplas_rostos_2288af49: "Múltiples rostros:",
    ui_ips_identicos_a9e2cc1b: "IPs idénticas:",
    ui_ao_desvincular_este_candidato_ele_nao_tera_mais_ac_1d2c882c: "Al desvincular este candidato, ya no tendrá acceso a este proceso",
    ui_aqui_ficam_os_candidatos_ordernados_por_saidas_da__b0224f9a: "Candidatos ordenados por salidas de la pantalla de evaluación de \"",
    ui_quanto_menor_mais_confiavel_46a756c2: "Cuanto menor, más confiable",
    ui_vincule_um_ou_mais_candidatos_ao_processo_aeb7a3be: "Vincule uno o mas candidatos al proceso",
    ui_nenhum_candidato_encontrado_com_este_termo_2b9da6d2: "Ningún candidato encontrado con este término",
    ui_candidatos_selecionados_c38f4abb: "Candidatos seleccionados",
    ui_nenhum_candidato_selecionado_5cf1f638: "Ningun candidato seleccionado",
    ui_salvar_candidatos_87fdb232: "Guardar candidatos",
    ui_salvando_candidatos_bfb38308: "Guardando candidatos",
    ui_aqui_ficam_os_registros_de_tela_do_candidato_dd8ad37e: "Registros de pantalla del candidato \"",
    ui_ao_deletar_esta_imagem_ela_nao_estara_mais_disponi_fba6b358: "Al eliminar esta imagen, ya no estará disponible en el sistema",
    ui_aqui_ficam_as_imagens_do_candidato_6138c418: "Imágenes del candidato \"",
    ui_proximo_64b2d0d6: "Siguiente",
    ui_nenhuma_imagem_encontrada_2840b232: "No se encontro ninguna imagen",
    ui_ao_deletar_este_image_ele_nao_estara_mais_disponiv_e2464011: "Al eliminar esta imagen, ya no estará disponible en el sistema",
    ui_aqui_fica_os_logs_de_conexao_do_candidato_d73a76d4: "Registros de conexión del candidato \"",
    ui_logs_de_conexao_86069e78: "Registros de conexión:",
    ui_ao_deletar_este_relatorio_ele_nao_estara_mais_disp_34cd8ca1: "Al eliminar este informe, ya no estará disponible en el sistema",
    ui_aqui_ficam_as_mensagens_do_candidato_92001b7d: "Mensajes del candidato \"",
    ui_ao_deletar_este_message_ele_nao_estara_mais_dispon_ff224805: "Al eliminar este mensaje, ya no estará disponible en el sistema",
    ui_adicionar_candidatos_no_processo_4fc3ab7a: "Agregar candidatos al proceso",
    ui_arquivo_csv_contendo_os_dados_dos_candidatos_272963f2: "Archivo .csv con los datos de los candidatos",
    ui_padrao_3386172b: "Patron:",
    ui_o_csv_nao_deve_ter_cabecalho_nome_das_colunas_as_c_641b51e4: "El .csv no debe incluir encabezado. Las columnas deben estar separadas por “;” en el siguiente formato:",
    ui_numero_inscricao_nome_e_mail_data_de_nascimento_yy_e687bdde: "Número de inscripción; Nombre; E-mail; Fecha de nacimiento (YYYY-MM-DD); CPF (sin . ni -); Contraseña; Enlace de la foto del candidato (opcional)",
    ui_nenhum_candidato_adicionado_33c9a2c9: "Ningún candidato agregado",
    ui_aqui_ficam_as_avaliacoes_do_candidato_fd246cf8: "Evaluaciones del candidato \"",
    ui_redacoes_30c87866: "Redacciones:",
    ui_redacao_cd320598: "Redacción",
    ui_gerenciar_correcao_c17fdb3e: "Gestionar corrección",
    ui_gerenciar_redacao_b69a0438: "Gestionar redacción",
    ui_nenhuma_redacao_encontrado_eb318de7: "Ninguna redacción encontrada",
    ui_questionarios_fefc98ab: "Cuestionarios:",
    ui_questionario_a3ec8d1d: "Cuestionario",
    ui_nenhum_questionario_encontrado_cc92c82e: "Ningún cuestionario encontrado",
    ui_aqui_fica_o_relatorio_do_candidato_37e99da8: "Informe del candidato \"",
    ui_acao_d621dc82: "Acción",
    ui_ate_fc454800: "Hasta",
    ui_saiu_da_pagina_da_aplicacao_fda9235a: "Salió de la página de la aplicación:",
    ui_horario_3bd854d6: "Horario",
    ui_ver_video_da_camera_0a3101ee: "Ver video de la cámara",
    ui_ver_video_da_tela_b4b78e7f: "Ver video de pantalla",
    ui_nenhuma_acao_registrada_aebf4fac: "Ninguna acción registrada",
    ui_registros_de_saida_27d28fba: "Registros de salida:",
    ui_avisos_de_restricao_de_horario_duas_ou_mais_telas__902f57ad: "Avisos de restricción horaria/dos o más pantallas/permisos:",
    ui_media_do_reconhecimento_facial_001ef5c2: "Promedio de reconocimiento facial",
    ui_validacoes_faciais_periodicas_f9280df8: "Validaciones faciales periódicas",
    ui_numero_de_pedidos_de_liberacao_para_o_fiscal_217b2c1f: "Número de solicitudes de liberación para el fiscal",
    ui_tempo_de_saida_da_tela_de_prova_7fd35c63: "Tiempo de salida de la pantalla de prueba",
    ui_videos_sem_rosto_57354ae0: "Videos sin rostro",
    ui_multiplas_rostos_de74b532: "Múltiples rostros",
    ui_ips_identicos_df44355b: "IPs idénticas",
    ui_sim_desejo_liberar_b38fec32: "Sim, desejo liberar",
    ui_ao_liberar_esse_candidato_ele_tera_acesso_a_avalia_8784a55f: "Al liberar este candidato, tendrá acceso a la evaluación si no ingresó durante el intervalo configurado o si ya finalizó la evaluación",
    ui_aqui_ficam_os_videos_da_tela_do_candidato_8209a3d0: "Videos de pantalla del candidato \"",
    ui_nenhum_video_de_tela_encontrado_372de0f0: "No se encontro ningun video de pantalla",
    ui_ao_deletar_este_video_ele_nao_estara_mais_disponiv_db74e885: "Al eliminar este video, ya no estará disponible en el sistema",
    ui_aqui_ficam_os_videos_do_candidato_a563f69c: "Videos del candidato \"",
    ui_nenhum_video_encontrado_6180dcce: "No se encontro ningun video",
    ui_ao_deletar_esta_disciplina_ela_nao_estara_mais_dis_6ced45ee: "Al eliminar esta disciplina, ya no estará disponible en el sistema",
    ui_contexto_da_questao_36e5d6aa: "Contexto de la pregunta",
    ui_tipo_de_questao_2e2adb09: "Tipo de pregunta:",
    ui_nivel_de_escolaridade_d4702d75: "Nivel de escolaridad:",
    ui_nivel_de_dificuldade_0d029649: "Nivel de dificultad:",
    ui_editar_criar_novo_contexto_0450e752: "Editar/Crear nuevo contexto",
    ui_gerar_questao_d655bb9d: "Generar pregunta",
    ui_questoes_geradas_pendentes_de_validacao_18471a7e: "Preguntas generadas pendientes de validacion",
    ui_altere_a_disciplina_do_contexto_para_ver_questao_p_815d5e95: "Cambia la disciplina del contexto para ver preguntas pendientes de otra disciplina",
    ui_validar_questao_787fc7b5: "Validar pregunta",
    ui_salvar_disciplina_b7d69832: "Guardar disciplina",
    ui_cadastre_as_questoes_da_disciplina_2788a383: "Registre preguntas de la disciplina",
    ui_criando_questao_a_partir_de_uma_questao_gerada_por_fa6bba4a: "*Creando una pregunta a partir de una pregunta generada por IA*",
    ui_criar_questao_com_ia_e87441a1: "Crear pregunta con IA",
    ui_nivel_de_escolaridade_a4c58d10: "Nivel de escolaridad",
    ui_gerenciar_questao_71268f08: "Gestionar pregunta",
    ui_deletar_questao_6f8e24a2: "Eliminar pregunta",
    ui_salvando_questao_848b910e: "Guardando pregunta",
    ui_editar_disciplina_3a3c3d30: "Editar disciplina",
    ui_edite_uma_questao_da_disciplina_dec9ff97: "Edite una pregunta de la disciplina",
    ui_questao_56688686: "Pregunta -",
    ui_abra_o_teclado_de_formula_clicando_em_3de9635e: "Abra o teclado de fórmula clicando em",
    ui_aperte_shift_em_cada_aba_do_teclado_para_ver_mais__8e0b3b8b: "Presiona SHIFT en cada pestaña del teclado para ver más opciones",
    ui_salvando_formula_f82737d5: "Salvando fórmula",
    ui_solucao_b354e358: "Solucion:",
    ui_questao_de_31457044: "Pregunta de",
    ui_adicionar_questoes_na_disciplina_03c19af6: "Agregar preguntas a la disciplina",
    ui_palavras_chaves_palavras_que_serao_aplicadas_para__c51efe30: "Palabras clave (palabras usadas para identificar todas las preguntas del archivo)",
    ui_arquivo_docx_contendo_as_questoes_f5bf5ebe: "Archivo .docx con las preguntas",
    ui_o_docx_deve_ter_os_seguintes_caracteres_dividindo__d9815b36: "El .docx debe usar los siguientes caracteres para separar cada pregunta: $$$$$",
    ui_o_docx_deve_ter_os_seguintes_caracteres_dividindo__37d81673: "El .docx debe usar los siguientes caracteres para separar cada alternativa: &&&&&",
    ui_se_for_a_ultima_questao_ao_final_do_arquivo_tambem_e587849a: "Si es la última pregunta, al final del archivo también se deben colocar los caracteres: $$$$$",
    ui_o_docx_deve_ter_os_seguintes_caracteres_para_indic_1d1f63f4: "El .docx debe usar los siguientes caracteres para indicar que la línea siguiente contiene la respuesta de la pregunta: =====",
    ui_nenhuma_questao_cadastrada_2b696d49: "Ninguna pregunta registrada",
    ui_ao_deletar_esta_questao_ela_nao_estara_mais_dispon_a09d435b: "Al eliminar esta pregunta, ya no estará disponible en el sistema",
    ui_deseja_marcar_essa_questao_como_b8074843: "Desea marcar esta pregunta como",
    ui_defina_o_contexto_da_questao_4d71daea: "Defina el contexto de la pregunta",
    ui_crie_uma_questao_utilizando_inteligencia_artificia_66097e93: "Cree una pregunta usando inteligencia artificial",
    ui_descreva_o_assunto_especifico_da_questao_b704a6ac: "Describa el tema especifico de la pregunta",
    ui_avancar_82625e8f: "Continuar",
    ui_essa_questao_foi_criada_por_ia_voce_deve_confirmar_74018da6: "Esta pregunta fue creada por IA. Debes confirmar la calidad de la pregunta generada.",
    ui_voce_tem_certeza_que_deseja_validar_esta_questao_9e34f2f8: "¿Seguro que deseas validar esta pregunta?",
    ui_ao_confirmar_sera_redirecionado_para_a_pagina_de_b3319da3: "Al confirmar, serás redirigido a la página de",
    ui_criar_questao_beccec03: "\"Crear pregunta\"",
    ui_onde_podera_editar_seu_conteudo_como_desejar_10c9f36f: ", donde podrás editar su contenido como quieras.",
    ui_ao_deletar_este_membro_ele_nao_tera_mais_acesso_ao_65edeccd: "Al eliminar este miembro, ya no tendrá acceso al sistema",
    ui_deletar_conteudo_654f6956: "Deletar conteúdo",
    ui_cadastrar_conteudo_419aa739: "Registrar contenido",
    ui_cadastre_os_conteudos_do_seu_sistema_2deb6d86: "Registre los contenidos de su sistema",
    ui_nome_do_conteudo_103bd7e3: "Nombre del contenido",
    ui_selecione_qual_sera_o_tipo_do_arquivo_5c78c931: "Selecciona el tipo de archivo",
    ui_video_03e7e13e: "Video",
    ui_upload_do_video_menor_do_que_200_mb_3a58957f: "Upload do Vídeo (Menor do que 200 Mb)",
    ui_pre_visualizacao_65cab02c: "Vista previa",
    ui_salvando_conteudo_03d904a8: "Guardando contenido",
    ui_cadastre_as_questoes_do_conteudo_c3aecc68: "Registra las preguntas del contenido",
    ui_nome_da_questao_fbe10cc2: "Nombre de la pregunta",
    ui_editar_conteudo_f001902a: "Editar contenido",
    ui_upload_do_pdf_caso_seja_o_mesmo_nao_escolha_nenhum_2e4b8884: "Carga del PDF (si no cambió, no elijas ningún archivo)",
    ui_upload_do_video_caso_seja_o_mesmo_nao_escolha_nenh_a0aacf5a: "Carga del video (si no cambió, no elijas ningún archivo)",
    ui_upload_da_capa_do_video_caso_seja_o_mesmo_nao_esco_ba01a936: "Carga de la portada del video (si no cambió, no elijas ningún archivo)",
    ui_seu_navegador_nao_suporta_o_elemento_de_video_05b48753: "Su navegador no soporta el elemento de video.",
    ui_edite_uma_questao_do_conteudo_5a52b2a7: "Edita una pregunta del contenido",
    ui_editar_perguntas_9063b9f2: "Editar preguntas",
    ui_nao_foi_possivel_encontrar_o_arquivo_080c0a5a: "No fue posible encontrar el archivo.",
    ui_questao_de_6a47d07b: "Pregunta de:",
    ui_ao_deletar_este_corretor_ele_nao_estara_mais_dispo_823c3f53: "Al eliminar este corrector, ya no estará disponible en el sistema",
    ui_correcoes_redacoes_440ee433: "Correcciones de redacciones",
    ui_correcoes_dissertativas_926a5325: "Correcciones discursivas",
    ui_ao_desvincular_este_corretor_ele_nao_tera_mais_ace_2636a0a7: "Al desvincular este corrector, ya no tendrá acceso a las salas de este proceso",
    ui_nenhum_corretor_encontrado_com_este_termo_6d600488: "Ningún corrector encontrado con este término",
    ui_corrigira_quais_redacoes_9a93a9ff: "¿Qué redacciones corregirá?",
    ui_nenhuma_sala_selecionada_bf0df991: "Ninguna sala seleccionada",
    ui_nome_e_mail_senha_cpf_candidato_opcional_numero_da_dc2d93eb: "Nombre; E-mail; Contraseña; CPF del candidato (opcional); Número de pregunta (opcional); Salas (opcional)",
    ui_para_o_corretor_deve_ser_especificado_um_ou_mais_c_6d982098: "Para el corrector, se deben especificar uno o más candidatos junto con el número de pregunta para corregir la prueba discursiva, o una o más salas para corregir redacciones. Las salas deben especificarse separadas por comas. Por ejemplo, para que un corrector quede en las salas 1, 2 y 3, use: 1,2,3",
    ui_ao_deletar_esta_atribuicao_o_elaborador_nao_tera_m_aedfe8f4: "Al eliminar esta asignación, el elaborador ya no tendrá acceso a esta disciplina/demanda",
    ui_horario_invalido_6d7a8390: "Horário inválido",
    ui_salvando_demanda_f0fa62e8: "Guardando demanda",
    ui_gerenciar_demanda_d6f65913: "Gestionar demanda",
    ui_ao_deletar_esta_demanda_ela_nao_estara_mais_dispon_c569a1d6: "Al eliminar esta demanda, ya no estará disponible en el sistema",
    ui_edite_a_demanda_do_seu_sistema_ab251ef1: "Edita la demanda de tu sistema",
    ui_aqui_sao_listados_todas_as_questoes_da_demanda_0edb9c97: "Aquí se listan todas las preguntas de la demanda \"",
    ui_questoes_objetivas_d444777a: "Preguntas objetivas:",
    ui_questoes_dissertativas_8b8bb598: "Preguntas discursivas:",
    ui_descritivo_a0d41125: "Descritivo:",
    ui_cadastre_uma_diagramacao_de_prova_e9cacaf0: "Crea una diagramación de prueba",
    ui_nenhuma_prova_encontrada_para_diagramar_8d13fd70: "Ninguna prueba encontrada para diagramar",
    ui_trazer_as_questoes_diagramadas_do_padrao_seleciona_840f3d1d: "¿Traer las preguntas diagramadas del patrón seleccionado?",
    ui_instrucoes_7961e863: "Instrucciones",
    ui_numero_de_colunas_das_instrucoes_d22515a8: "Número de columnas de las instrucciones",
    ui_salvando_diagramacao_303cdc1f: "Guardando diagramación",
    ui_instrucoes_gerais_e7875311: "INSTRUCCIONES GENERALES",
    ui_realizacao_898ecc72: "Realización",
    ui_pagina_b3a7f96a: "Página",
    ui_nova_diagramacao_3f8a792f: "Nueva diagramación",
    ui_cadastre_a_primeira_diagramacao_deste_processo_921ee032: "Crea la primera diagramación de este proceso.",
    ui_ao_deletar_esta_diagramacao_ele_nao_estara_mais_di_596f476a: "Al eliminar esta diagramación, ya no estará disponible en el sistema",
    ui_aqui_ficam_as_respostas_da_prova_db6a9721: "Respuestas de la prueba \"",
    ui_ao_desvincular_este_prova_ele_nao_tera_mais_acesso_b74083f3: "Al desvincular esta prueba, ya no tendrá acceso a este proceso",
    ui_edite_uma_diagramacao_de_prova_6fc036bd: "Edita una diagramación de prueba",
    ui_modulo_nao_habilitado_f5792cfe: "Módulo no habilitado",
    ui_visualizar_diagramacao_b0136eb9: "Ver diagramación",
    ui_diagramacao_de_prova_do_aluno_a8bb0ec6: "Diagramación de prueba del alumno",
    ui_nenhum_download_registrado_6211f004: "Ninguna descarga registrada",
    ui_candidatos_da_entrevista_a9e44072: "Candidatos de la entrevista",
    ui_avaliacao_b83b6158: "Evaluación",
    ui_inicio_3ea3dd6c: "Inicio:",
    ui_nenhum_candidato_foi_vinculado_a_entrevista_1a26c285: "Nenhum candidato foi vinculado à entrevista.",
    ui_ao_desvincular_este_entrevista_ele_nao_tera_mais_a_3e116a66: "Al desvincular esta entrevista, ya no tendrá acceso a este proceso",
    ui_horario_de_inicio_701ca30c: "Horario de inicio",
    ui_criterios_5fb45232: "Criterios:",
    ui_cadastrar_entrevista_2914b77a: "Crear entrevista",
    ui_topicos_0e1d8c1b: "Temas",
    ui_remover_topico_e918d570: "Eliminar tema",
    ui_remover_criterio_ae4a7cae: "Eliminar criterio",
    ui_editar_entrevista_19c99dac: "Editar entrevista",
    ui_nenhuma_entrevista_encontrada_3eed3914: "Ninguna entrevista encontrada",
    ui_ao_deletar_esta_entrevista_ele_nao_estara_mais_dis_2a6785b8: "Al eliminar esta entrevista, ya no estará disponible para que los candidatos la respondan",
    ui_topicos_e6378334: "Temas:",
    ui_configure_os_modulos_e_funcionalidades_disponiveis_208f88ed: "Configura los módulos y funcionalidades disponibles para los candidatos",
    ui_configuracoes_salvas_com_sucesso_6f4c5595: "¡Configuraciones guardadas correctamente!",
    ui_ativacao_de_modulos_e_funcionalidades_d3a0ba81: "Activación de módulos y funcionalidades",
    ui_nenhum_modulo_disponivel_018261fe: "Ningún módulo disponible",
    ui_nao_existem_modulos_disponiveis_para_configuracao_43292f9a: "No hay módulos disponibles para configuración.",
    ui_total_candidatos_878e3013: "Total de candidatos",
    ui_candidatos_que_fizeram_login_14f0d12d: "Candidatos que iniciaron sesión",
    ui_candidatos_que_acessaram_a_tela_de_termos_e9f9141c: "Candidatos que accedieron a la pantalla de términos",
    ui_candidatos_que_acessaram_a_tela_de_avaliacao_nao_i_a41a4375: "Candidatos que accedieron a la pantalla de evaluación no iniciada",
    ui_candidatos_que_acessaram_a_tela_de_aceite_de_regra_da5f04ad: "Candidatos que accedieron a la pantalla de aceptación de reglas",
    ui_candidatos_que_acessaram_a_tela_de_avaliacao_em_an_1b4c8a44: "Candidatos que accedieron a la pantalla de evaluación en curso",
    ui_candidatos_que_acessaram_a_tela_de_avaliacao_final_7987b18b: "Candidatos que accedieron a la pantalla de evaluación finalizada",
    ui_candidatos_ausentes_906899d3: "Candidatos ausentes",
    ui_candidatos_que_acessaram_e_nao_finalizaram_fe2f36f7: "Candidatos que accedieron y no finalizaron",
    ui_candidatos_que_acessaram_e_finalizaram_c9793b24: "Candidatos que accedieron y finalizaron",
    ui_descicao_8a9d0ffe: "Descripción:",
    ui_nao_iniciado_79f0570c: "No iniciado",
    ui_opcoes_de_relatorio_b2f110b8: "Opciones de informe:",
    ui_candidatos_avaliadores_online_639e532c: "Candidatos/Evaluadores en línea",
    ui_analises_faciais_5ef2980a: "Análisis faciales",
    ui_analises_objetos_7b70af86: "Análisis de objetos",
    ui_analises_movimento_facial_9f470e32: "Análisis de movimiento facial",
    ui_candidatos_online_por_sala_c4a7fb6b: "Candidatos en línea por sala:",
    ui_candidatos_online_fe6d8bc6: "Candidatos en línea",
    ui_nenhum_avaliador_online_vinculado_a_este_cargo_85e7dc18: "Ningún evaluador en línea vinculado a este cargo",
    ui_nenhum_a_13fdab50: "Ninguno(a)",
    ui_cadastre_a_primeira_para_comecar_6d5dc4dd: "Registra el primero para comenzar.",
    ui_ao_deletar_esta_faculdade_ela_nao_estara_mais_disp_09656d24: "Al eliminar esta institución, ya no estará disponible en el sistema",
    ui_responsavel_dac53a5e: "Responsable:",
    ui_voltar_para_cd10d454: "← Volver a",
    ui_instituicao_criada_em_8e333c6a: "Institución creada el",
    ui_ao_deletar_este_fiscal_ele_nao_estara_mais_disponi_ba3bc4ca: "Al eliminar este fiscal, ya no estará disponible en el sistema",
    ui_nenhum_fiscal_encontrado_com_este_termo_7c6340f3: "Ningún fiscal encontrado con este término",
    ui_nenhum_fiscal_selecionado_b8684c0e: "Ningún fiscal seleccionado",
    ui_ao_desvincular_este_fiscal_ele_nao_tera_mais_acess_05fc2cf3: "Al desvincular este fiscal, ya no tendrá acceso a este proceso",
    ui_nome_e_mail_senha_tipo_fiscal_coordenador_ou_fisca_3df45539: "Nombre; E-mail; Contraseña; Tipo (fiscal_coordinador o fiscal_normal); Salas",
    ui_as_salas_devem_ser_especificadas_entre_ou_seja_se__164c8379: "Las salas deben especificarse separadas por comas. Por ejemplo, para que un fiscal quede en las salas 1, 2 y 3, use: 1,2,3",
    ui_nenhum_fiscal_adicionado_151a84e5: "Ningún fiscal agregado",
    ui_cadastrar_membro_da_equipe_02c4e5d7: "Crear miembro del equipo",
    ui_editar_membro_da_equipe_9c426afb: "Editar miembro del equipo",
    ui_cadastrar_modulo_a9b6ba58: "Crear módulo",
    ui_nenhum_conteudo_encontrado_com_este_termo_a1a14166: "Ningún contenido encontrado con este término",
    ui_conteudos_vinculados_7adf15fe: "Contenidos vinculados",
    ui_salvando_modulo_c5640cd0: "Guardando módulo",
    ui_editar_modulo_cead4a60: "Editar módulo",
    ui_edite_um_modulo_do_seu_sistema_435e4985: "Edita un módulo de tu sistema",
    ui_cadastrar_organizadora_6386ed45: "Crear organizadora",
    ui_dados_do_usuario_549a26c8: "Datos del usuario",
    ui_editar_organizadora_54d2b6d8: "Editar organizadora",
    ui_nenhuma_organizadora_encontrada_f5da8ee0: "Ninguna organizadora encontrada",
    ui_ao_deletar_esta_organizadora_ela_nao_tera_mais_ace_05022d02: "Al eliminar esta organizadora, ya no tendrá acceso al sistema",
    ui_e_suas_regras_9951434d: "e suas regras.",
    ui_a_avaliacao_e_online_63f6668d: "¿La evaluación es en línea?",
    ui_e_um_avaliacao_oral_031e9629: "¿Es una evaluación oral?",
    ui_se_habilitado_esta_vaga_cargo_sera_uma_entrevista__b2e828a7: "Si está habilitado, esta vacante/cargo será una entrevista (evaluación oral) con los candidatos vinculados, donde será posible registrar los criterios de evaluación y quiénes serán los evaluadores. Cada evaluador podrá entrar en llamadas individuales con cada candidato.",
    ui_e_um_simulado_para_teste_de_compatibilidade_dos_ca_be36cb46: "¿Es un simulacro para comprobar la compatibilidad de los candidatos?",
    ui_se_habilitado_essa_vaga_cargo_sera_um_teste_para_o_6222b09d: "Si está habilitado, esta vacante/cargo será una prueba para que los candidatos puedan acceder al sistema y probar funciones como compartir cámara, audio y pantalla. También se generará una prueba de test dentro de la vacante/cargo.",
    ui_cada_avaliacao_tera_um_tempo_maximo_para_fazer_e0de075c: "¿Cada evaluación tendrá un tiempo máximo?",
    ui_se_habilitado_na_hora_de_criar_a_prova_sera_obriga_8f8b7f7f: "Si está habilitado, al crear la prueba será obligatorio definir el tiempo, en minutos, que cada pregunta tendrá para ser respondida. Si no desea tiempo por pregunta, deshabilítelo.",
    ui_o_candidato_podera_solicitar_pausa_durante_a_prova_6d5871fc: "¿El candidato podrá solicitar una pausa durante la prueba?",
    ui_se_habilitado_e_exibilido_um_botao_de_pedir_pausa__a63c10d6: "Si está habilitado, se mostrará un botón de solicitar pausa para el candidato, donde podrá solicitar pausas durante la prueba con una justificación. El fiscal vinculado a la sala del candidato deberá aceptar o negar la pausa solicitada.",
    ui_o_candidato_podera_acessar_por_dispositivos_moveis_f529a234: "¿El candidato podrá acceder desde dispositivos móviles?",
    ui_se_habilitado_a_avaliacao_tambem_podera_ser_realiz_ccf181b9: "Si está habilitado, la evaluación también podrá realizarse en dispositivos móviles, pero algunas funciones no podrán habilitarse: grabación de pantalla y validación facial.",
    ui_disponibilizar_campo_para_rascunho_em_cada_questao_59890895: "¿Disponibilizar campo de borrador en cada pregunta?",
    ui_se_habilitado_em_cada_questao_tera_um_botao_de_ras_29b1be64: "Si está habilitado, cada pregunta tendrá un botón de borrador para el candidato, que abrirá un campo de texto para escribir. El borrador no se guarda en el sistema.",
    ui_obrigar_o_uso_de_tela_cheia_para_ver_a_avaliacao_81575207: "¿Obligar el uso de pantalla completa para ver la evaluación?",
    ui_se_habilitado_o_candidato_so_conseguira_fazer_a_av_c5c6d2f3: "Si está habilitado, el candidato solo podrá realizar la evaluación con el sistema en pantalla completa. Si sale de pantalla completa, el sistema registrará una salida de pantalla.",
    ui_tempo_de_prova_em_minutos_que_o_candidato_tera_apo_f25d6411: "Tiempo de prueba en minutos que tendrá el candidato después del primer acceso",
    ui_tempo_em_minuntos_anterior_a_avaliacao_que_deve_ap_6be44aeb: "Tiempo en minutos antes de la evaluación en que debe aparecer el chat de comunicación con el fiscal",
    ui_exemplo_caso_seja_colocado_60_minutos_entao_uma_ho_3f08b307: "Ejemplo: si se configuran 60 minutos, una hora antes del inicio de la evaluación aparecerá el chat de comunicación donde es posible enviar y recibir mensajes de los fiscales.",
    ui_se_habilitada_o_candidato_so_conseguira_acessar_a__104a32e1: "Si está habilitada, el candidato solo podrá acceder a la prueba si se identifica un rostro (solo uno) en la imagen de su cámara, y deberá mover la cabeza hacia la izquierda y la derecha para validar su entrada. También deberá decir una frase para validar el micrófono.",
    ui_tempo_em_minuntos_anterior_a_avaliacao_que_deve_ap_018422a2: "Tiempo en minutos antes de la evaluación en que debe aparecer al candidato un botón para solicitar liberación al fiscal",
    ui_exemplo_caso_seja_colocado_60_minutos_entao_uma_ho_333a557f: "Ejemplo: si se configuran 60 minutos, una hora antes del inicio de la evaluación aparecerá un botón para que el candidato solicite liberación al fiscal si no logra completar la validación facial.",
    ui_se_habilitada_caso_apos_o_candidato_acessar_a_aval_76209b26: "Si está habilitada, si después de que el candidato accede a la evaluación no se detecta un rostro en la cámara o una oscilación de audio en el micrófono durante cierto tiempo, el candidato deberá realizar la validación nuevamente (solo si no fue liberado por el fiscal).",
    ui_tempo_sem_reconhecimento_para_o_candidato_ter_que__36fb327b: "Tiempo sin reconocimiento para que el candidato tenga que realizar la validación facial nuevamente (en segundos)",
    ui_restringir_horario_de_acesso_do_candidato_ff671aed: "¿Restringir horario de acceso del candidato?",
    ui_candidatos_que_nao_tiverem_acessado_o_sistema_dent_db3aa123: "Los candidatos que no hayan accedido al sistema dentro de un horario determinado no podrán acceder a la prueba",
    ui_horario_inicial_do_intervalo_dbb8ab8c: "Horario inicial del intervalo",
    ui_data_de_encerramento_do_intervalo_ca148297: "Fecha de finalización del intervalo",
    ui_o_evento_sera_dividido_em_blocos_d2406ebe: "¿El evento se dividirá en bloques?",
    ui_caso_sim_e_possivel_definir_o_tempo_de_cada_bloco__e1f7d3b8: "Si es así, es posible definir el tiempo de cada bloque y un tiempo de intervalo.",
    ui_ao_deletar_este_processo_ele_nao_estara_mais_dispo_d822045c: "Al eliminar este proceso, ya no estará disponible en el sistema",
    ui_ao_deletar_este_elaborador_ele_nao_tera_mais_acess_c6438fc1: "Al eliminar este elaborador, ya no tendrá acceso al sistema",
    ui_cadastrar_prova_05e853e9: "Crear prueba",
    ui_configuracoes_adicionais_0d9c9733: "Configuraciones adicionales",
    ui_ordem_das_questoes_d3f085f2: "Orden de las preguntas",
    ui_selecao_das_questoes_c85b2f2d: "Selección de preguntas",
    ui_forma_de_aleatorizacao_499ad86d: "Forma de aleatorización",
    ui_numero_de_questoes_que_devem_ser_selecionadas_c940b4a7: "Número de preguntas que deben seleccionarse",
    ui_numero_de_questoes_que_devem_ser_selecionadas_def12a81: "Número de preguntas que deben seleccionarse:",
    ui_exibicao_das_questoes_8463a65b: "Visualización de las preguntas",
    ui_definir_um_numero_maximo_de_provas_aleatorias_gera_78fd6056: "¿Definir un número máximo de pruebas aleatorias generadas?",
    ui_numero_de_provas_geradas_5c4213f8: "Número de pruebas generadas:",
    ui_numero_de_provas_que_vao_ser_geradas_ebe3dc3e: "Número de pruebas que se generarán",
    ui_o_candidato_podera_retornar_para_a_questao_anterio_9d388b4d: "¿El candidato podrá volver a la pregunta anterior después de avanzar a la siguiente?",
    form_auto_advance_on_answer_question: "Al responder, ¿avanzar automáticamente a la siguiente pregunta?",
    form_auto_advance_on_answer_yes: "Sí, avanzar y bloquear cambios en la respuesta",
    form_auto_advance_on_answer_no: "No, mantener al candidato en la pregunta actual",
    form_show_answer_map_question: "¿Mostrar mapa de respuestas durante la prueba?",
    description_show_answer_map: "Si está desactivado, el candidato no verá el resumen de preguntas respondidas encima de la pregunta actual.",
    form_finished_result_visibility: "Al finalizar la prueba, mostrar",
    form_finished_result_answer_sheet: "Hoja de respuestas del candidato",
    form_finished_result_accuracy_sheet: "Relación de aciertos y errores",
    form_finished_result_answer_and_accuracy: "Hoja de respuestas con relación de aciertos y errores",
    form_finished_result_exam_booklet: "Cuaderno de prueba",
    form_finished_result_exam_booklet_correct: "Cuaderno de prueba con plantilla de respuestas",
    form_finished_result_exam_booklet_candidate: "Cuaderno de prueba con plantilla y respuestas del candidato",
    form_allow_download_answer_and_accuracy_sheet: "Descargar hoja de respuestas con aciertos y errores",
    form_finished_result_none: "Ninguna de las opciones",
    form_finished_result_mirror: "Cuaderno de prueba",
    description_finished_result_mirror: "Muestra el espejo del cuaderno con preguntas, alternativas y las reglas de acierto configuradas.",
    form_finished_result_period: "Periodo de visualización para el candidato",
    description_finished_result_period: "Déjalo vacío para mostrarlo inmediatamente y sin fecha final.",
    form_finished_result_downloads: "Permitir descarga",
    form_allow_download_answer_sheet: "Descargar hoja de respuestas",
    form_allow_download_accuracy_sheet: "Descargar relación de aciertos y errores",
    form_allow_download_mirror: "Descargar cuaderno de prueba",
    legacy_prova_dissertativa: "Prueba dissertativa",
    exam_options_summary_eyebrow: "Configuraciones",
    exam_options_summary_title: "Opciones seleccionadas al crear la prueba",
    exam_options_summary_description: "Resumen de las reglas de visualización, organización, resultado y descargas configuradas para esta prueba.",
    exam_options_basic: "Datos de la prueba",
    exam_options_randomization: "Organización de preguntas",
    exam_options_candidate_view: "Vista del candidato",
    exam_options_one_question: "Una pregunta por vez",
    exam_options_all_questions: "Todas las preguntas",
    exam_options_exam_time: "Tiempo de prueba",
    exam_options_use_exam_models: "Usar modelos de prueba",
    exam_options_exam_models_count: "Número de modelos",
    exam_options_shuffle_questions: "Aleatorizar preguntas",
    exam_options_shuffle_alternatives: "Aleatorizar alternativas",
    exam_options_select_from_group: "Seleccionar por grupo",
    exam_options_random_by_subject: "Sorteo por disciplina",
    exam_options_block_return_after_pause: "Bloquear retorno después de pausa",
    exam_options_immediate_display: "Visualización inmediata, sin fecha final",
    exam_options_no_downloads: "Ninguna descarga habilitada para esta opción",
    ui_bloquear_de_alterar_respostas_de_questoes_ja_vista_aaa83af2: "¿Bloquear la modificación de respuestas de preguntas ya vistas después de una solicitud de pausa?",
    ui_tempo_por_questao_em_minutos_5407240a: "Tiempo por pregunta en minutos",
    ui_tempo_por_questao_eaffb704: "Tiempo por pregunta",
    ui_selecionar_todas_as_questoes_desta_disciplina_7d72b315: "Seleccionar todas las preguntas de esta disciplina",
    ui_selecionar_questoes_por_palavra_chave_76d0ed50: "Seleccionar preguntas por palabra clave",
    ui_nenhuma_questao_encontrada_com_este_termo_69f1b489: "Ninguna pregunta encontrada con este término",
    ui_editar_prova_097be7e1: "Editar prueba",
    ui_bloquear_de_alterar_respostas_de_questoes_ja_vista_cb647283: "¿Bloquear la modificación de respuestas de preguntas ya vistas después de una solicitud de pausa?",
    ui_buscar_questoes_da_disciplina_93831202: "Buscar preguntas de la disciplina",
    ui_salvando_questoes_187c0279: "Guardando preguntas",
    ui_gerencie_as_provas_vinculadas_ao_processo_5ce1abb6: "Gestiona las pruebas vinculadas al proceso",
    ui_ao_deletar_esta_prova_ele_nao_estara_mais_disponiv_7c8cffac: "Al eliminar esta prueba, ya no estará disponible para que los candidatos la respondan",
    ui_aqui_ficam_as_questoes_da_prova_62cf730a: "Preguntas de la prueba \"",
    ui_cadastrar_questionario_c27e40cd: "Crear cuestionario",
    ui_cadastre_um_novo_questionario_no_sistema_9b7d9485: "Crea un nuevo cuestionario en el sistema",
    ui_ver_questionario_08339686: "Ver cuestionario",
    ui_salvando_questionario_446add5a: "Guardando cuestionario",
    ui_edite_um_questionario_do_sistema_9c25790b: "Edita un cuestionario del sistema",
    ui_cadastrar_pergunta_do_questionario_21b5431b: "Crear pregunta del cuestionario",
    ui_paragrafo_1c4bc2b2: "Párrafo",
    ui_nao_e_obrigatorio_4b5bab2b: "No es obligatorio",
    ui_obrigatorio_se_assinalado_59d615fd: "Obligatorio si está marcado \"",
    ui_gerenciar_questionario_4cf424e3: "Gestionar cuestionario",
    ui_deletar_questionario_44d0f59c: "Eliminar cuestionario",
    ui_ao_deletar_este_questionario_ela_nao_estara_mais_d_523483a1: "Al eliminar este cuestionario, ya no estará disponible en el sistema",
    ui_vincular_questionario_s_0c995c4c: "Vincular cuestionario(s)",
    ui_vincule_um_ou_mais_questionarios_ao_processo_a186a3eb: "Vincula uno o más cuestionarios al proceso",
    ui_onde_o_questionario_ira_aparecer_be82f196: "¿Dónde aparecerá el cuestionario?",
    ui_pesquise_o_questionario_pelo_nome_ab3d430c: "Busca el cuestionario por nombre",
    ui_nenhum_questionario_encontrado_com_este_termo_a4b1cd9f: "Ningún cuestionario encontrado con este término",
    ui_questionarios_selecionados_6a604e81: "Cuestionarios seleccionados",
    ui_desvincular_questionario_ac6d9747: "Desvincular cuestionario",
    ui_nenhum_questionario_selecionado_d6a1afb8: "Ningún cuestionario seleccionado",
    ui_salvando_questionarios_0ee57d98: "Guardando cuestionarios",
    ui_gerencie_os_questionarios_vinculados_ao_processo_10b384f8: "Gestiona los cuestionarios vinculados al proceso",
    ui_adicionar_questionarios_2a88af71: "Agregar cuestionarios",
    ui_vincule_o_primeiro_questionario_ao_processo_958376ac: "Vincula el primer cuestionario al proceso.",
    ui_ao_desvincular_este_questionario_ele_nao_estara_ma_574217ce: "Al desvincular este cuestionario, ya no estará disponible en este proceso",
    ui_aqui_ficam_as_respostas_do_questionario_1755792c: "Respuestas del cuestionario \"",
    ui_aqui_ficam_as_questoes_do_questionario_264de9be: "Preguntas del cuestionario \"",
    ui_aqui_ficam_as_atribuicoes_da_demanda_25de260e: "Asignaciones de la demanda \"",
    ui_gerenciar_atribuicao_224a10c0: "Gestionar asignación",
    ui_deletar_atribuicao_ae0a77d8: "Eliminar asignación",
    ui_ao_deletar_esta_atribuicao_o_elaborador_nao_tera_m_55bce2dd: "Al eliminar esta asignación, el elaborador ya no tendrá acceso a esta categoría/demanda",
    ui_questao_avaliada_com_sucesso_55663755: "¡Pregunta evaluada correctamente!",
    ui_carregando_comentarios_c260c035: "Cargando comentarios...",
    ui_escreva_seu_comentario_aqui_c2486f14: "Escribe tu comentario aquí...",
    ui_enviar_avaliacao_629e5d59: "Enviar evaluación",
    ui_adicione_edite_atribuicoes_a_demanda_d174b85f: "Agrega/Edita asignaciones a la demanda \"",
    ui_numero_de_questoes_2fb10acf: "Número de preguntas:",
    ui_cadastre_um_recurso_de_uma_questao_do_seu_sistema_62fc3a72: "Registra un recurso para una pregunta de tu sistema",
    ui_busque_a_questao_da_disciplina_55512db0: "Busca la pregunta de la disciplina",
    ui_nome_do_responsavel_df1f0fe8: "Nombre del responsable:",
    ui_e_mail_do_responsavel_6f9ed412: "E-mail del responsable:",
    ui_edite_um_recurso_de_uma_questao_do_seu_sistema_4692e136: "Edita un recurso para una pregunta de tu sistema",
    ui_nao_especificar_ddfc6e39: "No especificar",
    ui_ao_deletar_este_recurso_ela_nao_estara_mais_dispon_0ccc7650: "Al eliminar este recurso, ya no estará disponible en el sistema",
    ui_avaliacao_de_questao_27fd4ee1: "Evaluación de pregunta",
    ui_dados_da_questao_e4f73f31: "Datos de la pregunta",
    ui_data_de_criacao_b8ae5b5f: "Fecha de creación:",
    ui_demanda_relacionada_e62c1518: "Demanda relacionada:",
    ui_o_campo_comentario_e_obrigatorio_2d86054e: "El campo Comentario es obligatorio",
    ui_caso_a_questao_tenha_sido_editada_ela_so_sera_salv_2b9818fb: "Si la pregunta fue editada, solo se guardará al enviar la evaluación.",
    ui_descricao_dos_fatos_e3186d0b: "Descripción de los hechos:",
    ui_cadastre_as_redacoes_cd8d699e: "Registra las redacciones",
    ui_salvando_redacao_2875125c: "Guardando redacción",
    ui_edite_uma_redacao_f80c5cfb: "Edita una redacción",
    ui_gerencie_as_redacoes_vinculadas_ao_processo_9e0682a4: "Gestiona las redacciones vinculadas al proceso",
    ui_nova_redacao_f7f8f71a: "Nueva redacción",
    ui_cadastre_a_primeira_redacao_deste_processo_7b43c0f0: "Crea la primera redacción de este proceso.",
    ui_ao_deletar_esta_redacao_ele_nao_estara_mais_dispon_1440dab3: "Al eliminar esta redacción, ya no estará disponible para que los candidatos la respondan",
    ui_todas_as_redacoes_devem_estar_no_formato_png_ou_jp_48fe5b0b: "Todas las redacciones deben estar en formato .png o .jpg, con el número de inscripción como nombre de la imagen, y todas compactadas en un archivo .zip/.rar que puede seleccionarse abajo.",
    ui_salvando_redacoes_0ec9631b: "Guardando redacciones",
    ui_aqui_ficam_as_respostas_da_redacao_d8e417d4: "Respuestas de la redacción \"",
    ui_ao_desvincular_este_redacao_ele_nao_tera_mais_aces_ea522608: "Al desvincular esta redacción, ya no tendrá acceso a este proceso",
    ui_aqui_ficam_as_correcoes_da_redacao_1feaced4: "Correcciones de la redacción \"",
    ui_realizadas_por_inteligencia_artificial_e9b909ee: "\" realizadas por inteligencia artificial",
    ui_ir_para_progresso_da_correcao_94b462b0: "Ir al progreso de la corrección",
    ui_imprimir_template_da_redacao_42731392: "Imprimir plantilla de redacción",
    ui_aqui_ficam_os_textos_de_apoio_da_redacao_f7a787bd: "Textos de apoyo de la redacción \"",
    ui_ao_desvincular_este_texto_ele_nao_tera_mais_acesso_0fb3b0af: "Al desvincular este texto, ya no tendrá acceso a los textos de este proceso",
    ui_baixe_relatorios_gerais_d7ab5b34: "Descargar informes generales",
    ui_candidatos_62b9af6b: "candidatos",
    ui_nenhuma_sala_foi_vinculada_a_este_processo_cc8c090a: "Ninguna sala fue vinculada a este proceso.",
    ui_ao_desvincular_este_sala_ele_nao_tera_mais_acesso__15f445ac: "Al desvincular esta sala, ya no tendrá acceso a las salas de este proceso",
    ui_aqui_ficam_os_candidatos_da_sala_609742e7: "Candidatos de la sala \"",
    ui_aqui_ficam_os_fiscais_da_sala_b90de17f: "Fiscales de la sala \"",
    ui_aqui_ficam_os_corretores_da_sala_2997b757: "Correctores de la sala \"",
    ui_cadastrar_treinamento_4f504c6b: "Crear capacitación",
    ui_nenhum_modulo_encontrado_com_este_termo_40aad181: "Ningún módulo encontrado con este término",
    ui_nenhum_usuario_encontrado_07e706e0: "Ningún usuario encontrado.",
    ui_editar_treinamento_2a8da4ce: "Editar capacitación",
    ui_editar_treinamento_modulos_e4254df3: "Editar capacitación/módulos",
    ui_nenhum_modulo_cadastrado_f4cff322: "Ningún módulo registrado",
    ui_nenhum_treinamento_cadastrado_1114c17b: "Ninguna capacitación registrada",
    ui_periodo_9d2b2bb8: "Período",
    ui_nenhum_treinamento_encontrado_327ab048: "Ninguna capacitación encontrada",
    ui_aqui_estao_listados_todos_os_treinamentos_do_seu_s_066f2573: "Aquí se listan todas las capacitaciones de tu sistema",
    ui_nenhum_treinamento_encontrado_com_este_termo_01f25665: "Ninguna capacitación encontrada con este término",
    ui_videos_da_tela_6e150a3a: "Videos de pantalla",
    ui_gerenciar_candidatos_a4e149c2: "Gestionar candidatos",
    ui_acessar_configuracoes_e95ce866: "Acceder a configuraciones",
    ui_gerencie_avaliadores_00986d21: "Gestiona evaluadores",
    ui_avaliacao_oral_f015a022: "Evaluación oral",
    ui_configuracoes_da_avaliacao_oral_f1c2d588: "Configuraciones de evaluación oral",
    ui_antes_de_iniciar_a_avaliacao_1026e291: "Antes de iniciar la evaluación",
    ui_durante_a_avaliacao_b2e19d2f: "Durante la evaluación",
    ui_apos_finalizada_a_avaliacao_4f08017f: "Después de finalizar la evaluación",
    ui_acompanhe_os_resultados_do_questionario_b2346d60: "Sigue los resultados del cuestionario.",
    ui_lista_os_candidatos_que_acessaram_a_plataforma_2258f573: "Lista los candidatos que accedieron a la plataforma.",
    ui_lista_quem_concedeu_permissoes_e_chegou_na_tela_de_47155e81: "Lista quienes concedieron permisos y llegaron a la pantalla de evaluacion no iniciada.",
  },
};

export const getLanguageText = (selectedLanguage, key) => {
  const lang = selectedLanguage || 'pt';
  return language[lang]?.[key] || language.pt?.[key] || key;
};
